// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/security/checkarrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Withdraw page — popup styles (moved from global style.css) */

/* Coin thumbnails (Select coin + modal list + quick pick) */
.withdraw-coin-thumb__img {
  border-radius: 999px;
  object-fit: cover;
  display: block;
  background: #e2e8f0;
}

.withdraw-coin-thumb__placeholder {
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.02em;
  background: linear-gradient(140deg, #94a3b8, #64748b);
  color: #f8fafc;
  line-height: 1;
  -webkit-user-select: none;
          user-select: none;
}

body:not(.light_theme) .withdraw-coin-thumb__img {
  background: #334155;
}

/* —— Stepper rail: match deposit (clamp to last step badge) —— */
.deposit_crypto_left {
  position: relative;
}

.withdraw-stepper-rail.deposit-stepper-rail {
  position: absolute;
  left: 14px;
  top: var(--rail-top, 0px);
  height: var(--rail-height, 0px);
  width: 2px;
  background: rgba(148, 163, 184, 0.28);
  border-radius: 999px;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
}

.withdraw-stepper-rail .deposit-stepper-rail__fill {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: var(--rail-fill, 0px);
  background: #fff;
  border-radius: 999px;
  transition: height 220ms ease;
}

body.light_theme .withdraw-stepper-rail .deposit-stepper-rail__fill {
  background: #0b0b0b;
}

/* Inline field errors */
.withdraw_inline_error {
  margin-top: 6px;
  font-size: 12px;
  color: #f04438;
  font-weight: 600;
  line-height: 1.25;
}

.withdraw_inline_loader {
  margin-top: 6px;
  font-size: 12px;
  color: #6b7280;
  font-weight: 600;
  line-height: 1.25;
}

.withdraw_amt_meta_value {
  font-weight: 600;
}

.kycemail-phone_popup .withdraw_confirm_overlay.withdraw_sec_overlay .withdraw_sec_list {
  gap: 12px;
}

body:not(.light_theme) .withdraw_inline_error {
  color: #f04438;
}

body:not(.light_theme) .withdraw_inline_loader {
  color: #9ca3af;
}

/* Danger input border when invalid */
.withdraw_amt_field input[aria-invalid="true"],
.user_address_fill .addressfill input[aria-invalid="true"] {
  border-color: #f04438 !important;
  box-shadow: none !important;
  background: none;
}

body:not(.light_theme) .withdraw_amt_field input[aria-invalid="true"],
body:not(.light_theme) .user_address_fill .addressfill input[aria-invalid="true"] {
  border-color: #f04438 !important;
  box-shadow: none !important;
}

/* Outer wrapper border on error (match screenshot) */
.withdraw_amt_field.has-error,
.user_address_fill.has-error {
  border-color: #f04438 !important;
}

/* 24h limit: remaining / cap with danger cap + tooltip */
.withdraw_amt_nums {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.withdraw_limit_left {
  color: inherit;
  font-weight: 600;
}

.withdraw_limit_sep {
  opacity: 0.7;
}

.withdraw_limit_right {
  color: #f04438;
  font-weight: 700;
}

.withdraw_limit_info_wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.withdraw_limit_info_btn {
  width: 16px;
  height: 16px;
  border-radius: 999px;
  border: 1px solid rgba(152, 162, 179, 0.7);
  background: transparent;
  color: #667085;
  font-size: 11px;
  line-height: 1;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;
}

.withdraw_limit_tooltip {
  position: absolute;
  right: 0;
  top: calc(100% + 10px);
  min-width: 260px;
  max-width: 320px;
  background: #3a3a3a;
  color: #fff;
  border-radius: 10px;
  padding: 10px 12px;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.25);
  z-index: 20;
}

.withdraw_limit_tip_text {
  font-size: 12px;
  line-height: 1.35;
  color: rgba(255, 255, 255, 0.92);
  font-weight: 500;
}

.withdraw_limit_tip_link {
  margin-top: 8px;
  background: transparent;
  border: none;
  padding: 0;
  color: #fbbf24;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  text-align: left;
}

/* Disabled icon links in history details */
.withdraw_hist_icon_link.is-disabled {
  opacity: 0.45;
  pointer-events: none;
}

/* Min withdraw hint under amount input */
.withdraw_min_hint {
  margin-top: 6px;
  font-size: 12px;
  color: #94a3b8;
  line-height: 1.3;
}

body.light_theme .withdraw_min_hint {
  color: #667085;
}

body:not(.light_theme) .withdraw_min_hint strong {
  color: #e2e8f0;
}

/* Selected coin highlight (quick pick + modal list) */
.coin_items_list.is-selected {
  /* background: #064e3b;
  border: 1px solid rgba(52, 211, 153, 0.9);
  color: #a7f3d0; */
}

/* body.light_theme .coin_items_list.is-selected {
  border: 1px solid #9aa1af;
} */

/* Modal row selection */
.modal.search_coin tr.is-selected td {
  background: none;
}

.modal.search_coin tr.is-selected {
  background: rgb(43 47 58 / 18%);
  border: none;
}

body.light_theme .modal.search_coin tr.is-selected {
  background: rgb(43 47 58);
}

/* Shared overlay */
.withdraw_confirm_overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.20);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  z-index: 99999999;
}

body.light_theme .withdraw_confirm_overlay {
  background-color: rgb(255 255 255 / 20%);
}

/* Passkey must sit above other withdraw overlays and security_verification_unavailable
   (.withdraw_sec_overlay is 100000020). The :has() rule is more specific than a single class,
   so this value must stay above that overlay or Verify with Passkey never appears. */
.withdraw_confirm_overlay:has(.withdraw_passkey_modal) {
  z-index: 100000030;
}

/* Shared close button */
.withdraw_confirm_close {
  position: absolute;
  top: 14px;
  right: 16px;
  z-index: 10;
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  color: #e7e7e7;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
  border-radius: 10px;
  pointer-events: auto;
}

body.light_theme .withdraw_confirm_close {
  color: #111827;
}

/* .withdraw_confirm_close:hover {
  background: rgba(17, 24, 39, 0.05);
} */

/* 1) Network warning popup */
.withdraw_confirm_modal {
  width: 489px;
  max-width: 92vw;
  border-radius: 18px;
  padding: 30px;
  position: relative;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: #1a1a1a69;
}

body.light_theme .withdraw_confirm_modal {
  background: rgb(255 255 255 / 20%);
  border: 1px solid #e1e1e1;
}

.withdraw_confirm_icon {
  display: flex;
  justify-content: center;
  margin: 6px 0 14px;
}

.withdraw_confirm_envelope {
  max-width: 120px;
  margin-top: -20px;
}

.withdraw_confirm_text {
  max-width: 100%;
  margin: 0 auto;
  text-align: left;
  font-size: 15px;
  line-height: 1.65;
  color: #d8d8d8;
  font-weight: 500;
}

body.light_theme .withdraw_confirm_text {
  color: #101828;
}

.withdraw_ab_delete_confirm_title {
  font-size: 20px;
  font-weight: 600;
  color: #111827;
  margin: 0 40px 10px 0;
  line-height: 1.3;
}

.withdraw_confirm_actions {
  display: flex;
  gap: 9px;
  justify-content: center;
  margin-top: 22px;
}

.withdraw_confirm_btn {
  min-width: auto;
  height: 46px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  padding: 0 20px;
}

.withdraw_confirm_btn--ghost {
  background: #e5e7eb;
  color: #374151;
  width: 130px;
}

.withdraw_confirm_btn--primary {
  width: 100%;
  background: #2f3138;
  color: #fff;
}

.withdraw_verify_reminder_modal .withdraw_verify_reminder_title {
  font-size: 22px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 36px 14px 0;
  line-height: 1.25;
  letter-spacing: -0.02em;
}

body.light_theme .withdraw_verify_reminder_modal .withdraw_verify_reminder_title {
  color: #111827;
}

.withdraw_verify_reminder_text {
  margin: 0;
  font-size: 15px;
  line-height: 1.65;
  color: #374151;
  font-weight: 500;
}

@media (max-width: 520px) {
  .withdraw_confirm_modal {
    padding: 20px 18px 18px;
    border-radius: 16px;
  }

  .withdraw_confirm_actions {
    flex-direction: column;
    gap: 12px;
  }

  .withdraw_confirm_btn {
    width: 100%;
    min-width: 0;
  }
}

/* 2) Withdrawal summary popup */
.withdraw_summary_modal {
  width: 606px;
  max-width: 92vw;
  border-radius: 18px;
  border: 1px solid #e1e1e121;
  background: #1a1a1a69;
  padding: 30px;
  position: relative;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.18);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

body.light_theme .withdraw_summary_modal {
  border: 1px solid #e1e1e1;
  background: rgb(255 255 255 / 20%);
}

.withdraw_summary_title {
  font-size: 24px;
  font-weight: 600;
  color: #e2e2e2;
  margin-bottom: 12px;
}

body.light_theme .withdraw_summary_title {
  color: #111827;
}

.withdraw_summary_grid {
  width: 100%;
}

.withdraw_summary_row {
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 16px;
  padding: 10px 0;
}

.withdraw_summary_k {
  color: #f8f8f8;
  font-size: 16px;
  font-weight: 500;
}

body.light_theme .withdraw_summary_k {
  color: #000;
}

body.light_theme .withdraw_summary_v {
  color: #303236;
}

.withdraw_summary_v {
  color: #dfdfdf;
  font-size: 16px;
  font-weight: 500;
  text-align: right;
  word-break: break-all;
}

.withdraw_summary_notes {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid #e7e7e7;
}

body.light_theme .withdraw_summary_note {
  color: #6a7282;
}

.withdraw_summary_note {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  color: #e1e1e1;
  font-size: 13px;
  line-height: 1.5;
  padding: 6px 0;
}

.withdraw_summary_continue {
  width: 100%;
  margin-top: 22px;
  border-radius: 999px;
  border: none;
  padding: 13px 15px;
  background: #303236;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.withdraw_summary_continue:hover {
  background: #24262c;
}

@media (max-width: 767px) {
  .withdraw_summary_modal {
    padding: 20px 20px 32px;
    border-radius: 16px 16px 0px 0px;
    max-width: 100%;
  }

  .withdraw_summary_title {
    font-size: 20px;
  }

  .withdraw_summary_row {
    grid-template-columns: 100px 1fr;
  }

  .withdraw_summary_k,
  .withdraw_summary_v {
    font-size: 13px;
  }

}

/* 3) Verify with passkey popup */
.withdraw_passkey_modal {
  width: 606px;
  max-width: 100%;
  border-radius: 18px;
  padding: 24px 26px 0;
  position: relative;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.18);
  background: #1e202670;
  border: 1px solid #e1e1e11a;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

body.light_theme .withdraw_passkey_modal {
  background: rgb(255 255 255 / 20%);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);
  border: 1px solid #e1e1e1;
}

.withdraw_passkey_title {
  font-size: 24px;
  font-weight: 600;
  color: #dedede;
  margin-bottom: 14px;
}

body.light_theme .withdraw_passkey_title {
  color: #101828;
}

.withdraw_passkey_hero {
  display: flex;
  justify-content: center;
  margin: 30px auto;
  max-width: 180px;
  margin-bottom: 40px;
}

.withdraw_passkey_hero img {
  max-width: 260px;
  width: 100%;
  height: auto;
  display: block;
}

.withdraw_passkey_text {
  font-size: 18px;
  color: #d8d8d8;
  font-weight: 500;
  margin: 10px 0 6px;
  letter-spacing: -0.5px;
}

.withdraw_passkey_subtext {
  font-size: 16px;
  color: #d7d7d7;
  font-weight: 400;
  letter-spacing: -0.5px;
  margin: 7px 0px 20px;
}

body.light_theme .withdraw_passkey_subtext {
  color: #343434;
}

body.light_theme .withdraw_passkey_text {
  color: #6A7282;
}

.withdraw_passkey_verify {
  width: 100%;
  /* height: 54px; */
  border-radius: 999px;
  padding: 13px 15px;
  border: none;
  background: #303236;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.withdraw_passkey_link {
  display: block;
  width: -moz-fit-content;
  width: fit-content;
  margin: 24px auto 30px;
  border: none;
  background: none;
  letter-spacing: -0.5px;
  color: #AC8A50;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}

.withdraw_passkey_footer {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding: 20px 0;
  text-align: center;
  font-weight: 500;
  color: #9ca3af;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

body.light_theme .withdraw_passkey_footer {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.withdraw_passkey_footer img {
  width: 18px;
  height: 18px;
  display: block;
  object-fit: contain;
  flex-shrink: 0;
}

@media (max-width: 520px) {
  .withdraw_passkey_modal {
    padding: 18px 18px 0;
  }

  .withdraw_passkey_title {
    font-size: 20px;
  }

  .withdraw_passkey_text {
    font-size: 15px;
  }
}

/* 4) Authenticator App Verification popup */
.withdraw_auth_modal {
  width: 539px;
  max-width: 100%;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  padding: 24px 26px 0;
  position: relative;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.50);
  background: #181a2087;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

body.light_theme .withdraw_auth_modal {
  border: 1px solid #e1e1e1;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.80);
  background: rgb(255 255 255 / 20%);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

.withdraw_facial_left img {
  filter: invert(1);
}

body.light_theme .withdraw_facial_left img {
  filter: invert(0);
}

.withdraw_facial_item i {
  color: #ffffff;
}

body.light_theme .withdraw_facial_item i {
  color: #101828;
}

.withdraw_auth_title {
  font-size: 24px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 10px;
}

body.light_theme .withdraw_auth_title {
  color: #101828;
}

.withdraw_auth_subtitle {
  font-size: 16px;
  color: #d1d1d1;
  font-weight: 500;
  letter-spacing: -0.5px;
  line-height: 1.45;
  margin-bottom: 18px;
}

body.light_theme .withdraw_auth_subtitle {
  color: #6A7282;
}

.withdraw_auth_label {
  font-size: 14px;
  font-weight: 500;
  color: #9ca3af;
  margin: 11px 0px 7px;
}

body.light_theme .withdraw_auth_label {
  color: #303236;
}

.withdraw_auth_input_row {
  width: 100%;
  position: relative;
}

.withdraw_auth_input_row input {
  width: 100%;
  height: 50px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
  padding: 0 84px 0 14px;
  font-size: 14px;
  color: #ffffff;
  outline: none;
  box-sizing: border-box;
}

body.light_theme .withdraw_auth_input_row input {
  border: 1px solid #E4E4E4;
  background: #fff;
  color: #303236;
}

.withdraw_auth_paste {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: none;
  color: #AC8A50;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.withdraw_fund_password_toggle {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: none;
  padding: 4px;
  color: #9ca3af;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  line-height: 1;
}

body.light_theme .withdraw_fund_password_toggle {
  color: #6a7282;
}

.withdraw_fund_password_toggle:hover {
  color: #ffffff;
}

body.light_theme .withdraw_fund_password_toggle:hover {
  color: #303236;
}

.withdraw_auth_submit {
  width: 100%;
  border-radius: 999px;
  padding: 13px 15px;
  border: none;
  background: #303236;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 30px;
}

.withdraw_auth_link {
  display: block;
  width: -moz-fit-content;
  width: fit-content;
  margin: 32px auto 0px;
  border: none;
  background: none;
  letter-spacing: -0.5px;
  color: #AC8A50;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}

.withdraw_auth_link+.withdraw_auth_link {
  margin-top: 0px;
}

.gapbtn_space {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.withdraw_auth_footer {
  margin-top: 22px;
}

@media (max-width: 767px) {

  .withdraw_auth_modal {
    padding: 18px 18px 0;
    border-radius: 16px 16px 0px 0px;
  }

  .withdraw_auth_submit {
    margin-top: 20px;
  }

  .withdraw_auth_title {
    font-size: 20px;
    width: 90%;
  }

  .withdraw_auth_subtitle {
    font-size: 14px;
  }

  .withdraw_auth_label {
    font-size: 14px;
  }


  .withdraw_auth_link {
    margin: 18px auto 0px;
    font-size: 15px;
  }

}

/* 5) Choose an Authenticator popup */
.withdraw_choose_modal {
  width: 539px;
  max-width: 100%;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 18px 22px 22px;
  position: relative;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.50);
  background: #181a2087;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  min-height: 520px;
}

body.light_theme .withdraw_choose_modal {
  background: rgb(255 255 255 / 20%);
  border: 1px solid #e1e1e1;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.18);
}

/* 6) Email Verification popup */
.withdraw_email_modal {
  width: 539px;
  max-width: 100%;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 24px 26px 0;
  position: relative;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.50);
  background: #181a2087;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

body.light_theme .withdraw_email_modal {
  border: 1px solid #e1e1e1;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.18);
  background: rgb(255 255 255 / 20%);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

/* 7) Awaiting Approval popup */
.withdraw_await_modal {
  width: 606px;
  max-width: 92vw;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 24px 26px 26px;
  position: relative;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.50);
  background: #181a2087;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  text-align: center;
}

body.light_theme .withdraw_await_modal {
  border: 1px solid #e1e1e1;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.18);
  background: rgb(255 255 255 / 20%);
}

/* 8) Recipient Amount popup */
.withdraw_recipient_modal {
  width: 606px;
  max-width: 92vw;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 28px 30px 24px;
  position: relative;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.50);
  background: #181a2087;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  text-align: center;
}

body.light_theme .withdraw_recipient_modal {
  border: 1px solid #e1e1e1;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.18);
  background: rgb(255 255 255 / 20%);
}

.withdraw_recipient_icon {
  display: flex;
  justify-content: center;
  margin: 10px 0 14px;
}

.withdraw_recipient_check {
  width: 78px;
  height: 78px;
  border-radius: 999px;
  background: #00BC7D;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 34px;
  font-weight: 700;
  box-shadow: 0 12px 20px rgb(0 0 0 / 12%);
}

.withdraw_recipient_title {
  font-size: 24px;
  font-weight: 600;
  color: #ffffff;
  margin: 10px 0px 10px;
}

body.light_theme .withdraw_recipient_title {
  color: #101828;
}

.withdraw_coin_hd {
  font-size: 30px;
  font-weight: 600;
  color: #ffffff;
  margin: -6px 0px 0px;
}

body.light_theme .withdraw_coin_hd {
  color: #101828;
}

.withdraw_recipient_amt {
  font-size: 40px;
  font-weight: 600;
  color: #ffffff;
  letter-spacing: -0.6px;
  margin-bottom: 12px;
}

body.light_theme .withdraw_recipient_amt {
  color: #303236;
}

.withdraw_recipient_note {
  font-size: 17px;
  color: #cacaca;
  font-weight: 400;
  margin-bottom: 18px;
}

body.light_theme .withdraw_recipient_note {
  color: #6A7282;
}

.withdraw_recipient_grid {
  text-align: left;
  margin-top: 8px;
}

.withdraw_recipient_row {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 16px;
  padding: 10px 0;
}

.withdraw_recipient_k {
  color: #838996;
  font-size: 16px;
  font-weight: 500;
}

.withdraw_recipient_v {
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  text-align: right;
}

body.light_theme .withdraw_recipient_v {
  color: #303236;
}

.withdraw_recipient_v--addr {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  color: #AC8A50;
}

.withdraw_recipient_addr_icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  color: #6A7282;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  flex-shrink: 0;
}

.withdraw_recipient_addr_icon img {
  width: 20px;
  height: 20px;
  display: block;
}

.withdraw_recipient_actions {
  display: grid;
  /* grid-template-columns: 160px 1fr; */
  gap: 14px;
  margin-top: 18px;
}

.withdraw_recipient_sub {
  margin-top: 4px;
  font-size: 13px;
  color: #cacaca;
  font-weight: 500;
  text-align: right;
}

body.light_theme .withdraw_recipient_sub {
  color: #6A7282;
}

.withdraw_paypin_link {
  background: transparent;
  border: none;
  padding: 0;
  margin: 12px 0 14px;
  color: #AC8A50;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}

.withdraw_paypin_link:hover {
  text-decoration: underline;
}

.withdraw_paypin_modal {
  width: 520px;
  max-width: 92vw;
  border-radius: 18px;
  border: 1px solid #e1e1e1;
  padding: 0;
  position: relative;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.18);
  background: rgb(255 255 255 / 20%);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  overflow: hidden;
}

.withdraw_paypin_head {
  padding: 18px 24px;
  border-bottom: 1px solid rgba(225, 225, 225, 0.8);
}

.withdraw_paypin_title {
  font-size: 26px;
  font-weight: 600;
  color: #101828;
  display: flex;
  align-items: center;
  gap: 10px;
}

.withdraw_paypin_eye {
  border: none;
  background: transparent;
  padding: 0;
  color: #6A7282;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.withdraw_paypin_body {
  padding: 18px 24px 22px;
}

.withdraw_paypin_label {
  font-size: 18px;
  font-weight: 500;
  color: #101828;
  margin-bottom: 14px;
}

.withdraw_paypin_boxes {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 24px;
  max-width: 440px;
  margin-bottom: 12px;
}

.withdraw_paypin_box {
  height: 56px;
  width: 56px;
  border-radius: 10px;
  border: none;
  background: #E8EAED;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  color: #101828;
  outline: none;
}

/* .withdraw_paypin_box:focus {
  border-color: #AC8A50;
  box-shadow: 0 0 0 3px rgba(172, 138, 80, 0.15);
} */

.withdraw_paypin_hint {
  font-size: 14px;
  color: #7A8496;
  font-weight: 500;
  line-height: 1.45;
  max-width: 640px;
  margin: 8px 0 18px;
}

.withdraw_paypin_confirm {
  width: 100%;
  height: 52px;
  border-radius: 999px;
  border: none;
  background: #303236;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

.withdraw_paypin_confirm:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.withdraw_recipient_btn {
  height: 46px;
  border-radius: 999px;
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.withdraw_recipient_btn--ghost {
  background: #DDDDDD;
  color: #374151;
}

.withdraw_recipient_btn--primary {
  background: #ffffff;
  color: #101828;
}

body.light_theme .withdraw_recipient_btn--primary {
  background: #303236;
  color: #fff;
}

@media (max-width: 767px) {

  .withdraw_recipient_modal {
    padding: 20px 18px 32px;
    border-radius: 16px 16px 0px 0px;
    max-width: 100%;
    height: 85vh;
    overflow: scroll;
  }

  span.withdraw_sucessfull_icon {
    width: 130px;
  }

  .withdraw_coin_hd {
    font-size: 20px;
  }

  .withdraw_recipient_note {
    font-size: 15px;
  }

  .withdraw_recipient_v {
    font-size: 14px;
  }

  .withdraw_paypin_link {
    font-size: 14px;
  }

  .withdraw_recipient_k {
    font-size: 14px;
  }


  .gapbtn_space .withdraw_auth_link {
    padding: 0px;
  }

  .mid_use_text .withdraw_auth_link {
    padding: 0px;
  }

  .withdraw_facial_name {
    font-size: 15px;
  }

  .withdraw_recipient_amt {
    font-size: 30px;
  }

  .withdraw_recipient_row {
    grid-template-columns: 90px 1fr;
  }

  .withdraw_recipient_actions {
    grid-template-columns: 1fr;
  }

  .withdraw_paypin_modal {
    border-radius: 16px 16px 0px 0px;
    max-width: 100%;
  }

  .withdraw_paypin_box {
    height: 44px;
    width: 44px;
    border-radius: 6px;
    font-size: 16px;
  }

  .withdraw_paypin_confirm {
    height: 44px;
  }

  .withdraw_paypin_head,
  .withdraw_paypin_body {
    padding-left: 16px;
    padding-right: 16px;
  }

  .withdraw_paypin_title {
    font-size: 20px;
  }

  .withdraw_paypin_label {
    font-size: 16px;
  }

  .withdraw_paypin_boxes {
    gap: 10px;
    max-width: 100%;
  }
}

.withdraw_await_icon {
  display: flex;
  justify-content: center;
  margin: 50px 0 14px;
}

.withdraw_await_circle {
  width: 160px;
  height: 160px;
  border-radius: 999px;
  background: rgb(255 255 255 / 20%);
  box-shadow: 0 0px 20px rgba(0, 0, 0, 0.10);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.withdraw_await_circle i {
  font-size: 54px;
  color: #C5A36A;
}

.withdraw_await_title {
  font-size: 24px;
  font-weight: 600;
  color: #ffffff;
  margin: 36px 0px 10px;
}

body.light_theme .withdraw_await_title {
  color: #101828;
}

.withdraw_await_text {
  font-size: 16px;
  color: #cacaca;
  font-weight: 500;
  letter-spacing: -0.3px;
  line-height: 1.5;
  max-width: 520px;
  margin: 0 auto 18px;
}

body.light_theme .withdraw_await_text {
  color: #6A7282;
}

.withdraw_await_ok {
  width: 100%;
  border-radius: 999px;
  padding: 13px 15px;
  border: none;
  background: #ffffff;
  color: #101828;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 10px;
}

body.light_theme .withdraw_await_ok {
  background: #101828;
  color: #ffffff;
}

@media (max-width: 520px) {
  .withdraw_await_modal {
    padding: 18px 18px 20px;
    border-radius: 16px;
  }

  .withdraw_await_circle {
    width: 92px;
    height: 92px;
  }

  .withdraw_await_circle i {
    font-size: 44px;
  }

  .withdraw_await_title {
    font-size: 20px;
  }
}

.withdraw_email_title {
  font-size: 24px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 10px;
  letter-spacing: -0.45px;
}

body.light_theme .withdraw_email_title {
  color: #101828;
}

.withdraw_email_subtitle {
  font-size: 16px;
  color: #cacaca;
  font-weight: 400;
  letter-spacing: -0.5px;
  line-height: 1.45;
  margin-bottom: 18px;
}

body.light_theme .withdraw_email_subtitle {
  color: #6A7282;
}

.withdraw_email_label {
  font-size: 14px;
  font-weight: 500;
  color: #9ca3af;
  margin: 11px 0 7px;
}

body.light_theme .withdraw_email_label {
  color: #303236;
}

.withdraw_email_input_row {
  width: 100%;
  position: relative;
}

.withdraw_email_input_row input {
  width: 100%;
  height: 50px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
  padding: 0 110px 0 14px;
  font-size: 14px;
  color: #ffffff;
  outline: none;
  box-sizing: border-box;
}

body.light_theme .withdraw_email_input_row input {
  border: 1px solid #E4E4E4;
  background: #fff;
  color: #303236;
}

.withdraw_email_status {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #AC8A50;
  font-size: 14px;
  font-weight: 600;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
}

.withdraw_email_status:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.withdraw_email_submit {
  width: 100%;
  border-radius: 999px;
  padding: 13px 15px;
  border: none;
  background: #303236;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 30px;
}

@media (max-width: 767px) {
  .withdraw_email_modal {
    padding: 18px 18px 15px;
    border-radius: 16px 16px 0px 0px;
    max-width: 100%;
  }

  .withdraw_email_title {
    font-size: 20px;
    width: 90%;
  }

  .withdraw_email_label {
    font-size: 14px;
  }

  .withdraw_email_status {
    font-size: 14px;
  }
}

.withdraw_choose_topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.withdraw_choose_back {
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  color: #e7e7e7;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  border-radius: 10px;
}

body.light_theme .withdraw_choose_back {
  color: #111827;
}

.withdraw_choose_back:hover {
  background: rgba(255, 255, 255, 0.08);
}

body.light_theme .withdraw_choose_back:hover {
  background: rgba(17, 24, 39, 0.05);
}

.withdraw_choose_title {
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  margin-top: 6px;
  margin-bottom: 10px;
}

body.light_theme .withdraw_choose_title {
  color: #111827;
}

.withdraw_choose_subtitle {
  font-size: 16px;
  color: #84888C;
  font-weight: 400;
  letter-spacing: -0.5px;
  line-height: 1.45;
  margin-bottom: 22px;
}

body.light_theme .withdraw_choose_subtitle {
  color: #6A7282;
}

.withdraw_choose_item {
  width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  letter-spacing: -0.50px;
  gap: 12px;
  padding: 13px 16px;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  cursor: pointer;
  margin-top: 18px;
  transition: background 0.15s ease, border-color 0.15s ease;
}

body.light_theme .withdraw_choose_item {
  border: 1px solid #E4E4E4;
  background: #fff;
  color: #303236;
}

p.subheading {
  letter-spacing: -0.5px;
  color: #AC8A50;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
}

.mid_use_text {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.emailphone_outerbl {
  margin-top: 50px;
}

.withdraw_choose_item:hover {
  background: rgba(255, 255, 255, 0.1);
}

body.light_theme .withdraw_choose_item:hover {
  background: #F6F7F9;
}

.withdraw_choose_item img {
  width: 22px;
  height: 22px;
  display: block;
  opacity: 0.8;
  filter: invert(1);
}

.completed_header img {
  filter: invert(1);
}

body.light_theme .completed_header img {
  filter: invert(0);
}

body.light_theme .withdraw_choose_item img {
  filter: invert(0);
}

@media (max-width: 767px) {
  .withdraw_choose_modal {
    padding: 16px 16px 18px;
    border-radius: 16px 16px 0px 0px;
    min-height: 460px;
    max-width: 100%;
  }

  .withdraw_email_subtitle {
    font-size: 14px;
  }

  .withdraw_choose_title {
    font-size: 20px;
  }

  .withdraw_choose_item {
    font-size: 14px;
    padding: 14px 14px;
  }
}

/* Save Address modal */
.withdraw_save_modal {
  width: 539px;
  max-width: 92vw;
  border-radius: 18px;
  border: 1px solid #e8e8e807;
  padding: 22px 24px 20px;
  position: relative;
  box-shadow: 0 18px 48px rgb(0 0 0 / 40%);
  background-color: rgb(41 41 41 / 60%);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  text-align: left;
}

body.light_theme .withdraw_save_modal {
  border: 1px solid #e8e8e8;
  box-shadow: 0 18px 48px rgb(15 23 42 / 30%);
  background-color: rgb(255 255 255 / 20%);
}

.withdraw_save_head {
  padding-right: 36px;
  padding-bottom: 14px;
  margin-bottom: 4px;
  border-bottom: 1px solid #ececec20;
}

body.light_theme .withdraw_save_head {
  border-bottom: 1px solid #ececec;
}

.withdraw_confirm_overlay .withdraw_save_title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #fafafa;
  letter-spacing: -0.02em;
}

body.light_theme .withdraw_confirm_overlay .withdraw_save_title {
  color: #0f172a;
}

.withdraw_save_body {
  padding-top: 18px;
}

.withdraw_save_field {
  margin-bottom: 16px;
}

.withdraw_save_label {
  display: block;
  font-size: 15px;
  letter-spacing: -0.5px;
  font-weight: 500;
  color: #efefef;
  margin-bottom: 6px;
}

body.light_theme .withdraw_save_label {
  color: #303236;
}

.withdraw_save_input,
.withdraw_save_select,
.withdraw_save_select_trigger {
  width: 100%;
  height: 46px;
  border-radius: 10px;
  border: none;
  padding: 8px 14px;
  font-size: 14px;
  color: #f3f3f3;
  box-sizing: border-box;
  font-weight: 500;
  background: #f5f6f715;
}

body:not(.light_theme) .withdraw_save_input,
body:not(.light_theme) .withdraw_save_select,
body:not(.light_theme) .withdraw_save_select_trigger,
body:not(.light_theme) .withdraw_save_input:not(:placeholder-shown),
body:not(.light_theme) .withdraw_save_select_value {
  color: #ffffff !important;
  -webkit-text-fill-color: #ffffff !important;
}

body.light_theme .withdraw_save_input,
body.light_theme .withdraw_save_select,
body.light_theme .withdraw_save_select_trigger {
  color: #8e8e8e;
  background: #f5f6f7;
}

body.light_theme .withdraw_save_input:-webkit-autofill,
body.light_theme .withdraw_save_input:-webkit-autofill:hover,
body.light_theme .withdraw_save_input:-webkit-autofill:focus,
body.light_theme .withdraw_save_input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px #f5f6f7 inset !important;
  -webkit-text-fill-color: #8e8e8e !important;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}

body:not(.light_theme) .withdraw_save_input:-webkit-autofill,
body:not(.light_theme) .withdraw_save_input:-webkit-autofill:hover,
body:not(.light_theme) .withdraw_save_input:-webkit-autofill:focus,
body:not(.light_theme) .withdraw_save_input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px #24272c inset !important;
  /* approx solid color for #f5f6f715 over dark background */
  -webkit-text-fill-color: #ffffff !important;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}

.withdraw_save_select_trigger {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  padding-right: 40px;
  cursor: pointer;
  font-family: inherit;
  line-height: 1.3;
}

.withdraw_save_select_value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

.withdraw_save_select_trigger.is-placeholder .withdraw_save_select_value {
  color: #94a3b8;
  font-weight: 500;
}

.withdraw_save_select_trigger:not(.is-placeholder) .withdraw_save_select_value {
  color: #cfcfcf;
  font-weight: 500;
}

body.light_theme .withdraw_save_select_trigger:not(.is-placeholder) .withdraw_save_select_value {
  color: #0f172a;
}

.withdraw_save_input.is-invalid,
.withdraw_save_select.is-invalid,
.withdraw_save_select_trigger.is-invalid {
  border-color: #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.12);
}

.withdraw_save_error {
  margin-top: 8px;
  font-size: 12px;
  line-height: 1.3;
  color: #ef4444;
}

.withdraw_save_input::placeholder {
  color: #94a3b8;
}

.withdraw_save_select_wrap {
  position: relative;
}

.withdraw_save_country_select_wrap {
  position: relative;
}

.withdraw_save_country_select_wrap.is-invalid .withdraw-save-country__control {
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.12);
}

.withdraw_save_select {
  appearance: none;
  -webkit-appearance: none;
  padding-right: 40px;
  color: #0f172a;
  cursor: pointer;
}

.withdraw_save_select:invalid {
  color: #94a3b8;
}

.withdraw_save_select:valid {
  color: #0f172a;
}

.withdraw_save_select_wrap::after {
  content: "";
  position: absolute;
  right: 14px;
  top: 50%;
  width: 8px;
  height: 8px;
  border-right: 2px solid #64748b;
  border-bottom: 2px solid #64748b;
  transform: translateY(-65%) rotate(45deg);
  pointer-events: none;
  z-index: 1;
}

.withdraw_save_select_wrap.is-open::after {
  transform: translateY(-35%) rotate(225deg);
}

.withdraw_save_select_menu {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 6px);
  margin: 0;
  padding: 6px;
  list-style: none;
  background: #2f3031;
  border: 1px solid #e4e4e40d;
  border-radius: 10px;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12);
  z-index: 50;
  max-height: 220px;
  overflow-y: auto;
}

body.light_theme .withdraw_save_select_menu {
  background: #fff;
  border: 1px solid #e4e4e4;
}

.withdraw_save_select_menu li {
  margin: 0;
}

.withdraw_save_select_option {
  width: 100%;
  display: block;
  text-align: left;
  border: none;
  background: transparent;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  font-weight: 500;
  color: #dedede;
  cursor: pointer;
  font-family: inherit;
  line-height: 1.35;
}

body.light_theme .withdraw_save_select_option {
  color: #334155;
}

.withdraw_save_select_option:hover {
  background: #f4f5f70a;
}

body.light_theme .withdraw_save_select_option:hover {
  background: #f4f5f7;
}

.withdraw_save_select_option.is-selected {
  background: #f1f5f90a;
  color: #ffffff;
  font-weight: 600;
}

body.light_theme .withdraw_save_select_option.is-selected {
  background: #f1f5f9;
  color: #0f172a;
}

.withdraw_save_universal {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: #F1F4F8;
  border: 1px solid #e9e9e9;
  border-radius: 12px;
  padding: 20px 15px 20px 15px;
  margin-bottom: 16px;
}

.withdraw_save_universal_main {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0;
  flex: 1 1;
  cursor: pointer;
  font-size: 13px;
  line-height: 1.45;
  color: #cbcbcb;
}

body.light_theme .withdraw_save_universal_main {
  color: #334155;
}

.withdraw_save_universal_main input {
  margin-top: 3px;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  accent-color: #111827;
}

.css-qwbp4v-indicatorContainer {
  color: #dbdbdb !important;
}

body.light_theme .css-qwbp4v-indicatorContainer {
  color: #1a1d21 !important;
}

.withdraw_save_universal_text {
  flex: 1 1;
}

.withdraw_save_info {
  border: none;
  background: transparent;
  padding: 2px 0 0;
  margin: 0;
  color: #64748b;
  cursor: pointer;
  line-height: 1;
  flex-shrink: 0;
}

.withdraw_save_info i {
  font-size: 18px;
}

.withdraw_save_whitelist {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 4px 0 6px;
  font-size: 14px;
  color: #1e293b;
  cursor: pointer;
}

.withdraw_save_whitelist input {
  width: 16px;
  height: 16px;
  accent-color: #111827;
}

.withdraw_whitelist_step {
  text-align: left;
  font-size: 14px;
  line-height: 1.5;
  color: #ebebeb;
}

body.light_theme .withdraw_whitelist_step {
  color: #334155;
}

.withdraw_whitelist_intro {
  margin: 0 0 8px;
}

.withdraw_save_confirm_lead {
  margin: 0 0 16px;
  font-size: 14px;
  line-height: 1.55;
  font-weight: 400;
  color: #d5d5d5;
}

body.light_theme .withdraw_save_confirm_lead {
  color: #64748b;
}

.withdraw_save_radio_block {
  margin-bottom: 4px;
}

.withdraw_save_radio_rows {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 10px;
}

.withdraw_save_radio_question {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #f5f5f5;
  letter-spacing: -0.015em;
  line-height: 1.35;
}

body.light_theme .withdraw_save_radio_question {
  color: #0f172a;
}

.withdraw_save_radio_option {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 0;
  cursor: pointer;
}

.withdraw_save_radio_native {
  position: absolute;
  left: 0;
  top: 2px;
  width: 22px;
  height: 22px;
  margin: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 2;
}

.withdraw_save_radio_visual {
  position: relative;
  flex: 0 0 22px;
  width: 22px;
  height: 22px;
  margin-top: 2px;
  border: 2px solid #cbd5e16e;
  border-radius: 50%;
  background: #ffffff0f;
  box-sizing: border-box;
}

body.light_theme .withdraw_save_radio_visual {
  border: 2px solid #cbd5e1;
  background: #fff;
}

.css-9xs793-control {
  background-color: #f5f6f720 !important;
}

body.light_theme .css-9xs793-control {
  background-color: #f5f6f7 !important;
}

.withdraw_save_radio_native:focus-visible+.withdraw_save_radio_visual {
  outline: 2px solid #64748b;
  outline-offset: 2px;
}

.withdraw_save_radio_native:checked+.withdraw_save_radio_visual {
  border-color: #d1aa67;
}

.withdraw_save_radio_native:checked+.withdraw_save_radio_visual::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 10px;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background: #d1aa67;
}

.withdraw_save_radio_text {
  flex: 1 1;
  padding-top: 1px;
  font-size: 14px;
  line-height: 1.45;
  font-weight: 500;
  color: #ebebeb;
}

body.light_theme .withdraw_save_radio_text {
  color: #0f172a;
}

.withdraw_save_modal.verify_identity .withdraw_sec_item {
  padding: 15px;
}

.withdraw_save_modal.verify_identity .withdraw_sec_list {
  gap: 15px;
}

.withdraw_save_radio_option.is-disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.withdraw_save_radio_native:disabled {
  cursor: not-allowed;
  pointer-events: none;
}

.withdraw_whitelist_wallet_missing {
  margin: 4px 0 12px;
}

.withdraw_whitelist_wallet_missing_actions {
  margin-top: 10px;
}

.withdraw_whitelist_amount {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
}

body.light_theme .withdraw_whitelist_amount {
  color: #0f172a;
}

.withdraw_whitelist_hint {
  margin: 0 0 10px;
  color: #cfcfcf;
}

body.light_theme .withdraw_whitelist_hint {
  color: #475569;
}

.withdraw_whitelist_mm_soft_hint {
  margin: 0 0 10px;
  /* padding: 10px 12px; */
  font-size: 13px;
  line-height: 1.45;
  color: #3f3f3e70;
  /* background: #fffbeb; */
  /* border: 1px solid #fde68a; */
  border-radius: 8px;
}

.withdraw_whitelist_link {
  color: #b45309;
  font-weight: 600;
  text-decoration: underline;
  /* padding: 0px 1px; */
  background: none !important;
}

.withdraw_whitelist_expiry {
  margin: 0 0 12px;
  font-size: 13px;
  color: #dfdfdf;
}

body.light_theme .withdraw_whitelist_expiry {
  color: #64748b;
}

.withdraw_whitelist_polling {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 8px;
  font-size: 13px;
  color: #475569;
}

.withdraw_whitelist_polling_text {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.withdraw_whitelist_polling_hint {
  display: block;
  font-size: 12px;
  line-height: 1.45;
  color: #64748b;
  font-weight: 400;
}

.withdraw_whitelist_checking {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  font-size: 13px;
  color: #475569;
}

button.withdraw_sec_item.withdraw_sec_item--selectable {
  border: none;
}

b .withdraw_whitelist_checking .spinner-border {
  flex-shrink: 0;
}

.withdraw_whitelist_checking_text {
  font-weight: 500;
}

.withdraw_whitelist_awaiting_notice {
  margin-top: 12px;
  padding: 12px 0px;
  /* background: #f0f9ff; */
  /* border: 1px solid #bae6fd; */
  border-radius: 10px;
  text-align: left;
}

.withdraw_whitelist_awaiting_title {
  margin: 0 0 8px;
  font-size: 14px;
  font-weight: 600;
  color: #f5f5f5;
}

body.light_theme .withdraw_whitelist_awaiting_title {
  color: #000;
}

.withdraw_whitelist_awaiting_body {
  margin: 0 0 8px;
  font-size: 13px;
  line-height: 1.5;
  color: #e5e5e5;
}

body.light_theme .withdraw_whitelist_awaiting_body {
  color: #334155;
}

.withdraw_whitelist_awaiting_body:last-child {
  margin-bottom: 0;
}

.withdraw_whitelist_polling .spinner-border {
  flex-shrink: 0;
}

.withdraw_whitelist_deposit_loading {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 12px 0;
  font-size: 14px;
  color: #475569;
}

.withdraw_whitelist_deposit_panel {
  display: flex;
  /* flex-wrap: wrap; */
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  /* align-items: flex-start; */
  margin: 14px 0 8px;
  padding: 14px;
  border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.4);
  /* background: rgba(248, 250, 252, 0.65); */
}

.withdraw_whitelist_qr_wrap {
  /* flex: 0 0 auto; */
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.withdraw_whitelist_qr_svg {
  display: block;
  border-radius: 8px;
}

.withdraw_whitelist_qr_hint {
  margin-top: 8px;
  font-size: 12px;
  color: #ebebeb;
}

body.light_theme .withdraw_whitelist_qr_hint {
  color: #64748b;
}

.withdraw_whitelist_deposit_fields {
  /* flex: 1 1 200px; */
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
}

.withdraw_whitelist_addr_block {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.withdraw_whitelist_field_label {
  font-size: 12px;
  font-weight: 600;
  color: #ffffff;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

body.light_theme .withdraw_whitelist_field_label {
  color: #475569;
}

.withdraw_whitelist_addr_input_row {
  display: flex;
  gap: 8px;
  align-items: stretch;
  width: 100%;
}

.withdraw_whitelist_addr_input_row .withdraw_save_input {
  flex: 1 1 auto;
  min-width: 0;
}

.withdraw_whitelist_copy_btn {
  flex: 0 0 auto;
  padding: 0 14px;
  border-radius: 10px;
  border: 1px solid #d1aa67;
  background: #d1aa67;
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
  cursor: pointer;
  white-space: nowrap;
}

.withdraw_whitelist_copy_btn:hover {
  border-color: #d1aa67;
}

.withdraw_whitelist_method_hint {
  margin: 6px 0 0;
  font-size: 13px;
  line-height: 1.45;
  color: rgb(198, 199, 199);
}

body.light_theme .withdraw_whitelist_method_hint {
  color: #64748b;
}

.withdraw_whitelist_method_btn:disabled {
  opacity: 0.48;
  cursor: not-allowed;
}

.withdraw_whitelist_method_btn:not(:disabled):hover {
  border-color: #334155;
}

.withdraw_whitelist_method {
  margin: 8px 0 4px;
}

.withdraw_whitelist_method_btns {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
}

.withdraw_whitelist_method_btn {
  flex: 1 1 140px;
  min-height: 40px;
  padding: 0 12px;
  border-radius: 10px;
  border: 1px solid rgba(148, 163, 184, 0.55);
  background: #fff;
  font-size: 13px;
  font-weight: 500;
  color: #334155;
  cursor: pointer;
}

.withdraw_whitelist_method_btn.is-active {
  border-color: #111827;
  background: #111827;
  color: #fff;
}

.withdraw_save_actions {
  display: flex;
  gap: 12px;
  margin-top: 22px;
}

.withdraw_save_btn {
  height: 46px;
  border-radius: 999px;
  border: none;
  font-size: 14px;
  font-weight: 500;
}

.withdraw_save_btn--cancel {
  flex: 0 0 30%;
  max-width: 30%;
  background: #DDDDDD;
  color: #334155;
}

.withdraw_save_btn--save {
  flex: 1 1 60%;
  background: #111827;
  color: #fff;
}

.withdraw_save_btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

@media (max-width: 520px) {
  .withdraw_save_btn {
    height: 35px;

  }



  .withdraw_save_title {
    font-size: 18px;
  }

  .withdraw_save_actions {
    flex-direction: column;
  }

  .withdraw_save_btn--cancel {
    flex: 1 1 auto;
    max-width: none;
  }
}

/* About Network Fee — modal (Network Fee … button) */
.withdraw_netfee_modal {
  width: 606px;
  max-width: 92vw;
  border-radius: 18px;
  border: 1px solid #e8e8e806;
  padding: 22px 24px 20px;
  position: relative;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.30);
  background: #1e2026a3;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  text-align: left;
}

body.light_theme .withdraw_netfee_modal {
  border: 1px solid #e8e8e8;
  background: #ffffff21;

}

.withdraw_netfee_modal .withdraw_netfee_panel_title {
  margin: 0;
  padding-right: 40px;
}

@media (max-width: 767px) {

  .withdraw_save_modal {
    width: 100%;
    max-width: 100%;
    padding: 18px 16px 16px;
    border-radius: 16px 16px 0px 0px;
  }

  .withdraw_passkey_modal {
    border-radius: 16px 16px 0px 0px;
  }

  .withdraw_confirm_overlay .withdraw_save_title {
    font-size: 20px;
  }

  .withdraw_passkey_link {
    margin: 10px auto 10px;
    font-size: 14px;
  }

  .withdraw_netfee_modal {
    padding: 18px 16px 16px;
    border-radius: 16px 16px 0px 0px;
    max-width: 100%;
  }
}

/* —— Recent withdrawals: Withdrawal Details (replaces Bootstrap #recent_table) —— */
.withdraw_hist_detail_overlay {
  z-index: 100000001;
}

.withdraw_hist_detail_modal {
  width: 606px;
  max-width: 92vw;
  max-height: min(92vh, 720px);
  overflow: auto;
  border-radius: 20px;
  border: 1px solid #e8e8e8;
  padding: 24px;
  position: relative;
  /* box-shadow: 0 24px 48px rgba(15, 23, 42, 0.14); */
  /* background: #fff; */
  text-align: left;
  -webkit-overflow-scrolling: touch;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.18);
  background: rgb(255 255 255 / 20%);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
}

.withdraw_hist_detail_head {
  padding-bottom: 5px;
  margin-bottom: 4px;
}

.withdraw_hist_detail_title {
  margin: 0;
  padding-right: 44px;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #0f172a;
}

.withdraw_hist_detail_body {
  padding-top: 4px;
}

/* Vertical stepper */
.withdraw_hist_stepper {
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  padding-left: 24px;
}

.withdraw_hist_step {
  display: flex;
  gap: 14px;
  align-items: stretch;
}

.withdraw_hist_step_track {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 14px;
  flex-shrink: 0;
}

.withdraw_hist_step_dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #00c087;
  margin-top: 6px;
  flex-shrink: 0;
  box-shadow: 0 0 0 3px rgba(0, 192, 135, 0.18);
}

.withdraw_hist_step_line {
  flex: 1 1;
  width: 2px;
  min-height: 28px;
  margin: 6px 0 0;
  border-radius: 1px;
  background: rgba(0, 192, 135, 0.35);
}

.withdraw_hist_step_text {
  flex: 1 1;
  padding-bottom: 4px;
}

.withdraw_hist_step_title {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.35;
}

.withdraw_hist_step_title.is-emphasized {
  font-weight: 700;
}

.withdraw_hist_step_time {
  margin-top: 4px;
  font-size: 12px;
  font-weight: 500;
  color: #9CA3AF;
}

.withdraw_hist_step_note {
  margin: 4px 0 0;
  padding-left: 51px;
  font-size: 12px;
  line-height: 1.45;
  color: #64748b;
}

.withdraw_hist_step_note--danger {
  color: #b91c1c;
}

.withdraw_hist_step_sub {
  margin-top: 6px;
  font-size: 12px;
  line-height: 1.45;
  color: #64748b;
  font-weight: 400;
}

.withdraw_hist_stepper[data-outcome="danger"] .withdraw_hist_step:first-child .withdraw_hist_step_line {
  background: rgba(239, 68, 68, 0.45);
}

.withdraw_hist_stepper[data-outcome="danger"] .withdraw_hist_step:last-child .withdraw_hist_step_dot {
  background: #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.22);
}

.withdraw_hist_stepper[data-outcome="pending"] .withdraw_hist_step:first-child .withdraw_hist_step_line {
  background: rgba(245, 158, 11, 0.42);
}

.withdraw_hist_stepper[data-outcome="pending"] .withdraw_hist_step:last-child .withdraw_hist_step_dot {
  background: #f59e0b;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.28);
}

.withdraw_hist_tx_ref_hint {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #94a3b8;
  padding: 2px 6px;
  border-radius: 4px;
  background: rgba(148, 163, 184, 0.2);
  flex-shrink: 0;
}

.withdraw_hist_help_links {
  margin-top: 12px;
  padding-left: 50px;
  display: flex;
  flex-direction: column;
  gap: 3px 18px;
}

.withdraw_hist_gold_link {
  font-size: 14px;
  font-weight: 500;
  color: #AC8A50;
  /* text-decoration: underline; */
  text-underline-offset: 2px;
}

/* .withdraw_hist_gold_link:hover {
  color: #957a44;
} */

/* Detail rows */
.withdraw_hist_rows {
  margin-top: 22px;
  padding-top: 18px;
  border-top: 1px solid #eceff3;
  display: flex;
  flex-direction: column;
  gap: 26px;
}

.withdraw_hist_row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  font-size: 16px;
  line-height: 1.4;
}

.withdraw_hist_row_label {
  color: #707a8a;
  font-weight: 500;
  flex-shrink: 0;
}

.withdraw_hist_row_value {
  color: #303236;
  font-weight: 500;
  text-align: right;
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  max-width: 68%;
}

.withdraw_hist_row_value--success {
  color: #10b981;
}

.withdraw_hist_row_value--danger {
  color: #ef4444;
}

.withdraw_hist_row_value--pending {
  color: #d97706;
}

.withdraw_hist_row_value--neutral,
.withdraw_hist_row_value--info {
  color: #64748b;
}

.withdraw_hist_row_value--coin {
  gap: 8px;
}

.withdraw_hist_row_value--coin img {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  object-fit: cover;
}

.withdraw_hist_row_value--addr {
  max-width: 72%;
}

.withdraw_hist_mono {
  font-variant-numeric: tabular-nums;
  word-break: break-all;
}

.withdraw_hist_badge_unverified {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px 2px 6px;
  border-radius: 3px;
  background: #C6A5A5;
  color: #C21F33;
  font-size: 10px;
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;
}

.withdraw_hist_badge_icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: rgba(246, 70, 93, 0.22);
  font-size: 10px;
  font-weight: 800;
}

.withdraw_hist_icon_btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

body.light_theme .withdraw_hist_icon_btn {
  background: #F3F4F6;
  color: #6c6c6c;
}

html[data-theme='dark'] body .withdraw_sec_req_modal.sec-req-invert-icons .withdraw_sec_req_left img {
  filter: brightness(0) invert(1);
}

/* .withdraw_hist_icon_btn:hover {
  background: #f1f5f9;
  color: #64748b;
} */

.withdraw_hist_icon_link {
  text-decoration: none;
}

.withdraw_hist_icon_svg {
  width: 15px;
  height: 15px;
  display: block;
}

.withdraw_hist_chat_row {
  margin: 20px 0 0;
  text-align: center;
}

/* .withdraw_hist_chat_row .withdraw_hist_gold_link {
  font-weight: 500;
} */

.withdraw_hist_again_btn {
  width: 100%;
  margin-top: 16px;
  height: 46px;
  border: none;
  border-radius: 999px;
  background: #2d2e32;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.01em;
  cursor: pointer;
}

.withdraw_hist_again_btn:hover {
  background: #1a1b1f;
}

.withdraw_hist_cancel_btn {
  margin-top: 12px;
  background: transparent;
  color: #c45c5c;
  border: 1px solid #c45c5c;
}

.withdraw_hist_cancel_btn:hover:not(:disabled) {
  background: rgba(196, 92, 92, 0.12);
}

.withdraw_hist_cancel_btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.recent_deposit_list .withdraw_hist_view_btn {
  color: #ac8a50;
  font-size: 14px;
  font-weight: 500;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.recent_deposit_list .withdraw_hist_view_btn:hover {
  color: #957a44;
}

/* —— Recent Withdrawals v2 (Address tab: table + mobile cards; matches product layout) —— */
.recent_deposit_list.withdraw_recent_v2 {
  padding-top: 48px;
}

.withdraw_recent_head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.withdraw_recent_title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #101828;
  letter-spacing: -0.02em;
}

.withdraw_recent_head_right {
  display: flex;
  align-items: center;
  gap: 18px;
  flex-wrap: wrap;
}

.withdraw_recent_hide_err {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: #64748b;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.withdraw_recent_hide_err input {
  width: 16px;
  height: 16px;
  accent-color: #d1aa67;
  cursor: pointer;
}

body.light_theme .withdraw_recent_hide_err input {
  accent-color: #111827;
}

.withdraw_recent_more {
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  text-decoration: none;
}

.withdraw_recent_more:hover {
  color: #334155;
}

.withdraw_recent_tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}

.withdraw_recent_tab {
  padding: 8px 18px;
  border-radius: 999px;
  border: none;
  background: #fff;
  border-radius: 10px;
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  line-height: 1.2;
}

.withdraw_recent_table_outer {
  width: 100%;
}

/* Reset global .recent_deposit_list table { flex rows } so thead/tbody layout works */
.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
}

.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table thead tr,
.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table tbody tr {
  display: table-row;
  margin: 0;
  padding: 0;
  border-radius: 0;
  align-items: stretch;
}

.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table thead tr:hover,
.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table tbody tr:hover {
  background: transparent;
}

.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table th,
.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table td {
  display: table-cell;
  vertical-align: middle;
  cursor: default;
  padding: 14px 12px;
  border-bottom: none;
  font-size: 14px;
  text-align: left;
  color: #1e2329;
  font-weight: 400;
}

.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table thead th {
  font-size: 13px;
  font-weight: 400;
  color: #707a8a;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: none;
  background: none;
}

.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table tbody tr {
  background: #fff;
}

.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table tbody tr.withdraw_recent_row_open_detail {
  cursor: pointer;
}

.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table tbody tr.withdraw_recent_row_open_detail:hover {
  background: #f8fafc;
}

.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table tbody tr.withdraw_recent_row_open_detail:focus {
  /* outline: 2px solid rgba(172, 138, 80, 0.65); */
  outline-offset: -2px;
}

.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_card_open_detail {
  cursor: pointer;
}

.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_card_open_detail:hover {
  background: rgba(248, 250, 252, 0.92);
}

.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_card_open_detail:focus {
  outline: 2px solid rgba(172, 138, 80, 0.65);
  outline-offset: 2px;
}

/* .recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table tbody tr:hover {
  background: #f8fafc;
} */

.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table tbody tr td span {
  color: inherit;
}

.withdraw_recent_th_action {
  width: 56px;
}

.withdraw_recent_asset_cell {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.withdraw_recent_asset_cell img {
  border-radius: 50%;
  flex-shrink: 0;
}

.withdraw_recent_asset_text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.withdraw_recent_coin {
  font-weight: 600;
  color: #1e2329;
}

.withdraw_recent_list_date {
  font-size: 12px;
  font-weight: 400;
  color: #94a3b8;
}

.withdraw_recent_amount {
  font-weight: 500;
  color: #1e2329;
}

.withdraw_recent_net_pill {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  background: #F3F4F6;
  color: #475569 !important;
  font-size: 12px;
  font-weight: 500;
}

.withdraw_recent_cell_actions {
  display: inline-flex;
  /* align-items: center; */
  /* justify-content: flex-end; */
  /* flex-wrap: wrap; */
  /* gap: 6px; */
  font-weight: 500;
}

.withdraw_recent_mono {
  font-variant-numeric: tabular-nums;
  color: #1e2329;
  word-break: break-all;
}

.withdraw_recent_icon_btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  flex-shrink: 0;
}

.withdraw_recent_icon_btn:hover {
  background: #f1f5f9;
  color: #64748b;
}

.withdraw_recent_icon_link {
  text-decoration: none;
}

.withdraw_recent_v2 .withdraw_hist_icon_svg {
  width: 16px;
  height: 16px;
}

.withdraw_recent_status {
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
}

.withdraw_recent_status--success {
  color: #10b981;
}

.withdraw_recent_status--danger {
  color: #ef4444;
}

.withdraw_recent_status--pending {
  color: #d97706;
}

.withdraw_recent_status--neutral,
.withdraw_recent_status--info {
  color: #64748b;
}

.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_icon_link.is-disabled {
  opacity: 0.45;
  pointer-events: none;
  cursor: not-allowed;
}

.recent_deposit_list.withdraw_recent_v2 .withdraw_hist_view_btn {
  color: #ac8a50;
  font-size: 14px;
  font-weight: 500;
  text-decoration: underline;
  text-underline-offset: 3px;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
}

.recent_deposit_list.withdraw_recent_v2 .withdraw_hist_view_btn:hover {
  color: #957a44;
}

.withdraw_recent_empty {
  padding: 28px 16px;
  text-align: center;
  font-size: 14px;
  color: #94a3b8;
  /* background: #fafbfc;
  border: 1px dashed #e2e8f0; 
  border-radius: 12px;*/
}

/* Mobile card refinements */
.withdraw_recent_v2 .withdraw_recent_card .withdraw_recent_card_top {
  margin-bottom: 4px;
}

.withdraw_recent_v2 .withdraw_recent_card_asset {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.withdraw_recent_v2 .withdraw_recent_card_coin_row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.withdraw_recent_v2 .withdraw_recent_card_amt {
  border-top: none;
  padding-top: 10px;
}

.withdraw_recent_v2 .withdraw_recent_card_row_actions .value {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 6px;
  max-width: 68%;
  text-align: right;
}

@media (min-width: 992px) {
  .recent_deposit_list.withdraw_recent_v2 .withdraw_history_desktop {
    display: block;
  }

  .recent_deposit_list.withdraw_recent_v2 .withdraw_history_mobile {
    display: none;
  }
}

@media (max-width: 991px) {
  .recent_deposit_list.withdraw_recent_v2 .withdraw_history_desktop {
    display: none;
  }

  .recent_deposit_list.withdraw_recent_v2 .withdraw_history_mobile {
    display: block;
  }

  .withdraw_recent_head {
    flex-direction: column;
    align-items: stretch;
  }

  .withdraw_recent_head_right {
    justify-content: space-between;
  }
}

body.light_theme .dashboard_right .withdraw_recent_title {
  color: #101828;
}

.dashboard_right .withdraw_recent_tab {
  background: #2b3138;
  border-color: #e5e7eb;
}

body.light_theme .dashboard_right .withdraw_recent_tab {
  background: #fff;
  border-color: #e5e7eb;

}

.withdraw_recent_tab.is-active {
  color: #ffffff;
}

body.light_theme .withdraw_recent_tab.is-active {
  color: #0f172a;
}


@media (max-width: 767px) {

  .withdraw_confirm_overlay {
    align-items: end;
    padding: 0px
  }

  .withdraw_confirm_modal {
    padding: 20px 18px 32px;
    border-radius: 16px 16px 0px 0px;
    max-width: 100%;
  }

  .withdraw_hist_stepper {
    margin-top: 18px;
  }

  .withdraw_hist_again_btn {
    height: 38px;
    font-size: 13px;
  }

}


@media (max-width: 767px) {


  .withdraw_hist_detail_title {
    font-size: 18px;
  }

  .withdraw_hist_row_value,
  .withdraw_hist_row_value--addr {
    max-width: 100%;
    justify-content: flex-start;
    text-align: left;
  }

  .withdraw_hist_row {
    align-items: flex-start;
    gap: 6px;
  }

  .withdraw_hist_row {
    gap: 12px;
    font-size: 14px;
  }

}

/* —— Security verification unavailable flow (screenshots) —— */
.withdraw_sec_overlay {
  z-index: 100000020;
}

/* Shared popup typography + input styling (security_verification_unavailable only) */
.withdraw_sec_overlay .withdraw_sec_modal,
.withdraw_sec_overlay .withdraw_sec_confirm_modal,
.withdraw_sec_overlay .withdraw_sec_req_modal,
.withdraw_sec_overlay .withdraw_passkey_modal,
.withdraw_sec_overlay .withdraw_auth_modal,
.withdraw_sec_overlay .withdraw_email_modal,
.withdraw_sec_overlay .withdraw_mobile_modal,
.withdraw_sec_overlay .withdraw_facial_modal {
  font-family: inherit;
  color: #ffffff;
}

body.light_theme .withdraw_sec_overlay .withdraw_sec_modal,
body.light_theme .withdraw_sec_overlay .withdraw_sec_confirm_modal,
body.light_theme .withdraw_sec_overlay .withdraw_sec_req_modal,
body.light_theme .withdraw_sec_overlay .withdraw_passkey_modal,
body.light_theme .withdraw_sec_overlay .withdraw_auth_modal,
body.light_theme .withdraw_sec_overlay .withdraw_email_modal,
body.light_theme .withdraw_sec_overlay .withdraw_mobile_modal,
body.light_theme .withdraw_sec_overlay .withdraw_facial_modal {
  color: #111827;
}

.withdraw_sec_overlay input[type="text"],
.withdraw_sec_overlay input[type="email"],
.withdraw_sec_overlay input[type="tel"],
.withdraw_sec_overlay input[type="search"],
.withdraw_sec_overlay input[type="password"] {
  height: 48px;
  border-radius: 10px;
  border: 1px solid #e5e7eb2b;
  background: rgb(255 255 255 / 4%);
}

body.light_theme .withdraw_sec_overlay input[type="text"],
body.light_theme .withdraw_sec_overlay input[type="email"],
body.light_theme .withdraw_sec_overlay input[type="tel"],
body.light_theme .withdraw_sec_overlay input[type="search"],
body.light_theme .withdraw_sec_overlay input[type="password"] {
  border: 1px solid #e5e7eb;
  background: rgb(255 255 255 / 20%);
}

.withdraw_sec_overlay input[type="text"]:focus,
.withdraw_sec_overlay input[type="email"]:focus,
.withdraw_sec_overlay input[type="tel"]:focus,
.withdraw_sec_overlay input[type="search"]:focus,
.withdraw_sec_overlay input[type="password"]:focus {
  border-color: #ac8a5000;
  box-shadow: 0 0 0 2px rgba(142, 114, 67, 0.15);
  outline: none;
}

.withdraw_sec_modal,
.withdraw_sec_confirm_modal,
.withdraw_sec_req_modal {
  width: 550px;
  max-width: 92vw;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 22px 36px 24px;
  position: relative;
  text-align: left;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.50);
  background: #181a2087;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

body.light_theme .withdraw_sec_modal,
body.light_theme .withdraw_sec_confirm_modal,
body.light_theme .withdraw_sec_req_modal {
  border: 1px solid #e8e8e8;
  box-shadow: 0 20px 60px rgb(0 0 0 / 60%);
  background: rgb(255 255 255 / 20%);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

.withdraw_sec_title {
  font-size: 24px;
  letter-spacing: -0.45px;
  font-weight: 600;
  color: #ffffff;
  margin: 4px 0 8px;
  padding-right: 44px;
}

body.light_theme .withdraw_sec_title {
  color: #111827;
}

.withdraw_sec_subtitle {
  color: #84888C;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  margin-bottom: 18px;
}

body.light_theme .withdraw_sec_subtitle {
  color: #6A7282;
}

.withdraw_sec_list {
  display: flex;
  flex-direction: column;
  gap: 0px;
  margin-bottom: 18px;
}

.withdraw_sec_item {
  width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 10px 14px;
  display: flex;
  min-height: 62px;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.05);
  letter-spacing: -0.45px;
}

body.light_theme .withdraw_sec_item {
  border: 1px solid #E4E4E4;
  background: #ffffff00;
}

.withdraw_sec_item--selectable {
  cursor: pointer;
  text-align: left;
  padding: 0;
}

.withdraw_sec_item--selectable:hover {
  border-color: rgba(255, 255, 255, 0.3);
}

body.light_theme .withdraw_sec_item--selectable:hover {
  border-color: #c4b48a;
}

.withdraw_sec_item--selectable.is-selected {
  /* border-color: #a89058; */
  /* box-shadow: 0 0 0 1px rgba(168, 144, 88, 0.25); */
}

.withdraw_sec_item--readonly {
  cursor: default;
  pointer-events: none;
}

.withdraw_addr_verify_identity .withdraw_sec_confirm_hero {
  margin-top: 0;
}

.withdraw_addr_verify_identity .withdraw_sec_confirm_hero img {
  width: 180px;
  max-width: 100%;
}

.withdraw_addr_verify_identity .withdraw_sec_title {
  padding-right: 0;
}

.withdraw_addr_verify_chev {
  color: #9ca3af;
  font-size: 22px;
  font-weight: 300;
  line-height: 1;
  flex-shrink: 0;
  margin-left: 8px;
}

.withdraw_sec_item_left {
  display: flex;
  gap: 12px;
  align-items: center;
}

.withdraw_sec_icon {
  width: 21px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  filter: invert(1);
}

body.light_theme .withdraw_sec_icon img {
  filter: invert(0);
}

body.light_theme .withdraw_sec_icon {
  color: #111827;
}

span.withdraw_sec_item_txt {
  text-align: left;
}

.withdraw_sec_item_title {
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
}

body.light_theme .withdraw_sec_item_title {
  color: #111827;
}

.withdraw_sec_item_sub {
  display: block;
  font-size: 12px;
  color: #9ca3af;
  margin-top: 0px;
}

body.light_theme .withdraw_sec_item_sub {
  color: #6b7280;
}

.withdraw_sec_check {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  display: inline-block;
  position: relative;
  overflow: hidden;
}

body.light_theme .withdraw_sec_check {
  border: 2px solid #E5E7EB;
}

.withdraw_sec_check.is-checked {
  background: transparent;
  border-color: transparent;
}

.withdraw_sec_check.is-checked::after {
  content: "";
  position: absolute;
  inset: 0;
  margin: auto;
  background: #d1aa67;
  background-size: 10px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
}

.withdraw_sec_primary {
  width: 100%;
  border-radius: 999px;
  border: none;
  background: #2b2f36;
  color: #fff;
  font-weight: 500;
  padding: 14px 16px;
}

.withdraw_sec_primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.withdraw_sec_help {
  margin-top: 14px;
  width: 100%;
  background: transparent;
  border: none;
  font-size: 14px;
  color: #84888C;
  text-decoration: underline;
  font-weight: 500;
}

body.light_theme .withdraw_sec_help {
  color: #111827;
}

.withdraw_sec_confirm_hero {
  display: flex;
  justify-content: center;
  margin: 10px 0 20px;
}

.withdraw_sec_confirm_hero img {
  /* width: 220px; */
  height: 104px;
  opacity: 1;
}

.withdraw_sec_confirm_title {
  max-width: 80%;
  text-align: center;
  font-size: 24px;
  margin: 0 auto;
  font-weight: 600;
  color: #eaeaea;
  letter-spacing: -0.45px;
  line-height: 1.2;
  margin-bottom: 14px;
  padding: 0 10px;
}

body.light_theme .withdraw_sec_confirm_title {
  color: #111827;
}

.withdraw_sec_confirm_ack {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  border: 1px solid #e4e4e41a;
  border-radius: 10px;
  padding: 22px 15px;
  font-weight: 400;
  background: #ffffff0a;
  font-size: 14px;
  margin: 24px 0px;
  line-height: 1.45;
  color: #d0d0d0;
}

body.light_theme .withdraw_sec_confirm_ack {
  background: #fff;
  border: 1px solid #E4E4E4;
  color: #374151;
}

.withdraw_sec_confirm_ack_input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.withdraw_sec_confirm_ack_box--icon {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 2px solid #E5E7EB;
  background: rgb(255 255 255 / 20%);
  flex: 0 0 auto;
  position: relative;
  margin-top: 2px;
}

.withdraw_sec_confirm_ack_box--icon.is-checked {
  background: #111827;
  border-color: #111827;
}

.withdraw_sec_confirm_ack_box--icon.is-checked::after {
  content: "";
  position: absolute;
  inset: 0;
  margin: auto;
  width: 12px;
  height: 12px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.withdraw_sec_confirm_actions {
  display: flex;
  gap: 12px;
  margin-top: 16px;
}

.withdraw_sec_btnGhost,
.withdraw_sec_btnPrimary {
  flex: 1 1;
  border-radius: 999px;
  padding: 12px 14px;
  font-weight: 400;
}

.withdraw_sec_btnGhost {
  border: none;
  background: #DDDDDD;
  color: #111827;
  max-width: 160px;
}

.withdraw_sec_btnPrimary {
  border: none;
  background: #2b2f36;
  color: #fff;
}

.withdraw_sec_btnPrimary:disabled {
  opacity: 0.5;
}

.withdraw_sec_req_topbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.withdraw_sec_req_title {
  font-size: 24px;
  letter-spacing: -0.45px;
  font-weight: 600;
  color: #e9e9e9;
  margin: 0 0 8px;
}

body.light_theme .withdraw_sec_req_title {
  color: #111827;
}

.withdraw_sec_req_subtitle {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 10px;
  font-weight: 500;
}

.withdraw_sec_req_progress {
  font-size: 24px;
  font-weight: 600;
  color: #AC8A50;
  margin: 18px 0px;
}

.withdraw_sec_req_list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 14px;
}

.withdraw_sec_req_item {
  width: 100%;
  text-align: left;
  border: 1px solid #e5e7eb14;
  border-radius: 10px;
  padding: 10px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff0d;
  min-height: 62px;
  letter-spacing: -0.45px;
}

body.light_theme .withdraw_sec_req_item {
  border: 1px solid #e5e7eb;
  background: #fff;
}

.withdraw_sec_req_left {
  display: flex;
  gap: 12px;
  align-items: center;
  color: #f1f1f1;
}

.withdraw_sec_req_left img {
  filter: invert(1);
}

body.light_theme .withdraw_sec_req_left img {
  filter: invert(0);
}

body.light_theme .withdraw_sec_req_left {
  color: #111827;
}

.withdraw_sec_req_left i {
  font-size: 18px;
}

.withdraw_sec_req_name {
  display: block;
  font-weight: 500;
  font-size: 16px;
}

.withdraw_sec_req_desc {
  display: block;
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}

.withdraw_sec_req_right {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  color: #fff;
}

body.light_theme .withdraw_sec_req_right {
  color: #0f0f0f;
}

.withdraw_sec_req_arrow {
  font-size: 22px;
  color: #9ca3af;
}

.withdraw_sec_req_check {
  font-size: 18px;
  color: #16a34a;
}

.withdraw_sec_req_link {
  width: 100%;
  background: transparent;
  border: none;
  color: #b88b2c;
  font-weight: 600;
  text-align: center;
  padding: 10px 0 0;
}

/* Facial verification screens */
.withdraw_facial_modal {
  width: 540px;
  max-width: 92vw;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 24px 26px 24px;
  position: relative;
  text-align: left;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.50);
  background: #181a2087;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

body.light_theme .withdraw_facial_modal {
  border: 1px solid #e8e8e8;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.80);
  background: rgb(255 255 255 / 20%);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

.withdraw_sec_req_topbar button.withdraw_choose_back {
  padding: 0px;
}

.withdraw_facial_title {
  font-size: 24px;
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 8px;
}

body.light_theme .withdraw_facial_title {
  color: #111827;
}

.withdraw_facial_subtitle {
  font-size: 14px;
  color: #dddddd;
  line-height: 1.5;
  margin-bottom: 20px;
}

body.light_theme .withdraw_facial_subtitle {
  color: #6b7280;
}

.withdraw_facial_list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 40px 0 14px;
}

.withdraw_facial_item {
  width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 10px 14px;
  display: flex;
  letter-spacing: -0.45px;
  text-align: left;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.05);
  min-height: 62px;
}

body.light_theme .withdraw_facial_item {
  border: 1px solid #e5e7eb;
  background: #ffffff40;
}

.withdraw_facial_left {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  color: #ffffff;
}

body.light_theme .withdraw_facial_left {
  color: #111827;
}

.withdraw_facial_left i {
  font-size: 18px;
  margin-top: 2px;
}

.withdraw_facial_name {
  display: block;
  font-size: 16px;
  font-weight: 500;
}

.withdraw_facial_desc {
  display: block;
  font-size: 12px;
  color: #84888C;
  margin-top: 2px;
}

body.light_theme .withdraw_facial_desc {
  color: #6b7280;
}

.withdraw_facial_noteBox {
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  font-size: 14px;
  padding: 18px 22px;
  margin-bottom: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

body.light_theme .withdraw_facial_noteBox {
  border: 1px solid #e5e7eb;
  background: #ffffff40;
}

.withdraw_facial_noteLine {
  display: flex;
  align-items: center;
  gap: 6px;
}

.withdraw_facial_noteLine i {
  font-size: 7px;
}

.withdraw_facial_noteBox ul {
  margin: 0;
  padding-left: 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: #ffffff;
  font-size: 13px;
}

body.light_theme .withdraw_facial_noteBox ul {
  color: #374151;
}

.withdraw_facial_keyTitle {
  font-size: 18px;
  font-weight: 600;
  color: #e8e8e8;
  margin: 8px 0 14px;
  text-align: left;
  letter-spacing: -0.45px;
}

body.light_theme .withdraw_facial_keyTitle {
  color: #111827;
}

.withdraw_facial_grid4 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px 24px;
  margin: 46px 0 45px;
  justify-items: center;
  text-align: center;
}

.withdraw_facial_gridItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.completed_header .withdraw_facial_bigKey {
  width: 100%;
}


.withdraw_facial_badge {
  width: 84px;
  height: auto;
  border-radius: 999px;
  /* border: 2px solid #e5e7eb; */
  /* background: radial-gradient(circle at 50% 50%, #d1d5db, #f3f4f6); */
  position: relative;
}

.withdraw_facial_badge::after {
  content: "";
  position: absolute;
  width: 46px;
  height: 2px;
  background: #9ca3af;
  transform: rotate(-35deg);
  top: 31px;
  left: 9px;
  opacity: 0.7;
}

.withdraw_facial_gridTxt {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.25;
  max-width: 200px;
}

.withdraw_facial_loadingTitle {
  font-size: 18px;
  font-weight: 800;
  color: #111827;
  text-align: center;
  margin-top: 10px;
}

.withdraw_facial_ring {
  width: 220px;
  height: 220px;
  border-radius: 999px;
  margin: 32px auto 24px;
  position: relative;
}

/* .withdraw_facial_ring::before,
.withdraw_facial_ring::after {
  content: "";
  position: absolute;
  width: 28px;
  height: 10px;
  border-radius: 999px;
  background: #d1aa67;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
}

.withdraw_facial_ring::after {
  top: auto;
  bottom: -10px;
} */

.withdraw_facial_ringInner {
  width: 100%;
  height: 100%;
  border-radius: 999px;
}

.withdraw_facial_bigKey {
  font-size: 32px;
  width: 70%;
  font-weight: 600;
  letter-spacing: -0.03em;
  color: #ececec;
  text-align: left;
  line-height: 1.05;
  margin: 8px 0 6px;
}

body.light_theme .withdraw_facial_bigKey {
  color: #111827;
}

.withdraw_confirm_overlay .withdraw_choose_back {
  padding: 0px;
}

.withdraw_facial_camActions {
  display: flex;
  gap: 12px;
  margin-top: 14px;
}

.withdraw_facial_result {
  text-align: center;
}

.withdraw_facial_timeoutHero {
  width: 160px;
  height: 160px;
  border-radius: 999px;
  margin: 10px auto 14px;
  background: #fff;
  border: none;
  box-shadow: 0px 0px 20px #0000001c;
  display: flex;
  align-items: center;
  justify-content: center;
}

.withdraw_facial_timeoutText {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.5;
  margin: 10px 0 16px;
}

.withdraw_facial_submitHero,
.withdraw_facial_successHero {
  width: 160px;
  height: 160px;
  border-radius: 999px;
  margin: 10px auto 14px;
  background: #fff;
  border: none;
  box-shadow: 0px 0px 20px #0000001c;
  display: flex;
  align-items: center;
  justify-content: center;
}

.withdraw_facial_successHero {
  background: none;
  box-shadow: none;
  width: auto;
  height: auto;
  margin-bottom: 0px;
}

.withdraw_facial_submitTitle {
  font-size: 24px;
  font-weight: 600;
  color: #f5f5f5;
  margin: 26px 0 10px;
}

body.light_theme .withdraw_facial_submitTitle {
  color: #111827;
}


@media (max-width: 767px) {
  .withdraw_whitelist_awaiting_notice {
    display: none;
  }

  .withdraw_passkey_subtext {
    font-size: 14px;
  }

  .withdraw_sec_modal,
  .withdraw_sec_confirm_modal,
  .withdraw_sec_req_modal {
    max-width: 100%;
    border-radius: 16px 16px 0px 0px;
    padding: 20px 20px 32px;
  }

  .withdraw_sec_title {
    font-size: 20px;
  }

  .withdraw_facial_name {
    font-size: 15px;
  }

  .withdraw_sec_item_title {
    font-size: 14px;
  }

  .withdraw_hist_detail_modal {
    width: 100%;
    max-width: 100%;
    border-radius: 16px 16px 0px 0px;
    padding: 20px;
  }

  .withdraw_sec_primary {
    padding: 12px 16px;
    font-size: 14px;
  }

  .withdraw_sec_confirm_hero {
    width: 150px;
    margin: 18px auto;
  }

  .withdraw_sec_confirm_title {
    max-width: 90%;
    font-size: 20px;
  }

  .withdraw_facial_modal {
    max-width: 100%;
    border-radius: 16px 16px 0px 0px;
    height: 80vh;
    display: flex;
    overflow: scroll;
    padding: 20px 20px 24px;
    flex-direction: column;
  }

  .withdraw_confirm_text {
    font-size: 14px;
  }

  .withdraw_facial_title {
    width: 90%;
    font-size: 20px;
  }

  .withdraw_facial_list {
    margin: 15px 0 12px;
  }

  .withdraw_facial_grid4 {
    margin: 24px 0 32px;
  }


  .withdraw_facial_bigKey {
    font-size: 20px;
    width: 100%;
  }

  .withdraw_facial_ring {
    width: 160px;
    height: auto;
  }

  .withdraw_facial_ringInner {
    width: 150px;
    margin: 0 auto;
    height: auto;
  }

  .d-flex.justify-space-between.gap-2.completed_header img {
    width: 100px;
  }

  .withdraw_facial_submitHero,
  .withdraw_facial_successHero {
    width: 140px;
    height: 140px;
  }

  .withdraw_facial_submitTitle {
    font-size: 20px;
  }

}

/* Address book (wallet \`/api/v1/wallet/address-book\`) */
.withdraw_ab_addr_hint,
.withdraw_ab_history_hint {
  font-size: 13px;
  color: #a5a7aa;
  line-height: 1.45;
}

body.light_theme .withdraw_ab_addr_hint,
body.light_theme .withdraw_ab_history_hint {
  color: #5d6470;
}

.withdraw_ab_saved_list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  margin-top: 8px;
}

.withdraw_ab_saved_row {
  border: 1px solid rgba(148, 163, 184, 0.35);
  border-radius: 10px;
  padding: 10px 12px;
  cursor: pointer;
  text-align: left;
  background: rgba(255, 255, 255, 0.04);
}

.withdraw_ab_saved_row:focus {
  outline: 2px solid rgba(172, 138, 80, 0.55);
  outline-offset: 2px;
}

.withdraw_ab_saved_row--pending {
  cursor: not-allowed;
  opacity: 0.92;
}

.withdraw_ab_status {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.45);
  color: #475569;
  background: rgba(248, 250, 252, 0.9);
}

.withdraw_ab_status--success {
  /* color: #0f766e;
  border-color: rgba(45, 212, 191, 0.45);
  background: rgba(240, 253, 250, 0.95); */
}

.withdraw_ab_status--pending {
  color: #b45309;
  /* border-color: rgba(251, 191, 36, 0.5);
  background: rgba(255, 251, 235, 0.95); */
}

.withdraw_ab_status--danger {
  color: #b91c1c;
  /* border-color: rgba(248, 113, 113, 0.45);
  background: rgba(254, 242, 242, 0.95); */
}

.withdraw_ab_status--info {
  color: green;
  /* border-color: rgba(96, 165, 250, 0.45);
  background: rgba(239, 246, 255, 0.95); */
}

.withdraw_ab_status--neutral {
  color: #64748b;
}

.withdraw_ab_hist_list {
  max-height: min(52vh, 420px);
  overflow-y: auto;
  padding-right: 2px;
}

.withdraw_ab_hist_meta {
  margin-top: 6px;
  font-size: 11px;
  color: #64748b;
  line-height: 1.35;
}

.withdraw_ab_saved_row_top {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: space-between;
}

.withdraw_ab_saved_label {
  font-weight: 600;
  font-size: 14px;
  color: #ffffff;
  flex: 1 1;
  min-width: 0;
}

body.light_theme .withdraw_ab_saved_label {
  color: #1e2329;
}

.withdraw_ab_saved_remove {
  border: none;
  background: transparent;
  color: #94a3b8;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  padding: 0 4px;
}

.withdraw_ab_saved_remove:hover {
  color: #515763;
}

.withdraw_ab_saved_addr_mono {
  /* font-family: ui-monospace, monospace; */
  font-size: 12px;
  margin-top: 6px;
  word-break: break-all;
  font-weight: 500;
}

.withdraw_ab_resume_mm_btn {
  display: inline-block;
  margin-top: 10px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 600;
  /* color: #b45309; */
  /* background: #fffbeb; */
  border: none;
  border-radius: 8px;
  cursor: pointer;
  /* width: 100%; */
  text-align: center;
}

.withdraw_ab_resume_mm_btn:hover {
  /* background: #fef3c7; */
}

.withdraw_verify_combined {
  max-height: min(90vh, 640px);
  overflow-y: auto;
}

.withdraw_verify_combined_spaced {
  margin-top: 14px;
}

/* KYC gate: column-scoped overlay only.
   Do not add .pm-restrictOverlay — App.js uses that selector for body.agce-modal-open, which sets
   header.sticky-top { pointer-events: none } and blocks the auth header. */
.dashboard_right.dashboard_right--kyc-gate {
  position: relative;
}

.dashboard_right.dashboard_right--kyc-gate .withdraw-kyc-gate-overlay {
  position: fixed;
  inset: 0;
  z-index: 999999;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

body.light_theme .dashboard_right.dashboard_right--kyc-gate .withdraw-kyc-gate-overlay {
  background-color: rgba(255, 255, 255, 0.2);
}

@media (max-width: 767px) {

  /*
   * Fixed = viewport (see comment on desktop block). z-index must stay:
   * - below \`.profile-sidebar-shell.leftside_menu\` drawer (10080) so the open rail appears above this modal
   * - below \`.mobile_view.asset-sidebar-toggle\` (999999)
   * - above normal page / sticky header (~1020–1040)
   */
  .dashboard_right.dashboard_right--kyc-gate .withdraw-kyc-gate-overlay {
    position: fixed;
    inset: 0;
    width: 100vw;
    max-width: 100vw;
    min-height: 100vh;
    min-height: 100dvh;
    z-index: 10050;
    align-items: end;
    justify-content: center;
    padding: 0px;
    box-sizing: border-box;
  }

  .dashboard_right.dashboard_right--kyc-gate .withdraw-kyc-gate-overlay .pm-restrictModal {
    max-height: min(90dvh, calc(100dvh - 24px));
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    width: 100%;
    max-width: 100%;
    margin: 0;
  }
}

/* KYC gate on withdraw — .pm-restrictModal* from changeLoginPassword.css; tweak primary CTA */
.withdraw-kyc-gate-modal--loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  min-width: min(320px, 92vw);
  padding: 28px 24px;
}

.withdraw-kyc-gate-modal--loading::before {
  content: "";
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 3px solid rgba(17, 24, 39, 0.12);
  border-top-color: #2d2e32;
  animation: withdraw-kyc-gate-spin 0.75s linear infinite;
  flex-shrink: 0;
}

@keyframes withdraw-kyc-gate-spin {
  to {
    transform: rotate(360deg);
  }
}

.withdraw-kyc-gate-loading__text {
  font-size: 15px;
  line-height: 1.5;
  font-weight: 600;
  color: #fff;
  text-align: center;
}

body.light_theme .withdraw-kyc-gate-loading__text {
  color: #111827;
}

.withdraw-kyc-gate-modal--single .pm-restrictModal__actions {
  justify-content: center;
}

.withdraw-kyc-gate-modal {
  background-color: rgb(24 26 32 / 30%) !important;
}

body.light_theme .withdraw-kyc-gate-modal {
  background-color: rgb(255 255 255 / 30%) !important;
}

.withdraw-kyc-modal__cta.pm-restrictModal__confirm {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  box-sizing: border-box;
}

.withdraw-kyc-modal__cta--solo.pm-restrictModal__confirm {
  flex: 0 1 auto;
  min-width: min(280px, 100%);
  max-width: 100%;
}

.withdraw-kyc-modal__link {
  color: #fff;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;
}

body.light_theme .withdraw-kyc-modal__link {
  color: #111827;
}

.withdraw-kyc-modal__link:hover {
  color: #2d2e32;
}

/* —— Withdraw page: recent withdrawal history uses same table/card chrome as Deposit history (see depositPage.css) —— */
.depositcrypto_lft .deposit_history_section .withdraw_recent_tabs {
  margin-bottom: 12px;
}

.depositcrypto_lft .deposit_history_top .withdraw_history_top_actions {
  display: flex;
  align-items: center;
  gap: 14px 20px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.depositcrypto_lft .deposit_history_table_wrap {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  min-width: 0;
}

.depositcrypto_lft .deposit_history_body_wrap {
  min-width: 0;
  background: #fff;
}

.depositcrypto_lft .deposit_history_head_wrap {
  overflow: visible;
}

.depositcrypto_lft .deposit_history_head {
  display: grid;
  grid-template-columns: 1.05fr 1.25fr 0.9fr 0.95fr 1.55fr 1.55fr 0.75fr;
  gap: 8px;
  align-items: center;
}

.depositcrypto_lft .deposit_history_head,
.depositcrypto_lft .deposit_history_row {
  min-width: 1240px;
}

.depositcrypto_lft .deposit_history_head_cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.depositcrypto_lft .deposit_history_row {
  display: grid;
  grid-template-columns: 1.05fr 1.25fr 0.9fr 0.95fr 1.55fr 1.55fr 0.75fr;
  gap: 8px;
  padding: 12px 0;
  border-top: 1px solid #eaecf0;
  font-size: 13px;
  font-weight: 500;
  color: #101828;
  line-height: 1.3;
  align-items: start;
  box-sizing: border-box;
}

.depositcrypto_lft .deposit_history_row_cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.depositcrypto_lft .deposit_history_row_cell--action {
  text-transform: capitalize;
}

.depositcrypto_lft .deposit_history_trunc {
  display: inline-block;
  vertical-align: middle;
  max-width: calc(100% - 72px);
}

.depositcrypto_lft .deposit_history_copy_btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  border: 1px solid rgba(148, 163, 184, 0.45);
  background: #f8fafc;
  color: #334155;
  cursor: pointer;
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease,
    transform 0.05s ease;
  padding: 0;
  line-height: 1;
}

.depositcrypto_lft .deposit_history_copy_btn:hover {
  background: #eef2ff;
  border-color: rgba(99, 102, 241, 0.55);
  color: #3730a3;
}

.depositcrypto_lft .deposit_history_copy_btn:active {
  transform: translateY(0.5px);
}

.depositcrypto_lft .deposit_history_copy_btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.25);
}

.depositcrypto_lft .deposit_history_copy_btn.deposit_history_explorer_link {
  text-decoration: none;
}

.depositcrypto_lft .deposit_history_copy_btn .withdraw_hist_icon_svg {
  width: 14px;
  height: 14px;
}

.depositcrypto_lft .deposit_history_action_badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  border: 1px solid transparent;
  white-space: nowrap;
  line-height: 1;
}

.depositcrypto_lft .deposit_history_action_badge.is-success {
  background: #ecfdf3;
  border-color: #a7f3d0;
  color: #067647;
}

.depositcrypto_lft .deposit_history_action_badge.is-pending {
  background: #fffbeb;
  border-color: #fde68a;
  color: #92400e;
}

.depositcrypto_lft .deposit_history_action_badge.is-danger {
  background: #fef2f2;
  border-color: #fecaca;
  color: #b42318;
}

.depositcrypto_lft .deposit_history_action_badge.is-info {
  background: #eff6ff;
  border-color: #bfdbfe;
  color: #1d4ed8;
}

.depositcrypto_lft .deposit_history_action_badge.is-neutral {
  background: #f1f5f9;
  border-color: #e2e8f0;
  color: #334155;
}

body:not(.light_theme) .depositcrypto_lft .deposit_history_copy_btn {
  background: #1f2937;
  border-color: rgba(148, 163, 184, 0.35);
  color: #e2e8f0;
}

body:not(.light_theme) .depositcrypto_lft .deposit_history_copy_btn:hover {
  background: rgba(59, 130, 246, 0.18);
  border-color: rgba(59, 130, 246, 0.45);
  color: #bfdbfe;
}

body:not(.light_theme) .depositcrypto_lft .deposit_history_action_badge.is-neutral {
  background: rgba(148, 163, 184, 0.12);
  border-color: rgba(148, 163, 184, 0.22);
  color: #e2e8f0;
}

.depositcrypto_lft .deposit_history_mobile {
  display: none;
}

.deposit_hist_mobile_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 6px;
}

.deposit_hist_mobile_date {
  font-size: 13px;
  font-weight: 600;
  color: #eaecef;
}

body.light_theme .deposit_hist_mobile_date {
  color: #101828;
}

.deposit_hist_mobile_row--actions .value {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  max-width: 72%;
  text-align: right;
}

@media (max-width: 991.98px) {
  .depositcrypto_lft .deposit_history_desktop {
    display: none !important;
  }

  .depositcrypto_lft .deposit_history_mobile {
    display: block !important;
  }

  .depositcrypto_lft .deposit_history_table_wrap {
    overflow-x: visible;
  }
}

.withdraw-save-country__control {
  background-color: #f5f6f715 !important;
  border: none !important;
}

body.light_theme .withdraw-save-country__control {
  background-color: #f5f6f7 !important;
}

.withdraw-save-country__single-value {
  color: #f3f3f3 !important;
}

body.light_theme .withdraw-save-country__single-value {
  color: #0f172a !important;
}

.withdraw-save-country__menu {
  background-color: #2f3031 !important;
  border: 1px solid #e4e4e40d !important;
}

body.light_theme .withdraw-save-country__menu {
  background-color: #fff !important;
  border: 1px solid #e4e4e4 !important;
}

.withdraw-save-country__option {
  background-color: transparent !important;
  color: #dedede !important;
}

.withdraw-save-country__option--is-focused {
  background-color: #f4f5f70a !important;
}

body.light_theme .withdraw-save-country__option {
  color: #1a1d21 !important;
}

body.light_theme .withdraw-save-country__option--is-focused {
  background-color: #F0F2F4 !important;
}

.withdraw-save-country__option--is-selected {
  background-color: #f1f5f90a !important;
  color: #fff !important;
}

body.light_theme .withdraw-save-country__option--is-selected {
  background-color: #f1f5f9 !important;
  color: #0f172a !important;
}

/* --- Dark Theme Fixes for Withdraw History Detail Modal --- */

.withdraw_hist_detail_modal {
  background: rgba(30, 41, 59, 0.45) !important;
  border-color: rgba(255, 255, 255, 0.08) !important;
  color: #e2e8f0;
}

body.light_theme .withdraw_hist_detail_modal {
  background: rgb(255 255 255 / 40%) !important;
  border-color: #e8e8e8 !important;
  color: #0f172a;
}

.withdraw_hist_detail_title {
  color: #f1f5f9;
}

body.light_theme .withdraw_hist_detail_title {
  color: #0f172a;
}

.withdraw_hist_rows {
  border-top-color: rgba(255, 255, 255, 0.08);
}

body.light_theme .withdraw_hist_rows {
  border-top-color: #eceff3;
}

.withdraw_hist_row_label {
  color: #94a3b8;
}

body.light_theme .withdraw_hist_row_label {
  color: #707a8a;
}

.withdraw_hist_row_value {
  color: #e2e8f0;
}

body.light_theme .withdraw_hist_row_value {
  color: #303236;
}

.withdraw_hist_step_title {
  color: #f8fafc;
}

body.light_theme .withdraw_hist_step_title {
  color: #1e293b;
}

.withdraw_hist_step_time,
.withdraw_hist_step_note,
.withdraw_hist_step_sub {
  color: #94a3b8;
}

body.light_theme .withdraw_hist_step_time,
body.light_theme .withdraw_hist_step_note,
body.light_theme .withdraw_hist_step_sub {
  color: #64748b;
}

.withdraw_hist_icon_btn {
  background: rgba(255, 255, 255, 0.1);
  color: #cbd5e1;
}

body.light_theme .withdraw_hist_icon_btn {
  background: #F3F4F6;
  color: #6c6c6c;
}

body.dark_theme .dark_theme_white_icons_popup .withdraw_sec_req_left img {
  filter: brightness(0) invert(1);
}

body:not(.light_theme) .dark_theme_white_icons_popup .withdraw_sec_req_left img {
  filter: brightness(0) invert(1);
}


@media screen and (max-width:580px) {

  .withdraw_hist_row {
    font-size: 12px;
  }

  .withdraw_hist_rows {
    gap: 15px;
  }


}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/WithdrawPage/withdrawal.css"],"names":[],"mappings":"AAAA,+DAA+D;;AAE/D,4DAA4D;AAC5D;EACE,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qDAAqD;EACrD,cAAc;EACd,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iEAAiE;AACjE;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,+BAA+B;EAC/B,UAAU;EACV,qCAAqC;EACrC,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,6BAA6B;EAC7B,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,qCAAqC;AACrC;;EAEE,gCAAgC;EAChC,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;EAEE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA,qDAAqD;AACrD;;EAEE,gCAAgC;AAClC;;AAEA,yDAAyD;AACzD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,0CAA0C;EAC1C,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA,yCAAyC;AACzC;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,sDAAsD;AACtD;EACE;;mBAEiB;AACnB;;AAEA;;GAEG;;AAEH,wBAAwB;AACxB;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,QAAQ;EACR,qCAAqC;EACrC,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;qFAEqF;AACrF;EACE,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;;GAEG;;AAEH,6BAA6B;AAC7B;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,2CAA2C;EAC3C,2CAA2C;EAC3C,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,gCAAgC;AAChC;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,2CAA2C;EAC3C,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;IACvB,gCAAgC;IAChC,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;;IAEE,eAAe;EACjB;;AAEF;;AAEA,iCAAiC;AACjC;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,2CAA2C;EAC3C,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,4CAA4C;AAC5C;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,2CAA2C;EAC3C,oBAAoB;EACpB,kBAAkB;EAClB,2CAA2C;EAC3C,qBAAqB;EACrB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE;IACE,oBAAoB;IACpB,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;;EAGA;IACE,qBAAqB;IACrB,eAAe;EACjB;;AAEF;;AAEA,qCAAqC;AACrC;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,2CAA2C;EAC3C,qBAAqB;EACrB,0BAA0B;EAC1B,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA,gCAAgC;AAChC;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,0CAA0C;EAC1C,oBAAoB;EACpB,kBAAkB;EAClB,2CAA2C;EAC3C,qBAAqB;EACrB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA,+BAA+B;AAC/B;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,2CAA2C;EAC3C,qBAAqB;EACrB,0BAA0B;EAC1B,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA,8BAA8B;AAC9B;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,2CAA2C;EAC3C,qBAAqB;EACrB,0BAA0B;EAC1B,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,2CAA2C;EAC3C,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;;;GAGG;;AAEH;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE;IACE,uBAAuB;IACvB,gCAAgC;IAChC,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;;EAGA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;IAChC,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,kCAAkC;EAClC,0CAA0C;EAC1C,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;IACvB,gCAAgC;IAChC,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,uBAAuB;IACvB,gCAAgC;IAChC,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA,uBAAuB;AACvB;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,qCAAqC;EACrC,0BAA0B;EAC1B,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;;;EAKE,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;;;EAGE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;;EAIE,uDAAuD;EACvD,2CAA2C;EAC3C,yDAAiD;EAAjD,iDAAiD;AACnD;;AAEA;;;;EAIE,uDAAuD;EACvD,0DAA0D;EAC1D,2CAA2C;EAC3C,yDAAiD;EAAjD,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,UAAU;EACV,WAAW;EACX,+BAA+B;EAC/B,gCAAgC;EAChC,yCAAyC;EACzC,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,qBAAqB;EACrB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,8CAA8C;EAC9C,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,SAAS;EACT,SAAO;EACP,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,YAAY;;EAEd;;;;EAIA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA,qDAAqD;AACrD;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,2CAA2C;EAC3C,qBAAqB;EACrB,0BAA0B;EAC1B,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;;AAEvB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE;IACE,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,gCAAgC;IAChC,eAAe;EACjB;AACF;;AAEA,oFAAoF;AACpF;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,oDAAoD;EACpD,sBAAsB;EACtB,gBAAgB;EAChB,iCAAiC;EACjC,2CAA2C;EAC3C,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,SAAO;EACP,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;;GAEG;;AAEH,gBAAgB;AAChB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;;GAGG;;AAEH;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;GAEG;;AAEH;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA,4FAA4F;AAC5F;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,sFAAsF;AACtF;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iDAAiD;EACjD,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;;GAEG;;AAEH;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,+BAA+B;EAC/B,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;EAC1B,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd;;uBAEqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;;AAEvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;;AAGA;;EAEE;IACE,gBAAgB;IAChB;EACF;;EAEA;IACE,uBAAuB;IACvB,gCAAgC;IAChC,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;AAEF;;;AAGA;;;EAGE;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;AAEF;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;AACpB;;AAEA,qFAAqF;AACrF;;;;;;;;EAQE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;;;;;;;;EAQE,cAAc;AAChB;;AAEA;;;;;EAKE,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;;;;;EAKE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;;;;;EAKE,uBAAuB;EACvB,8CAA8C;EAC9C,aAAa;AACf;;AAEA;;;EAGE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,qBAAqB;EACrB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;;;EAGE,yBAAyB;EACzB,wCAAwC;EACxC,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,yDAAgE;EAChE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,yDAAgE;EAChE,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,SAAO;EACP,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,qBAAqB;EACrB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,qCAAqC;EACrC,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,+BAA+B;EAC/B,sEAAsE;EACtE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,SAAS;EACT,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;GAgBG;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,eAAe;IACf,gCAAgC;IAChC,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gCAAgC;IAChC,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;;EAGA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA,wDAAwD;AACxD;;EAEE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,2CAA2C;EAC3C,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE;;0CAEwC;AAC1C;;AAEA;EACE,cAAc;EACd;0CACwC;AAC1C;;AAEA;EACE,cAAc;EACd;0CACwC;AAC1C;;AAEA;EACE,YAAY;EACZ;0CACwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;2EAE2E;AAC3E;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,eAAe;EACf,0BAA0B;EAC1B,kCAAkC;EAClC,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;EAEE;;;;;IAKE;EACF;IACE,eAAe;IACf,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,2CAA2C;IAC3C,gBAAgB;IAChB,iCAAiC;IACjC,WAAW;IACX,eAAe;IACf,SAAS;EACX;AACF;;AAEA,8FAA8F;AAC9F;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,yBAAyB;EACzB,uDAAuD;EACvD,cAAc;AAChB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,wHAAwH;AACxH;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sEAAsE;EACtE,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sEAAsE;EACtE,QAAQ;EACR,eAAe;EACf,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf;;;;wBAIsB;EACtB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,QAAQ;EACR,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,+DAA+D;;AAE/D;EACE,6CAA6C;EAC7C,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,6CAA6C;EAC7C,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;;AAGA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;;AAGF","sourcesContent":["/* Withdraw page — popup styles (moved from global style.css) */\n\n/* Coin thumbnails (Select coin + modal list + quick pick) */\n.withdraw-coin-thumb__img {\n  border-radius: 999px;\n  object-fit: cover;\n  display: block;\n  background: #e2e8f0;\n}\n\n.withdraw-coin-thumb__placeholder {\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  background: linear-gradient(140deg, #94a3b8, #64748b);\n  color: #f8fafc;\n  line-height: 1;\n  user-select: none;\n}\n\nbody:not(.light_theme) .withdraw-coin-thumb__img {\n  background: #334155;\n}\n\n/* —— Stepper rail: match deposit (clamp to last step badge) —— */\n.deposit_crypto_left {\n  position: relative;\n}\n\n.withdraw-stepper-rail.deposit-stepper-rail {\n  position: absolute;\n  left: 14px;\n  top: var(--rail-top, 0px);\n  height: var(--rail-height, 0px);\n  width: 2px;\n  background: rgba(148, 163, 184, 0.28);\n  border-radius: 999px;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: 0;\n}\n\n.withdraw-stepper-rail .deposit-stepper-rail__fill {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: var(--rail-fill, 0px);\n  background: #fff;\n  border-radius: 999px;\n  transition: height 220ms ease;\n}\n\nbody.light_theme .withdraw-stepper-rail .deposit-stepper-rail__fill {\n  background: #0b0b0b;\n}\n\n/* Inline field errors */\n.withdraw_inline_error {\n  margin-top: 6px;\n  font-size: 12px;\n  color: #f04438;\n  font-weight: 600;\n  line-height: 1.25;\n}\n\n.withdraw_inline_loader {\n  margin-top: 6px;\n  font-size: 12px;\n  color: #6b7280;\n  font-weight: 600;\n  line-height: 1.25;\n}\n\n.withdraw_amt_meta_value {\n  font-weight: 600;\n}\n\n.kycemail-phone_popup .withdraw_confirm_overlay.withdraw_sec_overlay .withdraw_sec_list {\n  gap: 12px;\n}\n\nbody:not(.light_theme) .withdraw_inline_error {\n  color: #f04438;\n}\n\nbody:not(.light_theme) .withdraw_inline_loader {\n  color: #9ca3af;\n}\n\n/* Danger input border when invalid */\n.withdraw_amt_field input[aria-invalid=\"true\"],\n.user_address_fill .addressfill input[aria-invalid=\"true\"] {\n  border-color: #f04438 !important;\n  box-shadow: none !important;\n  background: none;\n}\n\nbody:not(.light_theme) .withdraw_amt_field input[aria-invalid=\"true\"],\nbody:not(.light_theme) .user_address_fill .addressfill input[aria-invalid=\"true\"] {\n  border-color: #f04438 !important;\n  box-shadow: none !important;\n}\n\n/* Outer wrapper border on error (match screenshot) */\n.withdraw_amt_field.has-error,\n.user_address_fill.has-error {\n  border-color: #f04438 !important;\n}\n\n/* 24h limit: remaining / cap with danger cap + tooltip */\n.withdraw_amt_nums {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.withdraw_limit_left {\n  color: inherit;\n  font-weight: 600;\n}\n\n.withdraw_limit_sep {\n  opacity: 0.7;\n}\n\n.withdraw_limit_right {\n  color: #f04438;\n  font-weight: 700;\n}\n\n.withdraw_limit_info_wrap {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n\n.withdraw_limit_info_btn {\n  width: 16px;\n  height: 16px;\n  border-radius: 999px;\n  border: 1px solid rgba(152, 162, 179, 0.7);\n  background: transparent;\n  color: #667085;\n  font-size: 11px;\n  line-height: 1;\n  font-weight: 800;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  cursor: pointer;\n}\n\n.withdraw_limit_tooltip {\n  position: absolute;\n  right: 0;\n  top: calc(100% + 10px);\n  min-width: 260px;\n  max-width: 320px;\n  background: #3a3a3a;\n  color: #fff;\n  border-radius: 10px;\n  padding: 10px 12px;\n  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.25);\n  z-index: 20;\n}\n\n.withdraw_limit_tip_text {\n  font-size: 12px;\n  line-height: 1.35;\n  color: rgba(255, 255, 255, 0.92);\n  font-weight: 500;\n}\n\n.withdraw_limit_tip_link {\n  margin-top: 8px;\n  background: transparent;\n  border: none;\n  padding: 0;\n  color: #fbbf24;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  text-align: left;\n}\n\n/* Disabled icon links in history details */\n.withdraw_hist_icon_link.is-disabled {\n  opacity: 0.45;\n  pointer-events: none;\n}\n\n/* Min withdraw hint under amount input */\n.withdraw_min_hint {\n  margin-top: 6px;\n  font-size: 12px;\n  color: #94a3b8;\n  line-height: 1.3;\n}\n\nbody.light_theme .withdraw_min_hint {\n  color: #667085;\n}\n\nbody:not(.light_theme) .withdraw_min_hint strong {\n  color: #e2e8f0;\n}\n\n/* Selected coin highlight (quick pick + modal list) */\n.coin_items_list.is-selected {\n  /* background: #064e3b;\n  border: 1px solid rgba(52, 211, 153, 0.9);\n  color: #a7f3d0; */\n}\n\n/* body.light_theme .coin_items_list.is-selected {\n  border: 1px solid #9aa1af;\n} */\n\n/* Modal row selection */\n.modal.search_coin tr.is-selected td {\n  background: none;\n}\n\n.modal.search_coin tr.is-selected {\n  background: rgb(43 47 58 / 18%);\n  border: none;\n}\n\nbody.light_theme .modal.search_coin tr.is-selected {\n  background: rgb(43 47 58);\n}\n\n/* Shared overlay */\n.withdraw_confirm_overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.20);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 18px;\n  z-index: 99999999;\n}\n\nbody.light_theme .withdraw_confirm_overlay {\n  background-color: rgb(255 255 255 / 20%);\n}\n\n/* Passkey must sit above other withdraw overlays and security_verification_unavailable\n   (.withdraw_sec_overlay is 100000020). The :has() rule is more specific than a single class,\n   so this value must stay above that overlay or Verify with Passkey never appears. */\n.withdraw_confirm_overlay:has(.withdraw_passkey_modal) {\n  z-index: 100000030;\n}\n\n/* Shared close button */\n.withdraw_confirm_close {\n  position: absolute;\n  top: 14px;\n  right: 16px;\n  z-index: 10;\n  width: 36px;\n  height: 36px;\n  border: none;\n  background: transparent;\n  color: #e7e7e7;\n  font-size: 28px;\n  line-height: 1;\n  cursor: pointer;\n  border-radius: 10px;\n  pointer-events: auto;\n}\n\nbody.light_theme .withdraw_confirm_close {\n  color: #111827;\n}\n\n/* .withdraw_confirm_close:hover {\n  background: rgba(17, 24, 39, 0.05);\n} */\n\n/* 1) Network warning popup */\n.withdraw_confirm_modal {\n  width: 489px;\n  max-width: 92vw;\n  border-radius: 18px;\n  padding: 30px;\n  position: relative;\n  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.18);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: #1a1a1a69;\n}\n\nbody.light_theme .withdraw_confirm_modal {\n  background: rgb(255 255 255 / 20%);\n  border: 1px solid #e1e1e1;\n}\n\n.withdraw_confirm_icon {\n  display: flex;\n  justify-content: center;\n  margin: 6px 0 14px;\n}\n\n.withdraw_confirm_envelope {\n  max-width: 120px;\n  margin-top: -20px;\n}\n\n.withdraw_confirm_text {\n  max-width: 100%;\n  margin: 0 auto;\n  text-align: left;\n  font-size: 15px;\n  line-height: 1.65;\n  color: #d8d8d8;\n  font-weight: 500;\n}\n\nbody.light_theme .withdraw_confirm_text {\n  color: #101828;\n}\n\n.withdraw_ab_delete_confirm_title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #111827;\n  margin: 0 40px 10px 0;\n  line-height: 1.3;\n}\n\n.withdraw_confirm_actions {\n  display: flex;\n  gap: 9px;\n  justify-content: center;\n  margin-top: 22px;\n}\n\n.withdraw_confirm_btn {\n  min-width: auto;\n  height: 46px;\n  border-radius: 999px;\n  font-size: 14px;\n  font-weight: 500;\n  border: none;\n  cursor: pointer;\n  padding: 0 20px;\n}\n\n.withdraw_confirm_btn--ghost {\n  background: #e5e7eb;\n  color: #374151;\n  width: 130px;\n}\n\n.withdraw_confirm_btn--primary {\n  width: 100%;\n  background: #2f3138;\n  color: #fff;\n}\n\n.withdraw_verify_reminder_modal .withdraw_verify_reminder_title {\n  font-size: 22px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 36px 14px 0;\n  line-height: 1.25;\n  letter-spacing: -0.02em;\n}\n\nbody.light_theme .withdraw_verify_reminder_modal .withdraw_verify_reminder_title {\n  color: #111827;\n}\n\n.withdraw_verify_reminder_text {\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.65;\n  color: #374151;\n  font-weight: 500;\n}\n\n@media (max-width: 520px) {\n  .withdraw_confirm_modal {\n    padding: 20px 18px 18px;\n    border-radius: 16px;\n  }\n\n  .withdraw_confirm_actions {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .withdraw_confirm_btn {\n    width: 100%;\n    min-width: 0;\n  }\n}\n\n/* 2) Withdrawal summary popup */\n.withdraw_summary_modal {\n  width: 606px;\n  max-width: 92vw;\n  border-radius: 18px;\n  border: 1px solid #e1e1e121;\n  background: #1a1a1a69;\n  padding: 30px;\n  position: relative;\n  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.18);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n}\n\nbody.light_theme .withdraw_summary_modal {\n  border: 1px solid #e1e1e1;\n  background: rgb(255 255 255 / 20%);\n}\n\n.withdraw_summary_title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #e2e2e2;\n  margin-bottom: 12px;\n}\n\nbody.light_theme .withdraw_summary_title {\n  color: #111827;\n}\n\n.withdraw_summary_grid {\n  width: 100%;\n}\n\n.withdraw_summary_row {\n  display: grid;\n  grid-template-columns: 140px 1fr;\n  gap: 16px;\n  padding: 10px 0;\n}\n\n.withdraw_summary_k {\n  color: #f8f8f8;\n  font-size: 16px;\n  font-weight: 500;\n}\n\nbody.light_theme .withdraw_summary_k {\n  color: #000;\n}\n\nbody.light_theme .withdraw_summary_v {\n  color: #303236;\n}\n\n.withdraw_summary_v {\n  color: #dfdfdf;\n  font-size: 16px;\n  font-weight: 500;\n  text-align: right;\n  word-break: break-all;\n}\n\n.withdraw_summary_notes {\n  margin-top: 14px;\n  padding-top: 14px;\n  border-top: 1px solid #e7e7e7;\n}\n\nbody.light_theme .withdraw_summary_note {\n  color: #6a7282;\n}\n\n.withdraw_summary_note {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  color: #e1e1e1;\n  font-size: 13px;\n  line-height: 1.5;\n  padding: 6px 0;\n}\n\n.withdraw_summary_continue {\n  width: 100%;\n  margin-top: 22px;\n  border-radius: 999px;\n  border: none;\n  padding: 13px 15px;\n  background: #303236;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.withdraw_summary_continue:hover {\n  background: #24262c;\n}\n\n@media (max-width: 767px) {\n  .withdraw_summary_modal {\n    padding: 20px 20px 32px;\n    border-radius: 16px 16px 0px 0px;\n    max-width: 100%;\n  }\n\n  .withdraw_summary_title {\n    font-size: 20px;\n  }\n\n  .withdraw_summary_row {\n    grid-template-columns: 100px 1fr;\n  }\n\n  .withdraw_summary_k,\n  .withdraw_summary_v {\n    font-size: 13px;\n  }\n\n}\n\n/* 3) Verify with passkey popup */\n.withdraw_passkey_modal {\n  width: 606px;\n  max-width: 100%;\n  border-radius: 18px;\n  padding: 24px 26px 0;\n  position: relative;\n  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.18);\n  background: #1e202670;\n  border: 1px solid #e1e1e11a;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n}\n\nbody.light_theme .withdraw_passkey_modal {\n  background: rgb(255 255 255 / 20%);\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);\n  border: 1px solid #e1e1e1;\n}\n\n.withdraw_passkey_title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #dedede;\n  margin-bottom: 14px;\n}\n\nbody.light_theme .withdraw_passkey_title {\n  color: #101828;\n}\n\n.withdraw_passkey_hero {\n  display: flex;\n  justify-content: center;\n  margin: 30px auto;\n  max-width: 180px;\n  margin-bottom: 40px;\n}\n\n.withdraw_passkey_hero img {\n  max-width: 260px;\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.withdraw_passkey_text {\n  font-size: 18px;\n  color: #d8d8d8;\n  font-weight: 500;\n  margin: 10px 0 6px;\n  letter-spacing: -0.5px;\n}\n\n.withdraw_passkey_subtext {\n  font-size: 16px;\n  color: #d7d7d7;\n  font-weight: 400;\n  letter-spacing: -0.5px;\n  margin: 7px 0px 20px;\n}\n\nbody.light_theme .withdraw_passkey_subtext {\n  color: #343434;\n}\n\nbody.light_theme .withdraw_passkey_text {\n  color: #6A7282;\n}\n\n.withdraw_passkey_verify {\n  width: 100%;\n  /* height: 54px; */\n  border-radius: 999px;\n  padding: 13px 15px;\n  border: none;\n  background: #303236;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.withdraw_passkey_link {\n  display: block;\n  width: -moz-fit-content;\n  width: fit-content;\n  margin: 24px auto 30px;\n  border: none;\n  background: none;\n  letter-spacing: -0.5px;\n  color: #AC8A50;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.withdraw_passkey_footer {\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  padding: 20px 0;\n  text-align: center;\n  font-weight: 500;\n  color: #9ca3af;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\nbody.light_theme .withdraw_passkey_footer {\n  border-top: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.withdraw_passkey_footer img {\n  width: 18px;\n  height: 18px;\n  display: block;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n@media (max-width: 520px) {\n  .withdraw_passkey_modal {\n    padding: 18px 18px 0;\n  }\n\n  .withdraw_passkey_title {\n    font-size: 20px;\n  }\n\n  .withdraw_passkey_text {\n    font-size: 15px;\n  }\n}\n\n/* 4) Authenticator App Verification popup */\n.withdraw_auth_modal {\n  width: 539px;\n  max-width: 100%;\n  border-radius: 18px;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  padding: 24px 26px 0;\n  position: relative;\n  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.50);\n  background: #181a2087;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n}\n\nbody.light_theme .withdraw_auth_modal {\n  border: 1px solid #e1e1e1;\n  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.80);\n  background: rgb(255 255 255 / 20%);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n}\n\n.withdraw_facial_left img {\n  filter: invert(1);\n}\n\nbody.light_theme .withdraw_facial_left img {\n  filter: invert(0);\n}\n\n.withdraw_facial_item i {\n  color: #ffffff;\n}\n\nbody.light_theme .withdraw_facial_item i {\n  color: #101828;\n}\n\n.withdraw_auth_title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #ffffff;\n  margin-bottom: 10px;\n}\n\nbody.light_theme .withdraw_auth_title {\n  color: #101828;\n}\n\n.withdraw_auth_subtitle {\n  font-size: 16px;\n  color: #d1d1d1;\n  font-weight: 500;\n  letter-spacing: -0.5px;\n  line-height: 1.45;\n  margin-bottom: 18px;\n}\n\nbody.light_theme .withdraw_auth_subtitle {\n  color: #6A7282;\n}\n\n.withdraw_auth_label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #9ca3af;\n  margin: 11px 0px 7px;\n}\n\nbody.light_theme .withdraw_auth_label {\n  color: #303236;\n}\n\n.withdraw_auth_input_row {\n  width: 100%;\n  position: relative;\n}\n\n.withdraw_auth_input_row input {\n  width: 100%;\n  height: 50px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.05);\n  padding: 0 84px 0 14px;\n  font-size: 14px;\n  color: #ffffff;\n  outline: none;\n  box-sizing: border-box;\n}\n\nbody.light_theme .withdraw_auth_input_row input {\n  border: 1px solid #E4E4E4;\n  background: #fff;\n  color: #303236;\n}\n\n.withdraw_auth_paste {\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  border: none;\n  background: none;\n  color: #AC8A50;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.withdraw_fund_password_toggle {\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  border: none;\n  background: none;\n  padding: 4px;\n  color: #9ca3af;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  line-height: 1;\n}\n\nbody.light_theme .withdraw_fund_password_toggle {\n  color: #6a7282;\n}\n\n.withdraw_fund_password_toggle:hover {\n  color: #ffffff;\n}\n\nbody.light_theme .withdraw_fund_password_toggle:hover {\n  color: #303236;\n}\n\n.withdraw_auth_submit {\n  width: 100%;\n  border-radius: 999px;\n  padding: 13px 15px;\n  border: none;\n  background: #303236;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  margin-top: 30px;\n}\n\n.withdraw_auth_link {\n  display: block;\n  width: -moz-fit-content;\n  width: fit-content;\n  margin: 32px auto 0px;\n  border: none;\n  background: none;\n  letter-spacing: -0.5px;\n  color: #AC8A50;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.withdraw_auth_link+.withdraw_auth_link {\n  margin-top: 0px;\n}\n\n.gapbtn_space {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.withdraw_auth_footer {\n  margin-top: 22px;\n}\n\n@media (max-width: 767px) {\n\n  .withdraw_auth_modal {\n    padding: 18px 18px 0;\n    border-radius: 16px 16px 0px 0px;\n  }\n\n  .withdraw_auth_submit {\n    margin-top: 20px;\n  }\n\n  .withdraw_auth_title {\n    font-size: 20px;\n    width: 90%;\n  }\n\n  .withdraw_auth_subtitle {\n    font-size: 14px;\n  }\n\n  .withdraw_auth_label {\n    font-size: 14px;\n  }\n\n\n  .withdraw_auth_link {\n    margin: 18px auto 0px;\n    font-size: 15px;\n  }\n\n}\n\n/* 5) Choose an Authenticator popup */\n.withdraw_choose_modal {\n  width: 539px;\n  max-width: 100%;\n  border-radius: 18px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 18px 22px 22px;\n  position: relative;\n  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.50);\n  background: #181a2087;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  min-height: 520px;\n}\n\nbody.light_theme .withdraw_choose_modal {\n  background: rgb(255 255 255 / 20%);\n  border: 1px solid #e1e1e1;\n  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.18);\n}\n\n/* 6) Email Verification popup */\n.withdraw_email_modal {\n  width: 539px;\n  max-width: 100%;\n  border-radius: 18px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 24px 26px 0;\n  position: relative;\n  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.50);\n  background: #181a2087;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n}\n\nbody.light_theme .withdraw_email_modal {\n  border: 1px solid #e1e1e1;\n  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.18);\n  background: rgb(255 255 255 / 20%);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n}\n\n/* 7) Awaiting Approval popup */\n.withdraw_await_modal {\n  width: 606px;\n  max-width: 92vw;\n  border-radius: 18px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 24px 26px 26px;\n  position: relative;\n  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.50);\n  background: #181a2087;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  text-align: center;\n}\n\nbody.light_theme .withdraw_await_modal {\n  border: 1px solid #e1e1e1;\n  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.18);\n  background: rgb(255 255 255 / 20%);\n}\n\n/* 8) Recipient Amount popup */\n.withdraw_recipient_modal {\n  width: 606px;\n  max-width: 92vw;\n  border-radius: 18px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 28px 30px 24px;\n  position: relative;\n  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.50);\n  background: #181a2087;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  text-align: center;\n}\n\nbody.light_theme .withdraw_recipient_modal {\n  border: 1px solid #e1e1e1;\n  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.18);\n  background: rgb(255 255 255 / 20%);\n}\n\n.withdraw_recipient_icon {\n  display: flex;\n  justify-content: center;\n  margin: 10px 0 14px;\n}\n\n.withdraw_recipient_check {\n  width: 78px;\n  height: 78px;\n  border-radius: 999px;\n  background: #00BC7D;\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 34px;\n  font-weight: 700;\n  box-shadow: 0 12px 20px rgb(0 0 0 / 12%);\n}\n\n.withdraw_recipient_title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 10px 0px 10px;\n}\n\nbody.light_theme .withdraw_recipient_title {\n  color: #101828;\n}\n\n.withdraw_coin_hd {\n  font-size: 30px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: -6px 0px 0px;\n}\n\nbody.light_theme .withdraw_coin_hd {\n  color: #101828;\n}\n\n.withdraw_recipient_amt {\n  font-size: 40px;\n  font-weight: 600;\n  color: #ffffff;\n  letter-spacing: -0.6px;\n  margin-bottom: 12px;\n}\n\nbody.light_theme .withdraw_recipient_amt {\n  color: #303236;\n}\n\n.withdraw_recipient_note {\n  font-size: 17px;\n  color: #cacaca;\n  font-weight: 400;\n  margin-bottom: 18px;\n}\n\nbody.light_theme .withdraw_recipient_note {\n  color: #6A7282;\n}\n\n.withdraw_recipient_grid {\n  text-align: left;\n  margin-top: 8px;\n}\n\n.withdraw_recipient_row {\n  display: grid;\n  grid-template-columns: 120px 1fr;\n  gap: 16px;\n  padding: 10px 0;\n}\n\n.withdraw_recipient_k {\n  color: #838996;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.withdraw_recipient_v {\n  color: #ffffff;\n  font-size: 16px;\n  font-weight: 500;\n  text-align: right;\n}\n\nbody.light_theme .withdraw_recipient_v {\n  color: #303236;\n}\n\n.withdraw_recipient_v--addr {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  color: #AC8A50;\n}\n\n.withdraw_recipient_addr_icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  margin: 0;\n  border: none;\n  background: transparent;\n  color: #6A7282;\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.withdraw_recipient_addr_icon img {\n  width: 20px;\n  height: 20px;\n  display: block;\n}\n\n.withdraw_recipient_actions {\n  display: grid;\n  /* grid-template-columns: 160px 1fr; */\n  gap: 14px;\n  margin-top: 18px;\n}\n\n.withdraw_recipient_sub {\n  margin-top: 4px;\n  font-size: 13px;\n  color: #cacaca;\n  font-weight: 500;\n  text-align: right;\n}\n\nbody.light_theme .withdraw_recipient_sub {\n  color: #6A7282;\n}\n\n.withdraw_paypin_link {\n  background: transparent;\n  border: none;\n  padding: 0;\n  margin: 12px 0 14px;\n  color: #AC8A50;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.withdraw_paypin_link:hover {\n  text-decoration: underline;\n}\n\n.withdraw_paypin_modal {\n  width: 520px;\n  max-width: 92vw;\n  border-radius: 18px;\n  border: 1px solid #e1e1e1;\n  padding: 0;\n  position: relative;\n  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.18);\n  background: rgb(255 255 255 / 20%);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  overflow: hidden;\n}\n\n.withdraw_paypin_head {\n  padding: 18px 24px;\n  border-bottom: 1px solid rgba(225, 225, 225, 0.8);\n}\n\n.withdraw_paypin_title {\n  font-size: 26px;\n  font-weight: 600;\n  color: #101828;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.withdraw_paypin_eye {\n  border: none;\n  background: transparent;\n  padding: 0;\n  color: #6A7282;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n}\n\n.withdraw_paypin_body {\n  padding: 18px 24px 22px;\n}\n\n.withdraw_paypin_label {\n  font-size: 18px;\n  font-weight: 500;\n  color: #101828;\n  margin-bottom: 14px;\n}\n\n.withdraw_paypin_boxes {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 24px;\n  max-width: 440px;\n  margin-bottom: 12px;\n}\n\n.withdraw_paypin_box {\n  height: 56px;\n  width: 56px;\n  border-radius: 10px;\n  border: none;\n  background: #E8EAED;\n  text-align: center;\n  font-size: 20px;\n  font-weight: 600;\n  color: #101828;\n  outline: none;\n}\n\n/* .withdraw_paypin_box:focus {\n  border-color: #AC8A50;\n  box-shadow: 0 0 0 3px rgba(172, 138, 80, 0.15);\n} */\n\n.withdraw_paypin_hint {\n  font-size: 14px;\n  color: #7A8496;\n  font-weight: 500;\n  line-height: 1.45;\n  max-width: 640px;\n  margin: 8px 0 18px;\n}\n\n.withdraw_paypin_confirm {\n  width: 100%;\n  height: 52px;\n  border-radius: 999px;\n  border: none;\n  background: #303236;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.withdraw_paypin_confirm:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.withdraw_recipient_btn {\n  height: 46px;\n  border-radius: 999px;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.withdraw_recipient_btn--ghost {\n  background: #DDDDDD;\n  color: #374151;\n}\n\n.withdraw_recipient_btn--primary {\n  background: #ffffff;\n  color: #101828;\n}\n\nbody.light_theme .withdraw_recipient_btn--primary {\n  background: #303236;\n  color: #fff;\n}\n\n@media (max-width: 767px) {\n\n  .withdraw_recipient_modal {\n    padding: 20px 18px 32px;\n    border-radius: 16px 16px 0px 0px;\n    max-width: 100%;\n    height: 85vh;\n    overflow: scroll;\n  }\n\n  span.withdraw_sucessfull_icon {\n    width: 130px;\n  }\n\n  .withdraw_coin_hd {\n    font-size: 20px;\n  }\n\n  .withdraw_recipient_note {\n    font-size: 15px;\n  }\n\n  .withdraw_recipient_v {\n    font-size: 14px;\n  }\n\n  .withdraw_paypin_link {\n    font-size: 14px;\n  }\n\n  .withdraw_recipient_k {\n    font-size: 14px;\n  }\n\n\n  .gapbtn_space .withdraw_auth_link {\n    padding: 0px;\n  }\n\n  .mid_use_text .withdraw_auth_link {\n    padding: 0px;\n  }\n\n  .withdraw_facial_name {\n    font-size: 15px;\n  }\n\n  .withdraw_recipient_amt {\n    font-size: 30px;\n  }\n\n  .withdraw_recipient_row {\n    grid-template-columns: 90px 1fr;\n  }\n\n  .withdraw_recipient_actions {\n    grid-template-columns: 1fr;\n  }\n\n  .withdraw_paypin_modal {\n    border-radius: 16px 16px 0px 0px;\n    max-width: 100%;\n  }\n\n  .withdraw_paypin_box {\n    height: 44px;\n    width: 44px;\n    border-radius: 6px;\n    font-size: 16px;\n  }\n\n  .withdraw_paypin_confirm {\n    height: 44px;\n  }\n\n  .withdraw_paypin_head,\n  .withdraw_paypin_body {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  .withdraw_paypin_title {\n    font-size: 20px;\n  }\n\n  .withdraw_paypin_label {\n    font-size: 16px;\n  }\n\n  .withdraw_paypin_boxes {\n    gap: 10px;\n    max-width: 100%;\n  }\n}\n\n.withdraw_await_icon {\n  display: flex;\n  justify-content: center;\n  margin: 50px 0 14px;\n}\n\n.withdraw_await_circle {\n  width: 160px;\n  height: 160px;\n  border-radius: 999px;\n  background: rgb(255 255 255 / 20%);\n  box-shadow: 0 0px 20px rgba(0, 0, 0, 0.10);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.withdraw_await_circle i {\n  font-size: 54px;\n  color: #C5A36A;\n}\n\n.withdraw_await_title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 36px 0px 10px;\n}\n\nbody.light_theme .withdraw_await_title {\n  color: #101828;\n}\n\n.withdraw_await_text {\n  font-size: 16px;\n  color: #cacaca;\n  font-weight: 500;\n  letter-spacing: -0.3px;\n  line-height: 1.5;\n  max-width: 520px;\n  margin: 0 auto 18px;\n}\n\nbody.light_theme .withdraw_await_text {\n  color: #6A7282;\n}\n\n.withdraw_await_ok {\n  width: 100%;\n  border-radius: 999px;\n  padding: 13px 15px;\n  border: none;\n  background: #ffffff;\n  color: #101828;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  margin-top: 10px;\n}\n\nbody.light_theme .withdraw_await_ok {\n  background: #101828;\n  color: #ffffff;\n}\n\n@media (max-width: 520px) {\n  .withdraw_await_modal {\n    padding: 18px 18px 20px;\n    border-radius: 16px;\n  }\n\n  .withdraw_await_circle {\n    width: 92px;\n    height: 92px;\n  }\n\n  .withdraw_await_circle i {\n    font-size: 44px;\n  }\n\n  .withdraw_await_title {\n    font-size: 20px;\n  }\n}\n\n.withdraw_email_title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #ffffff;\n  margin-bottom: 10px;\n  letter-spacing: -0.45px;\n}\n\nbody.light_theme .withdraw_email_title {\n  color: #101828;\n}\n\n.withdraw_email_subtitle {\n  font-size: 16px;\n  color: #cacaca;\n  font-weight: 400;\n  letter-spacing: -0.5px;\n  line-height: 1.45;\n  margin-bottom: 18px;\n}\n\nbody.light_theme .withdraw_email_subtitle {\n  color: #6A7282;\n}\n\n.withdraw_email_label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #9ca3af;\n  margin: 11px 0 7px;\n}\n\nbody.light_theme .withdraw_email_label {\n  color: #303236;\n}\n\n.withdraw_email_input_row {\n  width: 100%;\n  position: relative;\n}\n\n.withdraw_email_input_row input {\n  width: 100%;\n  height: 50px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.05);\n  padding: 0 110px 0 14px;\n  font-size: 14px;\n  color: #ffffff;\n  outline: none;\n  box-sizing: border-box;\n}\n\nbody.light_theme .withdraw_email_input_row input {\n  border: 1px solid #E4E4E4;\n  background: #fff;\n  color: #303236;\n}\n\n.withdraw_email_status {\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #AC8A50;\n  font-size: 14px;\n  font-weight: 600;\n  background: transparent;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n\n.withdraw_email_status:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.withdraw_email_submit {\n  width: 100%;\n  border-radius: 999px;\n  padding: 13px 15px;\n  border: none;\n  background: #303236;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  margin-top: 30px;\n}\n\n@media (max-width: 767px) {\n  .withdraw_email_modal {\n    padding: 18px 18px 15px;\n    border-radius: 16px 16px 0px 0px;\n    max-width: 100%;\n  }\n\n  .withdraw_email_title {\n    font-size: 20px;\n    width: 90%;\n  }\n\n  .withdraw_email_label {\n    font-size: 14px;\n  }\n\n  .withdraw_email_status {\n    font-size: 14px;\n  }\n}\n\n.withdraw_choose_topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.withdraw_choose_back {\n  width: 36px;\n  height: 36px;\n  border: none;\n  background: transparent;\n  color: #e7e7e7;\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n  border-radius: 10px;\n}\n\nbody.light_theme .withdraw_choose_back {\n  color: #111827;\n}\n\n.withdraw_choose_back:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n\nbody.light_theme .withdraw_choose_back:hover {\n  background: rgba(17, 24, 39, 0.05);\n}\n\n.withdraw_choose_title {\n  font-size: 24px;\n  font-weight: 700;\n  color: #ffffff;\n  margin-top: 6px;\n  margin-bottom: 10px;\n}\n\nbody.light_theme .withdraw_choose_title {\n  color: #111827;\n}\n\n.withdraw_choose_subtitle {\n  font-size: 16px;\n  color: #84888C;\n  font-weight: 400;\n  letter-spacing: -0.5px;\n  line-height: 1.45;\n  margin-bottom: 22px;\n}\n\nbody.light_theme .withdraw_choose_subtitle {\n  color: #6A7282;\n}\n\n.withdraw_choose_item {\n  width: 100%;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.05);\n  display: flex;\n  align-items: center;\n  letter-spacing: -0.50px;\n  gap: 12px;\n  padding: 13px 16px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #ffffff;\n  cursor: pointer;\n  margin-top: 18px;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\nbody.light_theme .withdraw_choose_item {\n  border: 1px solid #E4E4E4;\n  background: #fff;\n  color: #303236;\n}\n\np.subheading {\n  letter-spacing: -0.5px;\n  color: #AC8A50;\n  font-size: 16px;\n  font-weight: 500;\n  text-align: center;\n}\n\n.mid_use_text {\n  margin-top: 15px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.emailphone_outerbl {\n  margin-top: 50px;\n}\n\n.withdraw_choose_item:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\nbody.light_theme .withdraw_choose_item:hover {\n  background: #F6F7F9;\n}\n\n.withdraw_choose_item img {\n  width: 22px;\n  height: 22px;\n  display: block;\n  opacity: 0.8;\n  filter: invert(1);\n}\n\n.completed_header img {\n  filter: invert(1);\n}\n\nbody.light_theme .completed_header img {\n  filter: invert(0);\n}\n\nbody.light_theme .withdraw_choose_item img {\n  filter: invert(0);\n}\n\n@media (max-width: 767px) {\n  .withdraw_choose_modal {\n    padding: 16px 16px 18px;\n    border-radius: 16px 16px 0px 0px;\n    min-height: 460px;\n    max-width: 100%;\n  }\n\n  .withdraw_email_subtitle {\n    font-size: 14px;\n  }\n\n  .withdraw_choose_title {\n    font-size: 20px;\n  }\n\n  .withdraw_choose_item {\n    font-size: 14px;\n    padding: 14px 14px;\n  }\n}\n\n/* Save Address modal */\n.withdraw_save_modal {\n  width: 539px;\n  max-width: 92vw;\n  border-radius: 18px;\n  border: 1px solid #e8e8e807;\n  padding: 22px 24px 20px;\n  position: relative;\n  box-shadow: 0 18px 48px rgb(0 0 0 / 40%);\n  background-color: rgb(41 41 41 / 60%);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  text-align: left;\n}\n\nbody.light_theme .withdraw_save_modal {\n  border: 1px solid #e8e8e8;\n  box-shadow: 0 18px 48px rgb(15 23 42 / 30%);\n  background-color: rgb(255 255 255 / 20%);\n}\n\n.withdraw_save_head {\n  padding-right: 36px;\n  padding-bottom: 14px;\n  margin-bottom: 4px;\n  border-bottom: 1px solid #ececec20;\n}\n\nbody.light_theme .withdraw_save_head {\n  border-bottom: 1px solid #ececec;\n}\n\n.withdraw_confirm_overlay .withdraw_save_title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  color: #fafafa;\n  letter-spacing: -0.02em;\n}\n\nbody.light_theme .withdraw_confirm_overlay .withdraw_save_title {\n  color: #0f172a;\n}\n\n.withdraw_save_body {\n  padding-top: 18px;\n}\n\n.withdraw_save_field {\n  margin-bottom: 16px;\n}\n\n.withdraw_save_label {\n  display: block;\n  font-size: 15px;\n  letter-spacing: -0.5px;\n  font-weight: 500;\n  color: #efefef;\n  margin-bottom: 6px;\n}\n\nbody.light_theme .withdraw_save_label {\n  color: #303236;\n}\n\n.withdraw_save_input,\n.withdraw_save_select,\n.withdraw_save_select_trigger {\n  width: 100%;\n  height: 46px;\n  border-radius: 10px;\n  border: none;\n  padding: 8px 14px;\n  font-size: 14px;\n  color: #f3f3f3;\n  box-sizing: border-box;\n  font-weight: 500;\n  background: #f5f6f715;\n}\n\nbody:not(.light_theme) .withdraw_save_input,\nbody:not(.light_theme) .withdraw_save_select,\nbody:not(.light_theme) .withdraw_save_select_trigger,\nbody:not(.light_theme) .withdraw_save_input:not(:placeholder-shown),\nbody:not(.light_theme) .withdraw_save_select_value {\n  color: #ffffff !important;\n  -webkit-text-fill-color: #ffffff !important;\n}\n\nbody.light_theme .withdraw_save_input,\nbody.light_theme .withdraw_save_select,\nbody.light_theme .withdraw_save_select_trigger {\n  color: #8e8e8e;\n  background: #f5f6f7;\n}\n\nbody.light_theme .withdraw_save_input:-webkit-autofill,\nbody.light_theme .withdraw_save_input:-webkit-autofill:hover,\nbody.light_theme .withdraw_save_input:-webkit-autofill:focus,\nbody.light_theme .withdraw_save_input:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px #f5f6f7 inset !important;\n  -webkit-text-fill-color: #8e8e8e !important;\n  transition: background-color 5000s ease-in-out 0s;\n}\n\nbody:not(.light_theme) .withdraw_save_input:-webkit-autofill,\nbody:not(.light_theme) .withdraw_save_input:-webkit-autofill:hover,\nbody:not(.light_theme) .withdraw_save_input:-webkit-autofill:focus,\nbody:not(.light_theme) .withdraw_save_input:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px #24272c inset !important;\n  /* approx solid color for #f5f6f715 over dark background */\n  -webkit-text-fill-color: #ffffff !important;\n  transition: background-color 5000s ease-in-out 0s;\n}\n\n.withdraw_save_select_trigger {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  text-align: left;\n  padding-right: 40px;\n  cursor: pointer;\n  font-family: inherit;\n  line-height: 1.3;\n}\n\n.withdraw_save_select_value {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 100%;\n}\n\n.withdraw_save_select_trigger.is-placeholder .withdraw_save_select_value {\n  color: #94a3b8;\n  font-weight: 500;\n}\n\n.withdraw_save_select_trigger:not(.is-placeholder) .withdraw_save_select_value {\n  color: #cfcfcf;\n  font-weight: 500;\n}\n\nbody.light_theme .withdraw_save_select_trigger:not(.is-placeholder) .withdraw_save_select_value {\n  color: #0f172a;\n}\n\n.withdraw_save_input.is-invalid,\n.withdraw_save_select.is-invalid,\n.withdraw_save_select_trigger.is-invalid {\n  border-color: #ef4444;\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.12);\n}\n\n.withdraw_save_error {\n  margin-top: 8px;\n  font-size: 12px;\n  line-height: 1.3;\n  color: #ef4444;\n}\n\n.withdraw_save_input::placeholder {\n  color: #94a3b8;\n}\n\n.withdraw_save_select_wrap {\n  position: relative;\n}\n\n.withdraw_save_country_select_wrap {\n  position: relative;\n}\n\n.withdraw_save_country_select_wrap.is-invalid .withdraw-save-country__control {\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.12);\n}\n\n.withdraw_save_select {\n  appearance: none;\n  -webkit-appearance: none;\n  padding-right: 40px;\n  color: #0f172a;\n  cursor: pointer;\n}\n\n.withdraw_save_select:invalid {\n  color: #94a3b8;\n}\n\n.withdraw_save_select:valid {\n  color: #0f172a;\n}\n\n.withdraw_save_select_wrap::after {\n  content: \"\";\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  width: 8px;\n  height: 8px;\n  border-right: 2px solid #64748b;\n  border-bottom: 2px solid #64748b;\n  transform: translateY(-65%) rotate(45deg);\n  pointer-events: none;\n  z-index: 1;\n}\n\n.withdraw_save_select_wrap.is-open::after {\n  transform: translateY(-35%) rotate(225deg);\n}\n\n.withdraw_save_select_menu {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: calc(100% + 6px);\n  margin: 0;\n  padding: 6px;\n  list-style: none;\n  background: #2f3031;\n  border: 1px solid #e4e4e40d;\n  border-radius: 10px;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12);\n  z-index: 50;\n  max-height: 220px;\n  overflow-y: auto;\n}\n\nbody.light_theme .withdraw_save_select_menu {\n  background: #fff;\n  border: 1px solid #e4e4e4;\n}\n\n.withdraw_save_select_menu li {\n  margin: 0;\n}\n\n.withdraw_save_select_option {\n  width: 100%;\n  display: block;\n  text-align: left;\n  border: none;\n  background: transparent;\n  border-radius: 8px;\n  padding: 10px 12px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #dedede;\n  cursor: pointer;\n  font-family: inherit;\n  line-height: 1.35;\n}\n\nbody.light_theme .withdraw_save_select_option {\n  color: #334155;\n}\n\n.withdraw_save_select_option:hover {\n  background: #f4f5f70a;\n}\n\nbody.light_theme .withdraw_save_select_option:hover {\n  background: #f4f5f7;\n}\n\n.withdraw_save_select_option.is-selected {\n  background: #f1f5f90a;\n  color: #ffffff;\n  font-weight: 600;\n}\n\nbody.light_theme .withdraw_save_select_option.is-selected {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n.withdraw_save_universal {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  background: #F1F4F8;\n  border: 1px solid #e9e9e9;\n  border-radius: 12px;\n  padding: 20px 15px 20px 15px;\n  margin-bottom: 16px;\n}\n\n.withdraw_save_universal_main {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin: 0;\n  flex: 1;\n  cursor: pointer;\n  font-size: 13px;\n  line-height: 1.45;\n  color: #cbcbcb;\n}\n\nbody.light_theme .withdraw_save_universal_main {\n  color: #334155;\n}\n\n.withdraw_save_universal_main input {\n  margin-top: 3px;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  accent-color: #111827;\n}\n\n.css-qwbp4v-indicatorContainer {\n  color: #dbdbdb !important;\n}\n\nbody.light_theme .css-qwbp4v-indicatorContainer {\n  color: #1a1d21 !important;\n}\n\n.withdraw_save_universal_text {\n  flex: 1;\n}\n\n.withdraw_save_info {\n  border: none;\n  background: transparent;\n  padding: 2px 0 0;\n  margin: 0;\n  color: #64748b;\n  cursor: pointer;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.withdraw_save_info i {\n  font-size: 18px;\n}\n\n.withdraw_save_whitelist {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 4px 0 6px;\n  font-size: 14px;\n  color: #1e293b;\n  cursor: pointer;\n}\n\n.withdraw_save_whitelist input {\n  width: 16px;\n  height: 16px;\n  accent-color: #111827;\n}\n\n.withdraw_whitelist_step {\n  text-align: left;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #ebebeb;\n}\n\nbody.light_theme .withdraw_whitelist_step {\n  color: #334155;\n}\n\n.withdraw_whitelist_intro {\n  margin: 0 0 8px;\n}\n\n.withdraw_save_confirm_lead {\n  margin: 0 0 16px;\n  font-size: 14px;\n  line-height: 1.55;\n  font-weight: 400;\n  color: #d5d5d5;\n}\n\nbody.light_theme .withdraw_save_confirm_lead {\n  color: #64748b;\n}\n\n.withdraw_save_radio_block {\n  margin-bottom: 4px;\n}\n\n.withdraw_save_radio_rows {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  margin-top: 10px;\n}\n\n.withdraw_save_radio_question {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #f5f5f5;\n  letter-spacing: -0.015em;\n  line-height: 1.35;\n}\n\nbody.light_theme .withdraw_save_radio_question {\n  color: #0f172a;\n}\n\n.withdraw_save_radio_option {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin: 0;\n  cursor: pointer;\n}\n\n.withdraw_save_radio_native {\n  position: absolute;\n  left: 0;\n  top: 2px;\n  width: 22px;\n  height: 22px;\n  margin: 0;\n  opacity: 0;\n  cursor: pointer;\n  z-index: 2;\n}\n\n.withdraw_save_radio_visual {\n  position: relative;\n  flex: 0 0 22px;\n  width: 22px;\n  height: 22px;\n  margin-top: 2px;\n  border: 2px solid #cbd5e16e;\n  border-radius: 50%;\n  background: #ffffff0f;\n  box-sizing: border-box;\n}\n\nbody.light_theme .withdraw_save_radio_visual {\n  border: 2px solid #cbd5e1;\n  background: #fff;\n}\n\n.css-9xs793-control {\n  background-color: #f5f6f720 !important;\n}\n\nbody.light_theme .css-9xs793-control {\n  background-color: #f5f6f7 !important;\n}\n\n.withdraw_save_radio_native:focus-visible+.withdraw_save_radio_visual {\n  outline: 2px solid #64748b;\n  outline-offset: 2px;\n}\n\n.withdraw_save_radio_native:checked+.withdraw_save_radio_visual {\n  border-color: #d1aa67;\n}\n\n.withdraw_save_radio_native:checked+.withdraw_save_radio_visual::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 10px;\n  height: 10px;\n  transform: translate(-50%, -50%);\n  border-radius: 50%;\n  background: #d1aa67;\n}\n\n.withdraw_save_radio_text {\n  flex: 1;\n  padding-top: 1px;\n  font-size: 14px;\n  line-height: 1.45;\n  font-weight: 500;\n  color: #ebebeb;\n}\n\nbody.light_theme .withdraw_save_radio_text {\n  color: #0f172a;\n}\n\n.withdraw_save_modal.verify_identity .withdraw_sec_item {\n  padding: 15px;\n}\n\n.withdraw_save_modal.verify_identity .withdraw_sec_list {\n  gap: 15px;\n}\n\n.withdraw_save_radio_option.is-disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.withdraw_save_radio_native:disabled {\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.withdraw_whitelist_wallet_missing {\n  margin: 4px 0 12px;\n}\n\n.withdraw_whitelist_wallet_missing_actions {\n  margin-top: 10px;\n}\n\n.withdraw_whitelist_amount {\n  margin: 0 0 12px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\nbody.light_theme .withdraw_whitelist_amount {\n  color: #0f172a;\n}\n\n.withdraw_whitelist_hint {\n  margin: 0 0 10px;\n  color: #cfcfcf;\n}\n\nbody.light_theme .withdraw_whitelist_hint {\n  color: #475569;\n}\n\n.withdraw_whitelist_mm_soft_hint {\n  margin: 0 0 10px;\n  /* padding: 10px 12px; */\n  font-size: 13px;\n  line-height: 1.45;\n  color: #3f3f3e70;\n  /* background: #fffbeb; */\n  /* border: 1px solid #fde68a; */\n  border-radius: 8px;\n}\n\n.withdraw_whitelist_link {\n  color: #b45309;\n  font-weight: 600;\n  text-decoration: underline;\n  /* padding: 0px 1px; */\n  background: none !important;\n}\n\n.withdraw_whitelist_expiry {\n  margin: 0 0 12px;\n  font-size: 13px;\n  color: #dfdfdf;\n}\n\nbody.light_theme .withdraw_whitelist_expiry {\n  color: #64748b;\n}\n\n.withdraw_whitelist_polling {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-top: 8px;\n  font-size: 13px;\n  color: #475569;\n}\n\n.withdraw_whitelist_polling_text {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.withdraw_whitelist_polling_hint {\n  display: block;\n  font-size: 12px;\n  line-height: 1.45;\n  color: #64748b;\n  font-weight: 400;\n}\n\n.withdraw_whitelist_checking {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 10px;\n  font-size: 13px;\n  color: #475569;\n}\n\nbutton.withdraw_sec_item.withdraw_sec_item--selectable {\n  border: none;\n}\n\nb .withdraw_whitelist_checking .spinner-border {\n  flex-shrink: 0;\n}\n\n.withdraw_whitelist_checking_text {\n  font-weight: 500;\n}\n\n.withdraw_whitelist_awaiting_notice {\n  margin-top: 12px;\n  padding: 12px 0px;\n  /* background: #f0f9ff; */\n  /* border: 1px solid #bae6fd; */\n  border-radius: 10px;\n  text-align: left;\n}\n\n.withdraw_whitelist_awaiting_title {\n  margin: 0 0 8px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #f5f5f5;\n}\n\nbody.light_theme .withdraw_whitelist_awaiting_title {\n  color: #000;\n}\n\n.withdraw_whitelist_awaiting_body {\n  margin: 0 0 8px;\n  font-size: 13px;\n  line-height: 1.5;\n  color: #e5e5e5;\n}\n\nbody.light_theme .withdraw_whitelist_awaiting_body {\n  color: #334155;\n}\n\n.withdraw_whitelist_awaiting_body:last-child {\n  margin-bottom: 0;\n}\n\n.withdraw_whitelist_polling .spinner-border {\n  flex-shrink: 0;\n}\n\n.withdraw_whitelist_deposit_loading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 12px 0;\n  font-size: 14px;\n  color: #475569;\n}\n\n.withdraw_whitelist_deposit_panel {\n  display: flex;\n  /* flex-wrap: wrap; */\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  /* align-items: flex-start; */\n  margin: 14px 0 8px;\n  padding: 14px;\n  border-radius: 12px;\n  border: 1px solid rgba(148, 163, 184, 0.4);\n  /* background: rgba(248, 250, 252, 0.65); */\n}\n\n.withdraw_whitelist_qr_wrap {\n  /* flex: 0 0 auto; */\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.withdraw_whitelist_qr_svg {\n  display: block;\n  border-radius: 8px;\n}\n\n.withdraw_whitelist_qr_hint {\n  margin-top: 8px;\n  font-size: 12px;\n  color: #ebebeb;\n}\n\nbody.light_theme .withdraw_whitelist_qr_hint {\n  color: #64748b;\n}\n\n.withdraw_whitelist_deposit_fields {\n  /* flex: 1 1 200px; */\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  align-items: center;\n}\n\n.withdraw_whitelist_addr_block {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n}\n\n.withdraw_whitelist_field_label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #ffffff;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\nbody.light_theme .withdraw_whitelist_field_label {\n  color: #475569;\n}\n\n.withdraw_whitelist_addr_input_row {\n  display: flex;\n  gap: 8px;\n  align-items: stretch;\n  width: 100%;\n}\n\n.withdraw_whitelist_addr_input_row .withdraw_save_input {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.withdraw_whitelist_copy_btn {\n  flex: 0 0 auto;\n  padding: 0 14px;\n  border-radius: 10px;\n  border: 1px solid #d1aa67;\n  background: #d1aa67;\n  font-size: 13px;\n  font-weight: 600;\n  color: #0f172a;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.withdraw_whitelist_copy_btn:hover {\n  border-color: #d1aa67;\n}\n\n.withdraw_whitelist_method_hint {\n  margin: 6px 0 0;\n  font-size: 13px;\n  line-height: 1.45;\n  color: rgb(198, 199, 199);\n}\n\nbody.light_theme .withdraw_whitelist_method_hint {\n  color: #64748b;\n}\n\n.withdraw_whitelist_method_btn:disabled {\n  opacity: 0.48;\n  cursor: not-allowed;\n}\n\n.withdraw_whitelist_method_btn:not(:disabled):hover {\n  border-color: #334155;\n}\n\n.withdraw_whitelist_method {\n  margin: 8px 0 4px;\n}\n\n.withdraw_whitelist_method_btns {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 6px;\n}\n\n.withdraw_whitelist_method_btn {\n  flex: 1 1 140px;\n  min-height: 40px;\n  padding: 0 12px;\n  border-radius: 10px;\n  border: 1px solid rgba(148, 163, 184, 0.55);\n  background: #fff;\n  font-size: 13px;\n  font-weight: 500;\n  color: #334155;\n  cursor: pointer;\n}\n\n.withdraw_whitelist_method_btn.is-active {\n  border-color: #111827;\n  background: #111827;\n  color: #fff;\n}\n\n.withdraw_save_actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 22px;\n}\n\n.withdraw_save_btn {\n  height: 46px;\n  border-radius: 999px;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.withdraw_save_btn--cancel {\n  flex: 0 0 30%;\n  max-width: 30%;\n  background: #DDDDDD;\n  color: #334155;\n}\n\n.withdraw_save_btn--save {\n  flex: 1 1 60%;\n  background: #111827;\n  color: #fff;\n}\n\n.withdraw_save_btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n@media (max-width: 520px) {\n  .withdraw_save_btn {\n    height: 35px;\n\n  }\n\n\n\n  .withdraw_save_title {\n    font-size: 18px;\n  }\n\n  .withdraw_save_actions {\n    flex-direction: column;\n  }\n\n  .withdraw_save_btn--cancel {\n    flex: 1 1 auto;\n    max-width: none;\n  }\n}\n\n/* About Network Fee — modal (Network Fee … button) */\n.withdraw_netfee_modal {\n  width: 606px;\n  max-width: 92vw;\n  border-radius: 18px;\n  border: 1px solid #e8e8e806;\n  padding: 22px 24px 20px;\n  position: relative;\n  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.30);\n  background: #1e2026a3;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  text-align: left;\n}\n\nbody.light_theme .withdraw_netfee_modal {\n  border: 1px solid #e8e8e8;\n  background: #ffffff21;\n\n}\n\n.withdraw_netfee_modal .withdraw_netfee_panel_title {\n  margin: 0;\n  padding-right: 40px;\n}\n\n@media (max-width: 767px) {\n\n  .withdraw_save_modal {\n    width: 100%;\n    max-width: 100%;\n    padding: 18px 16px 16px;\n    border-radius: 16px 16px 0px 0px;\n  }\n\n  .withdraw_passkey_modal {\n    border-radius: 16px 16px 0px 0px;\n  }\n\n  .withdraw_confirm_overlay .withdraw_save_title {\n    font-size: 20px;\n  }\n\n  .withdraw_passkey_link {\n    margin: 10px auto 10px;\n    font-size: 14px;\n  }\n\n  .withdraw_netfee_modal {\n    padding: 18px 16px 16px;\n    border-radius: 16px 16px 0px 0px;\n    max-width: 100%;\n  }\n}\n\n/* —— Recent withdrawals: Withdrawal Details (replaces Bootstrap #recent_table) —— */\n.withdraw_hist_detail_overlay {\n  z-index: 100000001;\n}\n\n.withdraw_hist_detail_modal {\n  width: 606px;\n  max-width: 92vw;\n  max-height: min(92vh, 720px);\n  overflow: auto;\n  border-radius: 20px;\n  border: 1px solid #e8e8e8;\n  padding: 24px;\n  position: relative;\n  /* box-shadow: 0 24px 48px rgba(15, 23, 42, 0.14); */\n  /* background: #fff; */\n  text-align: left;\n  -webkit-overflow-scrolling: touch;\n  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.18);\n  background: rgb(255 255 255 / 20%);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n}\n\n.withdraw_hist_detail_head {\n  padding-bottom: 5px;\n  margin-bottom: 4px;\n}\n\n.withdraw_hist_detail_title {\n  margin: 0;\n  padding-right: 44px;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n}\n\n.withdraw_hist_detail_body {\n  padding-top: 4px;\n}\n\n/* Vertical stepper */\n.withdraw_hist_stepper {\n  margin-top: 32px;\n  display: flex;\n  flex-direction: column;\n  padding-left: 24px;\n}\n\n.withdraw_hist_step {\n  display: flex;\n  gap: 14px;\n  align-items: stretch;\n}\n\n.withdraw_hist_step_track {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 14px;\n  flex-shrink: 0;\n}\n\n.withdraw_hist_step_dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #00c087;\n  margin-top: 6px;\n  flex-shrink: 0;\n  box-shadow: 0 0 0 3px rgba(0, 192, 135, 0.18);\n}\n\n.withdraw_hist_step_line {\n  flex: 1;\n  width: 2px;\n  min-height: 28px;\n  margin: 6px 0 0;\n  border-radius: 1px;\n  background: rgba(0, 192, 135, 0.35);\n}\n\n.withdraw_hist_step_text {\n  flex: 1;\n  padding-bottom: 4px;\n}\n\n.withdraw_hist_step_title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1e293b;\n  line-height: 1.35;\n}\n\n.withdraw_hist_step_title.is-emphasized {\n  font-weight: 700;\n}\n\n.withdraw_hist_step_time {\n  margin-top: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #9CA3AF;\n}\n\n.withdraw_hist_step_note {\n  margin: 4px 0 0;\n  padding-left: 51px;\n  font-size: 12px;\n  line-height: 1.45;\n  color: #64748b;\n}\n\n.withdraw_hist_step_note--danger {\n  color: #b91c1c;\n}\n\n.withdraw_hist_step_sub {\n  margin-top: 6px;\n  font-size: 12px;\n  line-height: 1.45;\n  color: #64748b;\n  font-weight: 400;\n}\n\n.withdraw_hist_stepper[data-outcome=\"danger\"] .withdraw_hist_step:first-child .withdraw_hist_step_line {\n  background: rgba(239, 68, 68, 0.45);\n}\n\n.withdraw_hist_stepper[data-outcome=\"danger\"] .withdraw_hist_step:last-child .withdraw_hist_step_dot {\n  background: #ef4444;\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.22);\n}\n\n.withdraw_hist_stepper[data-outcome=\"pending\"] .withdraw_hist_step:first-child .withdraw_hist_step_line {\n  background: rgba(245, 158, 11, 0.42);\n}\n\n.withdraw_hist_stepper[data-outcome=\"pending\"] .withdraw_hist_step:last-child .withdraw_hist_step_dot {\n  background: #f59e0b;\n  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.28);\n}\n\n.withdraw_hist_tx_ref_hint {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #94a3b8;\n  padding: 2px 6px;\n  border-radius: 4px;\n  background: rgba(148, 163, 184, 0.2);\n  flex-shrink: 0;\n}\n\n.withdraw_hist_help_links {\n  margin-top: 12px;\n  padding-left: 50px;\n  display: flex;\n  flex-direction: column;\n  gap: 3px 18px;\n}\n\n.withdraw_hist_gold_link {\n  font-size: 14px;\n  font-weight: 500;\n  color: #AC8A50;\n  /* text-decoration: underline; */\n  text-underline-offset: 2px;\n}\n\n/* .withdraw_hist_gold_link:hover {\n  color: #957a44;\n} */\n\n/* Detail rows */\n.withdraw_hist_rows {\n  margin-top: 22px;\n  padding-top: 18px;\n  border-top: 1px solid #eceff3;\n  display: flex;\n  flex-direction: column;\n  gap: 26px;\n}\n\n.withdraw_hist_row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  font-size: 16px;\n  line-height: 1.4;\n}\n\n.withdraw_hist_row_label {\n  color: #707a8a;\n  font-weight: 500;\n  flex-shrink: 0;\n}\n\n.withdraw_hist_row_value {\n  color: #303236;\n  font-weight: 500;\n  text-align: right;\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  max-width: 68%;\n}\n\n.withdraw_hist_row_value--success {\n  color: #10b981;\n}\n\n.withdraw_hist_row_value--danger {\n  color: #ef4444;\n}\n\n.withdraw_hist_row_value--pending {\n  color: #d97706;\n}\n\n.withdraw_hist_row_value--neutral,\n.withdraw_hist_row_value--info {\n  color: #64748b;\n}\n\n.withdraw_hist_row_value--coin {\n  gap: 8px;\n}\n\n.withdraw_hist_row_value--coin img {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.withdraw_hist_row_value--addr {\n  max-width: 72%;\n}\n\n.withdraw_hist_mono {\n  font-variant-numeric: tabular-nums;\n  word-break: break-all;\n}\n\n.withdraw_hist_badge_unverified {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px 2px 6px;\n  border-radius: 3px;\n  background: #C6A5A5;\n  color: #C21F33;\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.withdraw_hist_badge_icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: rgba(246, 70, 93, 0.22);\n  font-size: 10px;\n  font-weight: 800;\n}\n\n.withdraw_hist_icon_btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  padding: 0;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\nbody.light_theme .withdraw_hist_icon_btn {\n  background: #F3F4F6;\n  color: #6c6c6c;\n}\n\nhtml[data-theme='dark'] body .withdraw_sec_req_modal.sec-req-invert-icons .withdraw_sec_req_left img {\n  filter: brightness(0) invert(1);\n}\n\n/* .withdraw_hist_icon_btn:hover {\n  background: #f1f5f9;\n  color: #64748b;\n} */\n\n.withdraw_hist_icon_link {\n  text-decoration: none;\n}\n\n.withdraw_hist_icon_svg {\n  width: 15px;\n  height: 15px;\n  display: block;\n}\n\n.withdraw_hist_chat_row {\n  margin: 20px 0 0;\n  text-align: center;\n}\n\n/* .withdraw_hist_chat_row .withdraw_hist_gold_link {\n  font-weight: 500;\n} */\n\n.withdraw_hist_again_btn {\n  width: 100%;\n  margin-top: 16px;\n  height: 46px;\n  border: none;\n  border-radius: 999px;\n  background: #2d2e32;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  cursor: pointer;\n}\n\n.withdraw_hist_again_btn:hover {\n  background: #1a1b1f;\n}\n\n.withdraw_hist_cancel_btn {\n  margin-top: 12px;\n  background: transparent;\n  color: #c45c5c;\n  border: 1px solid #c45c5c;\n}\n\n.withdraw_hist_cancel_btn:hover:not(:disabled) {\n  background: rgba(196, 92, 92, 0.12);\n}\n\n.withdraw_hist_cancel_btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.recent_deposit_list .withdraw_hist_view_btn {\n  color: #ac8a50;\n  font-size: 14px;\n  font-weight: 500;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.recent_deposit_list .withdraw_hist_view_btn:hover {\n  color: #957a44;\n}\n\n/* —— Recent Withdrawals v2 (Address tab: table + mobile cards; matches product layout) —— */\n.recent_deposit_list.withdraw_recent_v2 {\n  padding-top: 48px;\n}\n\n.withdraw_recent_head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n\n.withdraw_recent_title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #101828;\n  letter-spacing: -0.02em;\n}\n\n.withdraw_recent_head_right {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  flex-wrap: wrap;\n}\n\n.withdraw_recent_hide_err {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  font-size: 14px;\n  font-weight: 400;\n  color: #64748b;\n  cursor: pointer;\n  user-select: none;\n}\n\n.withdraw_recent_hide_err input {\n  width: 16px;\n  height: 16px;\n  accent-color: #d1aa67;\n  cursor: pointer;\n}\n\nbody.light_theme .withdraw_recent_hide_err input {\n  accent-color: #111827;\n}\n\n.withdraw_recent_more {\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748b;\n  text-decoration: none;\n}\n\n.withdraw_recent_more:hover {\n  color: #334155;\n}\n\n.withdraw_recent_tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.withdraw_recent_tab {\n  padding: 8px 18px;\n  border-radius: 999px;\n  border: none;\n  background: #fff;\n  border-radius: 10px;\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  line-height: 1.2;\n}\n\n.withdraw_recent_table_outer {\n  width: 100%;\n}\n\n/* Reset global .recent_deposit_list table { flex rows } so thead/tbody layout works */\n.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  table-layout: fixed;\n}\n\n.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table thead tr,\n.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table tbody tr {\n  display: table-row;\n  margin: 0;\n  padding: 0;\n  border-radius: 0;\n  align-items: stretch;\n}\n\n.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table thead tr:hover,\n.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table tbody tr:hover {\n  background: transparent;\n}\n\n.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table th,\n.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table td {\n  display: table-cell;\n  vertical-align: middle;\n  cursor: default;\n  padding: 14px 12px;\n  border-bottom: none;\n  font-size: 14px;\n  text-align: left;\n  color: #1e2329;\n  font-weight: 400;\n}\n\n.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table thead th {\n  font-size: 13px;\n  font-weight: 400;\n  color: #707a8a;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  border-bottom: none;\n  background: none;\n}\n\n.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table tbody tr {\n  background: #fff;\n}\n\n.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table tbody tr.withdraw_recent_row_open_detail {\n  cursor: pointer;\n}\n\n.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table tbody tr.withdraw_recent_row_open_detail:hover {\n  background: #f8fafc;\n}\n\n.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table tbody tr.withdraw_recent_row_open_detail:focus {\n  /* outline: 2px solid rgba(172, 138, 80, 0.65); */\n  outline-offset: -2px;\n}\n\n.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_card_open_detail {\n  cursor: pointer;\n}\n\n.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_card_open_detail:hover {\n  background: rgba(248, 250, 252, 0.92);\n}\n\n.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_card_open_detail:focus {\n  outline: 2px solid rgba(172, 138, 80, 0.65);\n  outline-offset: 2px;\n}\n\n/* .recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table tbody tr:hover {\n  background: #f8fafc;\n} */\n\n.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_table tbody tr td span {\n  color: inherit;\n}\n\n.withdraw_recent_th_action {\n  width: 56px;\n}\n\n.withdraw_recent_asset_cell {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.withdraw_recent_asset_cell img {\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.withdraw_recent_asset_text {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.withdraw_recent_coin {\n  font-weight: 600;\n  color: #1e2329;\n}\n\n.withdraw_recent_list_date {\n  font-size: 12px;\n  font-weight: 400;\n  color: #94a3b8;\n}\n\n.withdraw_recent_amount {\n  font-weight: 500;\n  color: #1e2329;\n}\n\n.withdraw_recent_net_pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: #F3F4F6;\n  color: #475569 !important;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.withdraw_recent_cell_actions {\n  display: inline-flex;\n  /* align-items: center; */\n  /* justify-content: flex-end; */\n  /* flex-wrap: wrap; */\n  /* gap: 6px; */\n  font-weight: 500;\n}\n\n.withdraw_recent_mono {\n  font-variant-numeric: tabular-nums;\n  color: #1e2329;\n  word-break: break-all;\n}\n\n.withdraw_recent_icon_btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #94a3b8;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.withdraw_recent_icon_btn:hover {\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n.withdraw_recent_icon_link {\n  text-decoration: none;\n}\n\n.withdraw_recent_v2 .withdraw_hist_icon_svg {\n  width: 16px;\n  height: 16px;\n}\n\n.withdraw_recent_status {\n  font-size: 14px;\n  font-weight: 600;\n  color: #64748b;\n}\n\n.withdraw_recent_status--success {\n  color: #10b981;\n}\n\n.withdraw_recent_status--danger {\n  color: #ef4444;\n}\n\n.withdraw_recent_status--pending {\n  color: #d97706;\n}\n\n.withdraw_recent_status--neutral,\n.withdraw_recent_status--info {\n  color: #64748b;\n}\n\n.recent_deposit_list.withdraw_recent_v2 .withdraw_recent_icon_link.is-disabled {\n  opacity: 0.45;\n  pointer-events: none;\n  cursor: not-allowed;\n}\n\n.recent_deposit_list.withdraw_recent_v2 .withdraw_hist_view_btn {\n  color: #ac8a50;\n  font-size: 14px;\n  font-weight: 500;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n  padding: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n.recent_deposit_list.withdraw_recent_v2 .withdraw_hist_view_btn:hover {\n  color: #957a44;\n}\n\n.withdraw_recent_empty {\n  padding: 28px 16px;\n  text-align: center;\n  font-size: 14px;\n  color: #94a3b8;\n  /* background: #fafbfc;\n  border: 1px dashed #e2e8f0; \n  border-radius: 12px;*/\n}\n\n/* Mobile card refinements */\n.withdraw_recent_v2 .withdraw_recent_card .withdraw_recent_card_top {\n  margin-bottom: 4px;\n}\n\n.withdraw_recent_v2 .withdraw_recent_card_asset {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n}\n\n.withdraw_recent_v2 .withdraw_recent_card_coin_row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.withdraw_recent_v2 .withdraw_recent_card_amt {\n  border-top: none;\n  padding-top: 10px;\n}\n\n.withdraw_recent_v2 .withdraw_recent_card_row_actions .value {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 6px;\n  max-width: 68%;\n  text-align: right;\n}\n\n@media (min-width: 992px) {\n  .recent_deposit_list.withdraw_recent_v2 .withdraw_history_desktop {\n    display: block;\n  }\n\n  .recent_deposit_list.withdraw_recent_v2 .withdraw_history_mobile {\n    display: none;\n  }\n}\n\n@media (max-width: 991px) {\n  .recent_deposit_list.withdraw_recent_v2 .withdraw_history_desktop {\n    display: none;\n  }\n\n  .recent_deposit_list.withdraw_recent_v2 .withdraw_history_mobile {\n    display: block;\n  }\n\n  .withdraw_recent_head {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .withdraw_recent_head_right {\n    justify-content: space-between;\n  }\n}\n\nbody.light_theme .dashboard_right .withdraw_recent_title {\n  color: #101828;\n}\n\n.dashboard_right .withdraw_recent_tab {\n  background: #2b3138;\n  border-color: #e5e7eb;\n}\n\nbody.light_theme .dashboard_right .withdraw_recent_tab {\n  background: #fff;\n  border-color: #e5e7eb;\n\n}\n\n.withdraw_recent_tab.is-active {\n  color: #ffffff;\n}\n\nbody.light_theme .withdraw_recent_tab.is-active {\n  color: #0f172a;\n}\n\n\n@media (max-width: 767px) {\n\n  .withdraw_confirm_overlay {\n    align-items: end;\n    padding: 0px\n  }\n\n  .withdraw_confirm_modal {\n    padding: 20px 18px 32px;\n    border-radius: 16px 16px 0px 0px;\n    max-width: 100%;\n  }\n\n  .withdraw_hist_stepper {\n    margin-top: 18px;\n  }\n\n  .withdraw_hist_again_btn {\n    height: 38px;\n    font-size: 13px;\n  }\n\n}\n\n\n@media (max-width: 767px) {\n\n\n  .withdraw_hist_detail_title {\n    font-size: 18px;\n  }\n\n  .withdraw_hist_row_value,\n  .withdraw_hist_row_value--addr {\n    max-width: 100%;\n    justify-content: flex-start;\n    text-align: left;\n  }\n\n  .withdraw_hist_row {\n    align-items: flex-start;\n    gap: 6px;\n  }\n\n  .withdraw_hist_row {\n    gap: 12px;\n    font-size: 14px;\n  }\n\n}\n\n/* —— Security verification unavailable flow (screenshots) —— */\n.withdraw_sec_overlay {\n  z-index: 100000020;\n}\n\n/* Shared popup typography + input styling (security_verification_unavailable only) */\n.withdraw_sec_overlay .withdraw_sec_modal,\n.withdraw_sec_overlay .withdraw_sec_confirm_modal,\n.withdraw_sec_overlay .withdraw_sec_req_modal,\n.withdraw_sec_overlay .withdraw_passkey_modal,\n.withdraw_sec_overlay .withdraw_auth_modal,\n.withdraw_sec_overlay .withdraw_email_modal,\n.withdraw_sec_overlay .withdraw_mobile_modal,\n.withdraw_sec_overlay .withdraw_facial_modal {\n  font-family: inherit;\n  color: #ffffff;\n}\n\nbody.light_theme .withdraw_sec_overlay .withdraw_sec_modal,\nbody.light_theme .withdraw_sec_overlay .withdraw_sec_confirm_modal,\nbody.light_theme .withdraw_sec_overlay .withdraw_sec_req_modal,\nbody.light_theme .withdraw_sec_overlay .withdraw_passkey_modal,\nbody.light_theme .withdraw_sec_overlay .withdraw_auth_modal,\nbody.light_theme .withdraw_sec_overlay .withdraw_email_modal,\nbody.light_theme .withdraw_sec_overlay .withdraw_mobile_modal,\nbody.light_theme .withdraw_sec_overlay .withdraw_facial_modal {\n  color: #111827;\n}\n\n.withdraw_sec_overlay input[type=\"text\"],\n.withdraw_sec_overlay input[type=\"email\"],\n.withdraw_sec_overlay input[type=\"tel\"],\n.withdraw_sec_overlay input[type=\"search\"],\n.withdraw_sec_overlay input[type=\"password\"] {\n  height: 48px;\n  border-radius: 10px;\n  border: 1px solid #e5e7eb2b;\n  background: rgb(255 255 255 / 4%);\n}\n\nbody.light_theme .withdraw_sec_overlay input[type=\"text\"],\nbody.light_theme .withdraw_sec_overlay input[type=\"email\"],\nbody.light_theme .withdraw_sec_overlay input[type=\"tel\"],\nbody.light_theme .withdraw_sec_overlay input[type=\"search\"],\nbody.light_theme .withdraw_sec_overlay input[type=\"password\"] {\n  border: 1px solid #e5e7eb;\n  background: rgb(255 255 255 / 20%);\n}\n\n.withdraw_sec_overlay input[type=\"text\"]:focus,\n.withdraw_sec_overlay input[type=\"email\"]:focus,\n.withdraw_sec_overlay input[type=\"tel\"]:focus,\n.withdraw_sec_overlay input[type=\"search\"]:focus,\n.withdraw_sec_overlay input[type=\"password\"]:focus {\n  border-color: #ac8a5000;\n  box-shadow: 0 0 0 2px rgba(142, 114, 67, 0.15);\n  outline: none;\n}\n\n.withdraw_sec_modal,\n.withdraw_sec_confirm_modal,\n.withdraw_sec_req_modal {\n  width: 550px;\n  max-width: 92vw;\n  border-radius: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 22px 36px 24px;\n  position: relative;\n  text-align: left;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.50);\n  background: #181a2087;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n}\n\nbody.light_theme .withdraw_sec_modal,\nbody.light_theme .withdraw_sec_confirm_modal,\nbody.light_theme .withdraw_sec_req_modal {\n  border: 1px solid #e8e8e8;\n  box-shadow: 0 20px 60px rgb(0 0 0 / 60%);\n  background: rgb(255 255 255 / 20%);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n}\n\n.withdraw_sec_title {\n  font-size: 24px;\n  letter-spacing: -0.45px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 4px 0 8px;\n  padding-right: 44px;\n}\n\nbody.light_theme .withdraw_sec_title {\n  color: #111827;\n}\n\n.withdraw_sec_subtitle {\n  color: #84888C;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.5;\n  margin-bottom: 18px;\n}\n\nbody.light_theme .withdraw_sec_subtitle {\n  color: #6A7282;\n}\n\n.withdraw_sec_list {\n  display: flex;\n  flex-direction: column;\n  gap: 0px;\n  margin-bottom: 18px;\n}\n\n.withdraw_sec_item {\n  width: 100%;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  padding: 10px 14px;\n  display: flex;\n  min-height: 62px;\n  justify-content: space-between;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.05);\n  letter-spacing: -0.45px;\n}\n\nbody.light_theme .withdraw_sec_item {\n  border: 1px solid #E4E4E4;\n  background: #ffffff00;\n}\n\n.withdraw_sec_item--selectable {\n  cursor: pointer;\n  text-align: left;\n  padding: 0;\n}\n\n.withdraw_sec_item--selectable:hover {\n  border-color: rgba(255, 255, 255, 0.3);\n}\n\nbody.light_theme .withdraw_sec_item--selectable:hover {\n  border-color: #c4b48a;\n}\n\n.withdraw_sec_item--selectable.is-selected {\n  /* border-color: #a89058; */\n  /* box-shadow: 0 0 0 1px rgba(168, 144, 88, 0.25); */\n}\n\n.withdraw_sec_item--readonly {\n  cursor: default;\n  pointer-events: none;\n}\n\n.withdraw_addr_verify_identity .withdraw_sec_confirm_hero {\n  margin-top: 0;\n}\n\n.withdraw_addr_verify_identity .withdraw_sec_confirm_hero img {\n  width: 180px;\n  max-width: 100%;\n}\n\n.withdraw_addr_verify_identity .withdraw_sec_title {\n  padding-right: 0;\n}\n\n.withdraw_addr_verify_chev {\n  color: #9ca3af;\n  font-size: 22px;\n  font-weight: 300;\n  line-height: 1;\n  flex-shrink: 0;\n  margin-left: 8px;\n}\n\n.withdraw_sec_item_left {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.withdraw_sec_icon {\n  width: 21px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #ffffff;\n  filter: invert(1);\n}\n\nbody.light_theme .withdraw_sec_icon img {\n  filter: invert(0);\n}\n\nbody.light_theme .withdraw_sec_icon {\n  color: #111827;\n}\n\nspan.withdraw_sec_item_txt {\n  text-align: left;\n}\n\n.withdraw_sec_item_title {\n  display: block;\n  font-size: 16px;\n  font-weight: 500;\n  color: #ffffff;\n}\n\nbody.light_theme .withdraw_sec_item_title {\n  color: #111827;\n}\n\n.withdraw_sec_item_sub {\n  display: block;\n  font-size: 12px;\n  color: #9ca3af;\n  margin-top: 0px;\n}\n\nbody.light_theme .withdraw_sec_item_sub {\n  color: #6b7280;\n}\n\n.withdraw_sec_check {\n  width: 18px;\n  height: 18px;\n  border-radius: 4px;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  display: inline-block;\n  position: relative;\n  overflow: hidden;\n}\n\nbody.light_theme .withdraw_sec_check {\n  border: 2px solid #E5E7EB;\n}\n\n.withdraw_sec_check.is-checked {\n  background: transparent;\n  border-color: transparent;\n}\n\n.withdraw_sec_check.is-checked::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  margin: auto;\n  background: #d1aa67;\n  background-size: 10px;\n  background-image: url(\"../../../assets/security/checkarrow.svg\");\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.withdraw_sec_primary {\n  width: 100%;\n  border-radius: 999px;\n  border: none;\n  background: #2b2f36;\n  color: #fff;\n  font-weight: 500;\n  padding: 14px 16px;\n}\n\n.withdraw_sec_primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.withdraw_sec_help {\n  margin-top: 14px;\n  width: 100%;\n  background: transparent;\n  border: none;\n  font-size: 14px;\n  color: #84888C;\n  text-decoration: underline;\n  font-weight: 500;\n}\n\nbody.light_theme .withdraw_sec_help {\n  color: #111827;\n}\n\n.withdraw_sec_confirm_hero {\n  display: flex;\n  justify-content: center;\n  margin: 10px 0 20px;\n}\n\n.withdraw_sec_confirm_hero img {\n  /* width: 220px; */\n  height: 104px;\n  opacity: 1;\n}\n\n.withdraw_sec_confirm_title {\n  max-width: 80%;\n  text-align: center;\n  font-size: 24px;\n  margin: 0 auto;\n  font-weight: 600;\n  color: #eaeaea;\n  letter-spacing: -0.45px;\n  line-height: 1.2;\n  margin-bottom: 14px;\n  padding: 0 10px;\n}\n\nbody.light_theme .withdraw_sec_confirm_title {\n  color: #111827;\n}\n\n.withdraw_sec_confirm_ack {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  border: 1px solid #e4e4e41a;\n  border-radius: 10px;\n  padding: 22px 15px;\n  font-weight: 400;\n  background: #ffffff0a;\n  font-size: 14px;\n  margin: 24px 0px;\n  line-height: 1.45;\n  color: #d0d0d0;\n}\n\nbody.light_theme .withdraw_sec_confirm_ack {\n  background: #fff;\n  border: 1px solid #E4E4E4;\n  color: #374151;\n}\n\n.withdraw_sec_confirm_ack_input {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.withdraw_sec_confirm_ack_box--icon {\n  width: 18px;\n  height: 18px;\n  border-radius: 4px;\n  border: 2px solid #E5E7EB;\n  background: rgb(255 255 255 / 20%);\n  flex: 0 0 auto;\n  position: relative;\n  margin-top: 2px;\n}\n\n.withdraw_sec_confirm_ack_box--icon.is-checked {\n  background: #111827;\n  border-color: #111827;\n}\n\n.withdraw_sec_confirm_ack_box--icon.is-checked::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  margin: auto;\n  width: 12px;\n  height: 12px;\n  background-image: url(\"../../../assets/security/checkarrow.svg\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n\n.withdraw_sec_confirm_actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.withdraw_sec_btnGhost,\n.withdraw_sec_btnPrimary {\n  flex: 1;\n  border-radius: 999px;\n  padding: 12px 14px;\n  font-weight: 400;\n}\n\n.withdraw_sec_btnGhost {\n  border: none;\n  background: #DDDDDD;\n  color: #111827;\n  max-width: 160px;\n}\n\n.withdraw_sec_btnPrimary {\n  border: none;\n  background: #2b2f36;\n  color: #fff;\n}\n\n.withdraw_sec_btnPrimary:disabled {\n  opacity: 0.5;\n}\n\n.withdraw_sec_req_topbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.withdraw_sec_req_title {\n  font-size: 24px;\n  letter-spacing: -0.45px;\n  font-weight: 600;\n  color: #e9e9e9;\n  margin: 0 0 8px;\n}\n\nbody.light_theme .withdraw_sec_req_title {\n  color: #111827;\n}\n\n.withdraw_sec_req_subtitle {\n  font-size: 14px;\n  color: #6b7280;\n  margin-bottom: 10px;\n  font-weight: 500;\n}\n\n.withdraw_sec_req_progress {\n  font-size: 24px;\n  font-weight: 600;\n  color: #AC8A50;\n  margin: 18px 0px;\n}\n\n.withdraw_sec_req_list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.withdraw_sec_req_item {\n  width: 100%;\n  text-align: left;\n  border: 1px solid #e5e7eb14;\n  border-radius: 10px;\n  padding: 10px 14px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #ffffff0d;\n  min-height: 62px;\n  letter-spacing: -0.45px;\n}\n\nbody.light_theme .withdraw_sec_req_item {\n  border: 1px solid #e5e7eb;\n  background: #fff;\n}\n\n.withdraw_sec_req_left {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  color: #f1f1f1;\n}\n\n.withdraw_sec_req_left img {\n  filter: invert(1);\n}\n\nbody.light_theme .withdraw_sec_req_left img {\n  filter: invert(0);\n}\n\nbody.light_theme .withdraw_sec_req_left {\n  color: #111827;\n}\n\n.withdraw_sec_req_left i {\n  font-size: 18px;\n}\n\n.withdraw_sec_req_name {\n  display: block;\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.withdraw_sec_req_desc {\n  display: block;\n  font-size: 12px;\n  color: #6b7280;\n  margin-top: 2px;\n}\n\n.withdraw_sec_req_right {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  color: #fff;\n}\n\nbody.light_theme .withdraw_sec_req_right {\n  color: #0f0f0f;\n}\n\n.withdraw_sec_req_arrow {\n  font-size: 22px;\n  color: #9ca3af;\n}\n\n.withdraw_sec_req_check {\n  font-size: 18px;\n  color: #16a34a;\n}\n\n.withdraw_sec_req_link {\n  width: 100%;\n  background: transparent;\n  border: none;\n  color: #b88b2c;\n  font-weight: 600;\n  text-align: center;\n  padding: 10px 0 0;\n}\n\n/* Facial verification screens */\n.withdraw_facial_modal {\n  width: 540px;\n  max-width: 92vw;\n  border-radius: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 24px 26px 24px;\n  position: relative;\n  text-align: left;\n  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.50);\n  background: #181a2087;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n}\n\nbody.light_theme .withdraw_facial_modal {\n  border: 1px solid #e8e8e8;\n  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.80);\n  background: rgb(255 255 255 / 20%);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n}\n\n.withdraw_sec_req_topbar button.withdraw_choose_back {\n  padding: 0px;\n}\n\n.withdraw_facial_title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0 0 8px;\n}\n\nbody.light_theme .withdraw_facial_title {\n  color: #111827;\n}\n\n.withdraw_facial_subtitle {\n  font-size: 14px;\n  color: #dddddd;\n  line-height: 1.5;\n  margin-bottom: 20px;\n}\n\nbody.light_theme .withdraw_facial_subtitle {\n  color: #6b7280;\n}\n\n.withdraw_facial_list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin: 40px 0 14px;\n}\n\n.withdraw_facial_item {\n  width: 100%;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  padding: 10px 14px;\n  display: flex;\n  letter-spacing: -0.45px;\n  text-align: left;\n  justify-content: space-between;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.05);\n  min-height: 62px;\n}\n\nbody.light_theme .withdraw_facial_item {\n  border: 1px solid #e5e7eb;\n  background: #ffffff40;\n}\n\n.withdraw_facial_left {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  color: #ffffff;\n}\n\nbody.light_theme .withdraw_facial_left {\n  color: #111827;\n}\n\n.withdraw_facial_left i {\n  font-size: 18px;\n  margin-top: 2px;\n}\n\n.withdraw_facial_name {\n  display: block;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.withdraw_facial_desc {\n  display: block;\n  font-size: 12px;\n  color: #84888C;\n  margin-top: 2px;\n}\n\nbody.light_theme .withdraw_facial_desc {\n  color: #6b7280;\n}\n\n.withdraw_facial_noteBox {\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.05);\n  font-size: 14px;\n  padding: 18px 22px;\n  margin-bottom: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\nbody.light_theme .withdraw_facial_noteBox {\n  border: 1px solid #e5e7eb;\n  background: #ffffff40;\n}\n\n.withdraw_facial_noteLine {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.withdraw_facial_noteLine i {\n  font-size: 7px;\n}\n\n.withdraw_facial_noteBox ul {\n  margin: 0;\n  padding-left: 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  color: #ffffff;\n  font-size: 13px;\n}\n\nbody.light_theme .withdraw_facial_noteBox ul {\n  color: #374151;\n}\n\n.withdraw_facial_keyTitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: #e8e8e8;\n  margin: 8px 0 14px;\n  text-align: left;\n  letter-spacing: -0.45px;\n}\n\nbody.light_theme .withdraw_facial_keyTitle {\n  color: #111827;\n}\n\n.withdraw_facial_grid4 {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px 24px;\n  margin: 46px 0 45px;\n  justify-items: center;\n  text-align: center;\n}\n\n.withdraw_facial_gridItem {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.completed_header .withdraw_facial_bigKey {\n  width: 100%;\n}\n\n\n.withdraw_facial_badge {\n  width: 84px;\n  height: auto;\n  border-radius: 999px;\n  /* border: 2px solid #e5e7eb; */\n  /* background: radial-gradient(circle at 50% 50%, #d1d5db, #f3f4f6); */\n  position: relative;\n}\n\n.withdraw_facial_badge::after {\n  content: \"\";\n  position: absolute;\n  width: 46px;\n  height: 2px;\n  background: #9ca3af;\n  transform: rotate(-35deg);\n  top: 31px;\n  left: 9px;\n  opacity: 0.7;\n}\n\n.withdraw_facial_gridTxt {\n  font-size: 12px;\n  color: #6b7280;\n  line-height: 1.25;\n  max-width: 200px;\n}\n\n.withdraw_facial_loadingTitle {\n  font-size: 18px;\n  font-weight: 800;\n  color: #111827;\n  text-align: center;\n  margin-top: 10px;\n}\n\n.withdraw_facial_ring {\n  width: 220px;\n  height: 220px;\n  border-radius: 999px;\n  margin: 32px auto 24px;\n  position: relative;\n}\n\n/* .withdraw_facial_ring::before,\n.withdraw_facial_ring::after {\n  content: \"\";\n  position: absolute;\n  width: 28px;\n  height: 10px;\n  border-radius: 999px;\n  background: #d1aa67;\n  top: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.withdraw_facial_ring::after {\n  top: auto;\n  bottom: -10px;\n} */\n\n.withdraw_facial_ringInner {\n  width: 100%;\n  height: 100%;\n  border-radius: 999px;\n}\n\n.withdraw_facial_bigKey {\n  font-size: 32px;\n  width: 70%;\n  font-weight: 600;\n  letter-spacing: -0.03em;\n  color: #ececec;\n  text-align: left;\n  line-height: 1.05;\n  margin: 8px 0 6px;\n}\n\nbody.light_theme .withdraw_facial_bigKey {\n  color: #111827;\n}\n\n.withdraw_confirm_overlay .withdraw_choose_back {\n  padding: 0px;\n}\n\n.withdraw_facial_camActions {\n  display: flex;\n  gap: 12px;\n  margin-top: 14px;\n}\n\n.withdraw_facial_result {\n  text-align: center;\n}\n\n.withdraw_facial_timeoutHero {\n  width: 160px;\n  height: 160px;\n  border-radius: 999px;\n  margin: 10px auto 14px;\n  background: #fff;\n  border: none;\n  box-shadow: 0px 0px 20px #0000001c;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.withdraw_facial_timeoutText {\n  font-size: 14px;\n  color: #6b7280;\n  line-height: 1.5;\n  margin: 10px 0 16px;\n}\n\n.withdraw_facial_submitHero,\n.withdraw_facial_successHero {\n  width: 160px;\n  height: 160px;\n  border-radius: 999px;\n  margin: 10px auto 14px;\n  background: #fff;\n  border: none;\n  box-shadow: 0px 0px 20px #0000001c;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.withdraw_facial_successHero {\n  background: none;\n  box-shadow: none;\n  width: auto;\n  height: auto;\n  margin-bottom: 0px;\n}\n\n.withdraw_facial_submitTitle {\n  font-size: 24px;\n  font-weight: 600;\n  color: #f5f5f5;\n  margin: 26px 0 10px;\n}\n\nbody.light_theme .withdraw_facial_submitTitle {\n  color: #111827;\n}\n\n\n@media (max-width: 767px) {\n  .withdraw_whitelist_awaiting_notice {\n    display: none;\n  }\n\n  .withdraw_passkey_subtext {\n    font-size: 14px;\n  }\n\n  .withdraw_sec_modal,\n  .withdraw_sec_confirm_modal,\n  .withdraw_sec_req_modal {\n    max-width: 100%;\n    border-radius: 16px 16px 0px 0px;\n    padding: 20px 20px 32px;\n  }\n\n  .withdraw_sec_title {\n    font-size: 20px;\n  }\n\n  .withdraw_facial_name {\n    font-size: 15px;\n  }\n\n  .withdraw_sec_item_title {\n    font-size: 14px;\n  }\n\n  .withdraw_hist_detail_modal {\n    width: 100%;\n    max-width: 100%;\n    border-radius: 16px 16px 0px 0px;\n    padding: 20px;\n  }\n\n  .withdraw_sec_primary {\n    padding: 12px 16px;\n    font-size: 14px;\n  }\n\n  .withdraw_sec_confirm_hero {\n    width: 150px;\n    margin: 18px auto;\n  }\n\n  .withdraw_sec_confirm_title {\n    max-width: 90%;\n    font-size: 20px;\n  }\n\n  .withdraw_facial_modal {\n    max-width: 100%;\n    border-radius: 16px 16px 0px 0px;\n    height: 80vh;\n    display: flex;\n    overflow: scroll;\n    padding: 20px 20px 24px;\n    flex-direction: column;\n  }\n\n  .withdraw_confirm_text {\n    font-size: 14px;\n  }\n\n  .withdraw_facial_title {\n    width: 90%;\n    font-size: 20px;\n  }\n\n  .withdraw_facial_list {\n    margin: 15px 0 12px;\n  }\n\n  .withdraw_facial_grid4 {\n    margin: 24px 0 32px;\n  }\n\n\n  .withdraw_facial_bigKey {\n    font-size: 20px;\n    width: 100%;\n  }\n\n  .withdraw_facial_ring {\n    width: 160px;\n    height: auto;\n  }\n\n  .withdraw_facial_ringInner {\n    width: 150px;\n    margin: 0 auto;\n    height: auto;\n  }\n\n  .d-flex.justify-space-between.gap-2.completed_header img {\n    width: 100px;\n  }\n\n  .withdraw_facial_submitHero,\n  .withdraw_facial_successHero {\n    width: 140px;\n    height: 140px;\n  }\n\n  .withdraw_facial_submitTitle {\n    font-size: 20px;\n  }\n\n}\n\n/* Address book (wallet `/api/v1/wallet/address-book`) */\n.withdraw_ab_addr_hint,\n.withdraw_ab_history_hint {\n  font-size: 13px;\n  color: #a5a7aa;\n  line-height: 1.45;\n}\n\nbody.light_theme .withdraw_ab_addr_hint,\nbody.light_theme .withdraw_ab_history_hint {\n  color: #5d6470;\n}\n\n.withdraw_ab_saved_list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n  margin-top: 8px;\n}\n\n.withdraw_ab_saved_row {\n  border: 1px solid rgba(148, 163, 184, 0.35);\n  border-radius: 10px;\n  padding: 10px 12px;\n  cursor: pointer;\n  text-align: left;\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.withdraw_ab_saved_row:focus {\n  outline: 2px solid rgba(172, 138, 80, 0.55);\n  outline-offset: 2px;\n}\n\n.withdraw_ab_saved_row--pending {\n  cursor: not-allowed;\n  opacity: 0.92;\n}\n\n.withdraw_ab_status {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  padding: 2px 8px;\n  border-radius: 999px;\n  border: 1px solid rgba(148, 163, 184, 0.45);\n  color: #475569;\n  background: rgba(248, 250, 252, 0.9);\n}\n\n.withdraw_ab_status--success {\n  /* color: #0f766e;\n  border-color: rgba(45, 212, 191, 0.45);\n  background: rgba(240, 253, 250, 0.95); */\n}\n\n.withdraw_ab_status--pending {\n  color: #b45309;\n  /* border-color: rgba(251, 191, 36, 0.5);\n  background: rgba(255, 251, 235, 0.95); */\n}\n\n.withdraw_ab_status--danger {\n  color: #b91c1c;\n  /* border-color: rgba(248, 113, 113, 0.45);\n  background: rgba(254, 242, 242, 0.95); */\n}\n\n.withdraw_ab_status--info {\n  color: green;\n  /* border-color: rgba(96, 165, 250, 0.45);\n  background: rgba(239, 246, 255, 0.95); */\n}\n\n.withdraw_ab_status--neutral {\n  color: #64748b;\n}\n\n.withdraw_ab_hist_list {\n  max-height: min(52vh, 420px);\n  overflow-y: auto;\n  padding-right: 2px;\n}\n\n.withdraw_ab_hist_meta {\n  margin-top: 6px;\n  font-size: 11px;\n  color: #64748b;\n  line-height: 1.35;\n}\n\n.withdraw_ab_saved_row_top {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.withdraw_ab_saved_label {\n  font-weight: 600;\n  font-size: 14px;\n  color: #ffffff;\n  flex: 1;\n  min-width: 0;\n}\n\nbody.light_theme .withdraw_ab_saved_label {\n  color: #1e2329;\n}\n\n.withdraw_ab_saved_remove {\n  border: none;\n  background: transparent;\n  color: #94a3b8;\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0 4px;\n}\n\n.withdraw_ab_saved_remove:hover {\n  color: #515763;\n}\n\n.withdraw_ab_saved_addr_mono {\n  /* font-family: ui-monospace, monospace; */\n  font-size: 12px;\n  margin-top: 6px;\n  word-break: break-all;\n  font-weight: 500;\n}\n\n.withdraw_ab_resume_mm_btn {\n  display: inline-block;\n  margin-top: 10px;\n  padding: 6px 12px;\n  font-size: 13px;\n  font-weight: 600;\n  /* color: #b45309; */\n  /* background: #fffbeb; */\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  /* width: 100%; */\n  text-align: center;\n}\n\n.withdraw_ab_resume_mm_btn:hover {\n  /* background: #fef3c7; */\n}\n\n.withdraw_verify_combined {\n  max-height: min(90vh, 640px);\n  overflow-y: auto;\n}\n\n.withdraw_verify_combined_spaced {\n  margin-top: 14px;\n}\n\n/* KYC gate: column-scoped overlay only.\n   Do not add .pm-restrictOverlay — App.js uses that selector for body.agce-modal-open, which sets\n   header.sticky-top { pointer-events: none } and blocks the auth header. */\n.dashboard_right.dashboard_right--kyc-gate {\n  position: relative;\n}\n\n.dashboard_right.dashboard_right--kyc-gate .withdraw-kyc-gate-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 999999;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbody.light_theme .dashboard_right.dashboard_right--kyc-gate .withdraw-kyc-gate-overlay {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n@media (max-width: 767px) {\n\n  /*\n   * Fixed = viewport (see comment on desktop block). z-index must stay:\n   * - below `.profile-sidebar-shell.leftside_menu` drawer (10080) so the open rail appears above this modal\n   * - below `.mobile_view.asset-sidebar-toggle` (999999)\n   * - above normal page / sticky header (~1020–1040)\n   */\n  .dashboard_right.dashboard_right--kyc-gate .withdraw-kyc-gate-overlay {\n    position: fixed;\n    inset: 0;\n    width: 100vw;\n    max-width: 100vw;\n    min-height: 100vh;\n    min-height: 100dvh;\n    z-index: 10050;\n    align-items: end;\n    justify-content: center;\n    padding: 0px;\n    box-sizing: border-box;\n  }\n\n  .dashboard_right.dashboard_right--kyc-gate .withdraw-kyc-gate-overlay .pm-restrictModal {\n    max-height: min(90dvh, calc(100dvh - 24px));\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n    width: 100%;\n    max-width: 100%;\n    margin: 0;\n  }\n}\n\n/* KYC gate on withdraw — .pm-restrictModal* from changeLoginPassword.css; tweak primary CTA */\n.withdraw-kyc-gate-modal--loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  min-width: min(320px, 92vw);\n  padding: 28px 24px;\n}\n\n.withdraw-kyc-gate-modal--loading::before {\n  content: \"\";\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 3px solid rgba(17, 24, 39, 0.12);\n  border-top-color: #2d2e32;\n  animation: withdraw-kyc-gate-spin 0.75s linear infinite;\n  flex-shrink: 0;\n}\n\n@keyframes withdraw-kyc-gate-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.withdraw-kyc-gate-loading__text {\n  font-size: 15px;\n  line-height: 1.5;\n  font-weight: 600;\n  color: #fff;\n  text-align: center;\n}\n\nbody.light_theme .withdraw-kyc-gate-loading__text {\n  color: #111827;\n}\n\n.withdraw-kyc-gate-modal--single .pm-restrictModal__actions {\n  justify-content: center;\n}\n\n.withdraw-kyc-gate-modal {\n  background-color: rgb(24 26 32 / 30%) !important;\n}\n\nbody.light_theme .withdraw-kyc-gate-modal {\n  background-color: rgb(255 255 255 / 30%) !important;\n}\n\n.withdraw-kyc-modal__cta.pm-restrictModal__confirm {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  box-sizing: border-box;\n}\n\n.withdraw-kyc-modal__cta--solo.pm-restrictModal__confirm {\n  flex: 0 1 auto;\n  min-width: min(280px, 100%);\n  max-width: 100%;\n}\n\n.withdraw-kyc-modal__link {\n  color: #fff;\n  font-weight: 600;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\nbody.light_theme .withdraw-kyc-modal__link {\n  color: #111827;\n}\n\n.withdraw-kyc-modal__link:hover {\n  color: #2d2e32;\n}\n\n/* —— Withdraw page: recent withdrawal history uses same table/card chrome as Deposit history (see depositPage.css) —— */\n.depositcrypto_lft .deposit_history_section .withdraw_recent_tabs {\n  margin-bottom: 12px;\n}\n\n.depositcrypto_lft .deposit_history_top .withdraw_history_top_actions {\n  display: flex;\n  align-items: center;\n  gap: 14px 20px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.depositcrypto_lft .deposit_history_table_wrap {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  min-width: 0;\n}\n\n.depositcrypto_lft .deposit_history_body_wrap {\n  min-width: 0;\n  background: #fff;\n}\n\n.depositcrypto_lft .deposit_history_head_wrap {\n  overflow: visible;\n}\n\n.depositcrypto_lft .deposit_history_head {\n  display: grid;\n  grid-template-columns: 1.05fr 1.25fr 0.9fr 0.95fr 1.55fr 1.55fr 0.75fr;\n  gap: 8px;\n  align-items: center;\n}\n\n.depositcrypto_lft .deposit_history_head,\n.depositcrypto_lft .deposit_history_row {\n  min-width: 1240px;\n}\n\n.depositcrypto_lft .deposit_history_head_cell {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.depositcrypto_lft .deposit_history_row {\n  display: grid;\n  grid-template-columns: 1.05fr 1.25fr 0.9fr 0.95fr 1.55fr 1.55fr 0.75fr;\n  gap: 8px;\n  padding: 12px 0;\n  border-top: 1px solid #eaecf0;\n  font-size: 13px;\n  font-weight: 500;\n  color: #101828;\n  line-height: 1.3;\n  align-items: start;\n  box-sizing: border-box;\n}\n\n.depositcrypto_lft .deposit_history_row_cell {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n.depositcrypto_lft .deposit_history_row_cell--action {\n  text-transform: capitalize;\n}\n\n.depositcrypto_lft .deposit_history_trunc {\n  display: inline-block;\n  vertical-align: middle;\n  max-width: calc(100% - 72px);\n}\n\n.depositcrypto_lft .deposit_history_copy_btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 8px;\n  width: 24px;\n  height: 24px;\n  border-radius: 8px;\n  border: 1px solid rgba(148, 163, 184, 0.45);\n  background: #f8fafc;\n  color: #334155;\n  cursor: pointer;\n  transition:\n    background 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease,\n    transform 0.05s ease;\n  padding: 0;\n  line-height: 1;\n}\n\n.depositcrypto_lft .deposit_history_copy_btn:hover {\n  background: #eef2ff;\n  border-color: rgba(99, 102, 241, 0.55);\n  color: #3730a3;\n}\n\n.depositcrypto_lft .deposit_history_copy_btn:active {\n  transform: translateY(0.5px);\n}\n\n.depositcrypto_lft .deposit_history_copy_btn:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.25);\n}\n\n.depositcrypto_lft .deposit_history_copy_btn.deposit_history_explorer_link {\n  text-decoration: none;\n}\n\n.depositcrypto_lft .deposit_history_copy_btn .withdraw_hist_icon_svg {\n  width: 14px;\n  height: 14px;\n}\n\n.depositcrypto_lft .deposit_history_action_badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n  border: 1px solid transparent;\n  white-space: nowrap;\n  line-height: 1;\n}\n\n.depositcrypto_lft .deposit_history_action_badge.is-success {\n  background: #ecfdf3;\n  border-color: #a7f3d0;\n  color: #067647;\n}\n\n.depositcrypto_lft .deposit_history_action_badge.is-pending {\n  background: #fffbeb;\n  border-color: #fde68a;\n  color: #92400e;\n}\n\n.depositcrypto_lft .deposit_history_action_badge.is-danger {\n  background: #fef2f2;\n  border-color: #fecaca;\n  color: #b42318;\n}\n\n.depositcrypto_lft .deposit_history_action_badge.is-info {\n  background: #eff6ff;\n  border-color: #bfdbfe;\n  color: #1d4ed8;\n}\n\n.depositcrypto_lft .deposit_history_action_badge.is-neutral {\n  background: #f1f5f9;\n  border-color: #e2e8f0;\n  color: #334155;\n}\n\nbody:not(.light_theme) .depositcrypto_lft .deposit_history_copy_btn {\n  background: #1f2937;\n  border-color: rgba(148, 163, 184, 0.35);\n  color: #e2e8f0;\n}\n\nbody:not(.light_theme) .depositcrypto_lft .deposit_history_copy_btn:hover {\n  background: rgba(59, 130, 246, 0.18);\n  border-color: rgba(59, 130, 246, 0.45);\n  color: #bfdbfe;\n}\n\nbody:not(.light_theme) .depositcrypto_lft .deposit_history_action_badge.is-neutral {\n  background: rgba(148, 163, 184, 0.12);\n  border-color: rgba(148, 163, 184, 0.22);\n  color: #e2e8f0;\n}\n\n.depositcrypto_lft .deposit_history_mobile {\n  display: none;\n}\n\n.deposit_hist_mobile_top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-bottom: 6px;\n}\n\n.deposit_hist_mobile_date {\n  font-size: 13px;\n  font-weight: 600;\n  color: #eaecef;\n}\n\nbody.light_theme .deposit_hist_mobile_date {\n  color: #101828;\n}\n\n.deposit_hist_mobile_row--actions .value {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 8px;\n  max-width: 72%;\n  text-align: right;\n}\n\n@media (max-width: 991.98px) {\n  .depositcrypto_lft .deposit_history_desktop {\n    display: none !important;\n  }\n\n  .depositcrypto_lft .deposit_history_mobile {\n    display: block !important;\n  }\n\n  .depositcrypto_lft .deposit_history_table_wrap {\n    overflow-x: visible;\n  }\n}\n\n.withdraw-save-country__control {\n  background-color: #f5f6f715 !important;\n  border: none !important;\n}\n\nbody.light_theme .withdraw-save-country__control {\n  background-color: #f5f6f7 !important;\n}\n\n.withdraw-save-country__single-value {\n  color: #f3f3f3 !important;\n}\n\nbody.light_theme .withdraw-save-country__single-value {\n  color: #0f172a !important;\n}\n\n.withdraw-save-country__menu {\n  background-color: #2f3031 !important;\n  border: 1px solid #e4e4e40d !important;\n}\n\nbody.light_theme .withdraw-save-country__menu {\n  background-color: #fff !important;\n  border: 1px solid #e4e4e4 !important;\n}\n\n.withdraw-save-country__option {\n  background-color: transparent !important;\n  color: #dedede !important;\n}\n\n.withdraw-save-country__option--is-focused {\n  background-color: #f4f5f70a !important;\n}\n\nbody.light_theme .withdraw-save-country__option {\n  color: #1a1d21 !important;\n}\n\nbody.light_theme .withdraw-save-country__option--is-focused {\n  background-color: #F0F2F4 !important;\n}\n\n.withdraw-save-country__option--is-selected {\n  background-color: #f1f5f90a !important;\n  color: #fff !important;\n}\n\nbody.light_theme .withdraw-save-country__option--is-selected {\n  background-color: #f1f5f9 !important;\n  color: #0f172a !important;\n}\n\n/* --- Dark Theme Fixes for Withdraw History Detail Modal --- */\n\n.withdraw_hist_detail_modal {\n  background: rgba(30, 41, 59, 0.45) !important;\n  border-color: rgba(255, 255, 255, 0.08) !important;\n  color: #e2e8f0;\n}\n\nbody.light_theme .withdraw_hist_detail_modal {\n  background: rgb(255 255 255 / 40%) !important;\n  border-color: #e8e8e8 !important;\n  color: #0f172a;\n}\n\n.withdraw_hist_detail_title {\n  color: #f1f5f9;\n}\n\nbody.light_theme .withdraw_hist_detail_title {\n  color: #0f172a;\n}\n\n.withdraw_hist_rows {\n  border-top-color: rgba(255, 255, 255, 0.08);\n}\n\nbody.light_theme .withdraw_hist_rows {\n  border-top-color: #eceff3;\n}\n\n.withdraw_hist_row_label {\n  color: #94a3b8;\n}\n\nbody.light_theme .withdraw_hist_row_label {\n  color: #707a8a;\n}\n\n.withdraw_hist_row_value {\n  color: #e2e8f0;\n}\n\nbody.light_theme .withdraw_hist_row_value {\n  color: #303236;\n}\n\n.withdraw_hist_step_title {\n  color: #f8fafc;\n}\n\nbody.light_theme .withdraw_hist_step_title {\n  color: #1e293b;\n}\n\n.withdraw_hist_step_time,\n.withdraw_hist_step_note,\n.withdraw_hist_step_sub {\n  color: #94a3b8;\n}\n\nbody.light_theme .withdraw_hist_step_time,\nbody.light_theme .withdraw_hist_step_note,\nbody.light_theme .withdraw_hist_step_sub {\n  color: #64748b;\n}\n\n.withdraw_hist_icon_btn {\n  background: rgba(255, 255, 255, 0.1);\n  color: #cbd5e1;\n}\n\nbody.light_theme .withdraw_hist_icon_btn {\n  background: #F3F4F6;\n  color: #6c6c6c;\n}\n\nbody.dark_theme .dark_theme_white_icons_popup .withdraw_sec_req_left img {\n  filter: brightness(0) invert(1);\n}\n\nbody:not(.light_theme) .dark_theme_white_icons_popup .withdraw_sec_req_left img {\n  filter: brightness(0) invert(1);\n}\n\n\n@media screen and (max-width:580px) {\n\n  .withdraw_hist_row {\n    font-size: 12px;\n  }\n\n  .withdraw_hist_rows {\n    gap: 15px;\n  }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
